export const dashboard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.44085 19.8937V17.1294C9.44474 16.424 10.0169 15.8538 10.7223 15.8529H13.3201C14.0285 15.849 14.6064 16.4211 14.6093 17.1294V19.8985C14.6103 20.4979 15.09 20.9873 15.6893 21H17.4213C19.1386 21.0097 20.5397 19.6251 20.5494 17.9078V17.9059V10.0539C20.5377 9.38156 20.2186 8.75106 19.6834 8.34435L13.7619 3.61663C12.7218 2.79446 11.2525 2.79446 10.2124 3.61663L4.31517 8.34825C3.77711 8.75495 3.457 9.38739 3.44922 10.0626V17.9049C3.45798 19.6222 4.85713 21.0087 6.57541 21H8.30927C8.92322 21.0029 9.42334 20.5076 9.42626 19.8937"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const whiteTickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 text-blue-500"
    fill="#fff"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
      clipRule="evenodd"
    />
  </svg>
);
export const BackArrowBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M25.6667 12.8333H5.14974L11.3249 6.65818C11.4363 6.55056 11.5252 6.42182 11.5864 6.27948C11.6475 6.13715 11.6797 5.98406 11.681 5.82915C11.6824 5.67424 11.6529 5.52061 11.5942 5.37723C11.5355 5.23385 11.4489 5.10359 11.3394 4.99405C11.2298 4.88451 11.0996 4.79788 10.9562 4.73922C10.8128 4.68056 10.6592 4.65104 10.5043 4.65239C10.3494 4.65373 10.1963 4.68592 10.0539 4.74706C9.9116 4.80821 9.78287 4.89708 9.67524 5.00851L1.50858 13.1752C1.28986 13.394 1.16699 13.6907 1.16699 14C1.16699 14.3094 1.28986 14.6061 1.50858 14.8248L9.67524 22.9915C9.89528 23.204 10.19 23.3216 10.4959 23.319C10.8018 23.3163 11.0944 23.1936 11.3107 22.9773C11.527 22.761 11.6497 22.4684 11.6524 22.1625C11.655 21.8566 11.5374 21.5619 11.3249 21.3418L5.14974 15.1667H25.6667C25.9762 15.1667 26.2729 15.0438 26.4917 14.825C26.7105 14.6062 26.8334 14.3094 26.8334 14C26.8334 13.6906 26.7105 13.3938 26.4917 13.1751C26.2729 12.9563 25.9762 12.8333 25.6667 12.8333Z"
      fill="#4271D5"
    />
  </svg>
);
export const LogOutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
  >
    <path
      d="M40.0008 53.7516C43.3528 53.7516 46.0784 56.4716 46.0728 59.8292C46.0728 63.1836 43.3528 65.8964 40.0008 65.8964C36.6472 65.8964 33.9288 63.182 33.9288 59.8292C33.9288 56.4764 36.6472 53.7572 40.0008 53.7516ZM37.4408 14.1012H42.5656C44.9704 14.1012 46.9056 16.334 46.9056 19.1092L45.384 43.7076C45.384 46.482 43.4424 48.7156 40.0008 48.7156C36.5592 48.7156 34.6232 46.4828 34.6232 43.7076L33.1 19.1092C33.1024 16.3356 35.0384 14.1012 37.4424 14.1012H37.4408ZM40.0008 2.00195C19.0168 2.00195 2 19.0124 2 40.0028C2 60.9868 19.0144 77.9972 40.0008 77.9972C60.9848 78.0036 78 60.9868 78 40.0028C78 19.0124 60.9856 2.00195 40.0008 2.00195Z"
      fill="#4285F4"
    />
  </svg>
);
export const emailIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M21.5 15.0944C21.5 17.8596 19.6552 20.1072 16.9183 20.1004H8.08173C5.34476 20.1072 3.5 17.8596 3.5 15.0944V8.91315C3.5 6.15088 5.34476 3.90039 8.08173 3.90039H16.9183C19.6552 3.90039 21.5 6.15088 21.5 8.91315V15.0944Z"
      stroke="#787891"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.0874 6.87988L14.6182 12.1402C13.3999 13.1082 11.6732 13.1082 10.4549 12.1402L3.93066 6.87988"
      stroke="#787891"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const resentMail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.1 4.9125L7.909 8.59375C7.958 8.63125 8.042 8.63125 8.091 8.59375L12.9 4.9125M1.84 3H14.16C14.622 3 15 3.3375 15 3.75V11.5C15 12.325 14.244 13 13.32 13H2.68C1.756 13 1 12.325 1 11.5V3.75C1 3.3375 1.378 3 1.84 3Z"
      stroke="#1B3C52"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const activedashboard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.44085 19.8937V17.1294C9.44474 16.424 10.0169 15.8538 10.7223 15.8529H13.3201C14.0285 15.849 14.6064 16.4211 14.6093 17.1294V19.8985C14.6103 20.4979 15.09 20.9873 15.6893 21H17.4213C19.1386 21.0097 20.5397 19.6251 20.5494 17.9078V17.9059V10.0539C20.5377 9.38156 20.2186 8.75106 19.6834 8.34435L13.7619 3.61663C12.7218 2.79446 11.2525 2.79446 10.2124 3.61663L4.31517 8.34825C3.77711 8.75495 3.457 9.38739 3.44922 10.0626V17.9049C3.45798 19.6222 4.85713 21.0087 6.57541 21H8.30927C8.92322 21.0029 9.42334 20.5076 9.42626 19.8937"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const login = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.1392 0.660156H5.85592C5.23236 0.660915 4.63456 0.908716 4.19363 1.3492C3.75271 1.78969 3.50467 2.38691 3.50391 3.00985V4.45983C3.50391 4.64245 3.57652 4.81759 3.70578 4.94672C3.83504 5.07585 4.01034 5.14839 4.19314 5.14839C4.37594 5.14839 4.55125 5.07585 4.6805 4.94672C4.80976 4.81759 4.88238 4.64245 4.88238 4.45983V3.00985C4.88268 2.752 4.98535 2.5048 5.16786 2.32247C5.35037 2.14014 5.59781 2.03757 5.85592 2.03727H12.1392C12.3971 2.0378 12.6443 2.14047 12.8266 2.32279C13.0088 2.5051 13.1113 2.75217 13.1116 3.00985V12.9905C13.1113 13.2483 13.0087 13.4955 12.8263 13.6778C12.6438 13.8602 12.3964 13.9627 12.1383 13.963H5.85592C5.59781 13.9627 5.35037 13.8602 5.16786 13.6778C4.98535 13.4955 4.88268 13.2483 4.88238 12.9905V11.313C4.88238 11.1304 4.80976 10.9552 4.6805 10.8261C4.55125 10.697 4.37594 10.6244 4.19314 10.6244C4.01034 10.6244 3.83504 10.697 3.70578 10.8261C3.57652 10.9552 3.50391 11.1304 3.50391 11.313V12.9905C3.50467 13.6134 3.75271 14.2106 4.19363 14.6511C4.63456 15.0916 5.23236 15.3394 5.85592 15.3402H12.1392C12.7625 15.3391 13.36 15.0912 13.8007 14.6507C14.2414 14.2102 14.4893 13.6132 14.49 12.9905V3.00985C14.4893 2.3871 14.2414 1.79007 13.8007 1.34961C13.36 0.909153 12.7625 0.661219 12.1392 0.660156Z"
      fill="#1B3C52"
    />
    <path
      d="M11.122 7.50003L8.66942 5.05136C8.54182 4.92384 8.36923 4.85141 8.18875 4.84964C8.00827 4.84787 7.83429 4.9169 7.70421 5.04189C7.42564 5.30957 7.43225 5.76287 7.70564 6.03599L8.98274 7.31269H2.20095C2.01816 7.31269 1.84285 7.38523 1.71359 7.51436C1.58433 7.64349 1.51172 7.81863 1.51172 8.00124C1.51172 8.18386 1.58433 8.359 1.71359 8.48813C1.84285 8.61726 2.01816 8.6898 2.20095 8.6898H8.98302L7.69358 9.97797C7.56429 10.1071 7.49164 10.2822 7.49161 10.4649C7.49159 10.6475 7.56418 10.8227 7.69344 10.9518C7.82269 11.081 7.99801 11.1536 8.18083 11.1536C8.36364 11.1536 8.53898 11.0811 8.66827 10.952L11.122 8.5016C11.1879 8.43588 11.2402 8.35782 11.2758 8.27189C11.3115 8.18596 11.3299 8.09384 11.3299 8.00081C11.3299 7.90778 11.3115 7.81567 11.2758 7.72974C11.2402 7.64381 11.1879 7.56575 11.122 7.50003Z"
      fill="#1B3C52"
    />
  </svg>
);

export const rejected = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_1736_6422)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3401 7.99586C15.3446 8.96159 15.1578 9.91865 14.7903 10.8117C14.4228 11.7048 13.882 12.5163 13.1992 13.1992C12.5163 13.882 11.7048 14.4228 10.8117 14.7903C9.91865 15.1578 8.96159 15.3446 7.99586 15.3401C7.03085 15.3435 6.07471 15.1558 5.18261 14.7878C4.29051 14.4198 3.48009 13.8789 2.79813 13.1961C2.11616 12.5133 1.57613 11.7023 1.2092 10.8097C0.842264 9.91722 0.65569 8.96086 0.660237 7.99586C0.656828 7.03157 0.844242 6.07614 1.21168 5.18461C1.57913 4.29307 2.11933 3.48304 2.80119 2.80119C3.48304 2.11933 4.29307 1.57913 5.18461 1.21168C6.07614 0.844242 7.03157 0.656828 7.99586 0.660237C8.96086 0.65569 9.91722 0.842264 10.8097 1.2092C11.7023 1.57613 12.5133 2.11616 13.1961 2.79813C13.8789 3.48009 14.4198 4.29051 14.7878 5.18261C15.1558 6.07471 15.3435 7.03085 15.3401 7.99586ZM11.7712 3.30037C10.6155 2.36634 9.15445 1.89416 7.67073 1.97517C6.187 2.05619 4.78607 2.68465 3.73896 3.73896C2.68465 4.78607 2.05619 6.187 1.97517 7.67073C1.89416 9.15445 2.36634 10.6155 3.30037 11.7712L11.7712 3.30037ZM12.6999 4.22915L4.22915 12.6999C5.38482 13.634 6.84586 14.1062 8.32959 14.0251C9.81331 13.9441 11.2142 13.3157 12.2614 12.2614C13.3144 11.2131 13.9413 9.81163 14.0207 8.32792C14.1001 6.84422 13.6351 5.38379 12.6999 4.22915Z"
        fill="#1B3C52"
        stroke="#1B3C52"
        stroke-width="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1736_6422">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RequestAccess = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 1.99935C7.46957 1.99935 6.96086 2.21006 6.58579 2.58514C6.21071 2.96021 6 3.46892 6 3.99935C6 4.52978 6.21071 5.03849 6.58579 5.41356C6.96086 5.78864 7.46957 5.99935 8 5.99935C8.53043 5.99935 9.03914 5.78864 9.41421 5.41356C9.78929 5.03849 10 4.52978 10 3.99935C10 3.46892 9.78929 2.96021 9.41421 2.58514C9.03914 2.21006 8.53043 1.99935 8 1.99935ZM4.66667 3.99935C4.66667 3.11529 5.01786 2.26745 5.64298 1.64233C6.2681 1.01721 7.11595 0.666016 8 0.666016C8.88406 0.666016 9.7319 1.01721 10.357 1.64233C10.9821 2.26745 11.3333 3.11529 11.3333 3.99935C11.3333 4.8834 10.9821 5.73125 10.357 6.35637C9.7319 6.98149 8.88406 7.33268 8 7.33268C7.11595 7.33268 6.2681 6.98149 5.64298 6.35637C5.01786 5.73125 4.66667 4.8834 4.66667 3.99935ZM2 13.3327C2 12.095 2.49167 10.908 3.36683 10.0329C4.242 9.15768 5.42899 8.66602 6.66667 8.66602H9.33333C9.51014 8.66602 9.67971 8.73625 9.80474 8.86128C9.92976 8.9863 10 9.15587 10 9.33268C10 9.50949 9.92976 9.67906 9.80474 9.80409C9.67971 9.92911 9.51014 9.99935 9.33333 9.99935H6.66667C5.78261 9.99935 4.93477 10.3505 4.30964 10.9757C3.68452 11.6008 3.33333 12.4486 3.33333 13.3327C3.33333 13.5095 3.40357 13.6791 3.5286 13.8041C3.65362 13.9291 3.82319 13.9993 4 13.9993H8C8.17681 13.9993 8.34638 14.0696 8.4714 14.1946C8.59643 14.3196 8.66667 14.4892 8.66667 14.666C8.66667 14.8428 8.59643 15.0124 8.4714 15.1374C8.34638 15.2624 8.17681 15.3327 8 15.3327H4C3.46957 15.3327 2.96086 15.122 2.58579 14.7469C2.21071 14.3718 2 13.8631 2 13.3327ZM12.6667 9.99935C12.8435 9.99935 13.013 10.0696 13.1381 10.1946C13.2631 10.3196 13.3333 10.4892 13.3333 10.666V11.9993H14.6667C14.8435 11.9993 15.013 12.0696 15.1381 12.1946C15.2631 12.3196 15.3333 12.4892 15.3333 12.666C15.3333 12.8428 15.2631 13.0124 15.1381 13.1374C15.013 13.2624 14.8435 13.3327 14.6667 13.3327H13.3333V14.666C13.3333 14.8428 13.2631 15.0124 13.1381 15.1374C13.013 15.2624 12.8435 15.3327 12.6667 15.3327C12.4899 15.3327 12.3203 15.2624 12.1953 15.1374C12.0702 15.0124 12 14.8428 12 14.666V13.3327H10.6667C10.4899 13.3327 10.3203 13.2624 10.1953 13.1374C10.0702 13.0124 10 12.8428 10 12.666C10 12.4892 10.0702 12.3196 10.1953 12.1946C10.3203 12.0696 10.4899 11.9993 10.6667 11.9993H12V10.666C12 10.4892 12.0702 10.3196 12.1953 10.1946C12.3203 10.0696 12.4899 9.99935 12.6667 9.99935Z"
      fill="#1B3C52"
    />
  </svg>
);

export const deactiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
  >
    <rect width="20" height="12" rx="6" fill="#F03D36" />
    <rect x="1" y="1" width="10" height="10" rx="5" fill="white" />
    <path
      d="M4.44681 4C4.32839 4.00003 4.21482 4.04701 4.13098 4.13067C4.04711 4.21458 4 4.32838 4 4.44704C4 4.5657 4.04711 4.6795 4.13098 4.76341L5.36745 6.00027L4.13098 7.23623C4.04711 7.32015 4 7.43395 4 7.55261C4 7.67127 4.04711 7.78507 4.13098 7.86898C4.21487 7.95287 4.32863 8 4.44725 8C4.56587 8 4.67964 7.95287 4.76353 7.86898L6 6.63302L7.23647 7.86898C7.32036 7.95287 7.43413 8 7.55275 8C7.67137 8 7.78513 7.95287 7.86902 7.86898C7.95289 7.78507 8 7.67127 8 7.55261C8 7.43395 7.95289 7.32015 7.86902 7.23623L6.63255 6.00027L7.86902 4.76341C7.95289 4.6795 8 4.5657 8 4.44704C8 4.32838 7.95289 4.21458 7.86902 4.13067C7.8274 4.08914 7.77801 4.05622 7.72366 4.0338C7.66932 4.01138 7.61109 3.9999 7.5523 4C7.43388 4.00003 7.32031 4.04701 7.23647 4.13067L6 5.36752L4.76353 4.13067C4.72191 4.08914 4.67251 4.05622 4.61817 4.0338C4.56382 4.01138 4.50559 3.9999 4.44681 4Z"
      fill="#F03D36"
    />
  </svg>
);

export const activeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
  >
    <rect width="20" height="12" rx="6" fill="#00D261" />
    <rect x="9" y="1" width="10" height="10" rx="5" fill="white" />
    <path
      d="M15.6875 4.60013L13.268 6.40346L12.3815 5.45354C12.2017 5.26088 11.8856 5.23836 11.6754 5.40307C11.465 5.56778 11.4405 5.8575 11.6203 6.0502L12.8224 7.33945C12.8696 7.38968 12.928 7.43002 12.9937 7.45772C13.0594 7.48542 13.1308 7.49983 13.2032 7.49997C13.3178 7.50115 13.4294 7.46526 13.5185 7.39914L16.3188 5.31124C16.5302 5.15108 16.5611 4.86442 16.388 4.66926C16.2146 4.47399 15.9021 4.44328 15.6875 4.60013Z"
      fill="#00D261"
    />
  </svg>
);
export const Employees = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13 11C13 8.79086 11.2091 7 9 7C6.79086 7 5 8.79086 5 11C5 13.2091 6.79086 15 9 15C11.2091 15 13 13.2091 13 11Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0386 7.55773C11.0131 7.37547 11 7.18927 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C14.2554 11 13.5584 10.7966 12.9614 10.4423"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 21C15 17.6863 12.3137 15 9 15C5.68629 15 3 17.6863 3 21"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 17C21 13.6863 18.3137 11 15 11"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const activeEmpolyees = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13 11C13 8.79086 11.2091 7 9 7C6.79086 7 5 8.79086 5 11C5 13.2091 6.79086 15 9 15C11.2091 15 13 13.2091 13 11Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0386 7.55773C11.0131 7.37547 11 7.18927 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C14.2554 11 13.5584 10.7966 12.9614 10.4423"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 21C15 17.6863 12.3137 15 9 15C5.68629 15 3 17.6863 3 21"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 17C21 13.6863 18.3137 11 15 11"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ProvisionTenantsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 7.5C12 9.433 10.433 11 8.5 11C6.567 11 5 9.433 5 7.5C5 5.567 6.567 4 8.5 4C10.433 4 12 5.567 12 7.5Z"
      stroke="#5C5B62"
      stroke-width="1.5"
    />
    <path
      d="M13.5 11C15.433 11 17 9.433 17 7.5C17 5.567 15.433 4 13.5 4"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.1429 20H3.85714C2.83147 20 2 19.2325 2 18.2857C2 15.9188 4.07868 14 6.64286 14H10.3571C11.4023 14 12.3669 14.3188 13.1429 14.8568"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 14V20M22 17H16"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const activeProvisionTenants = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 7.5C12 9.433 10.433 11 8.5 11C6.567 11 5 9.433 5 7.5C5 5.567 6.567 4 8.5 4C10.433 4 12 5.567 12 7.5Z"
      stroke="#4285F4"
      stroke-width="1.5"
    />
    <path
      d="M13.5 11C15.433 11 17 9.433 17 7.5C17 5.567 15.433 4 13.5 4"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.1429 20H3.85714C2.83147 20 2 19.2325 2 18.2857C2 15.9188 4.07868 14 6.64286 14H10.3571C11.4023 14 12.3669 14.3188 13.1429 14.8568"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 14V20M22 17H16"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const settingActiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.5 16.5C9.19863 15.2923 10.5045 14.4797 12 14.4797C13.4956 14.4797 14.8014 15.2923 15.5 16.5M14.0001 10C14.0001 11.1046 13.1046 12 12.0001 12C10.8955 12 10 11.1046 10 10C10 8.89543 10.8955 8 12.0001 8C13.1046 8 14.0001 8.89543 14.0001 10Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M22 13.9669V10.0332C19.1433 10.0332 17.2857 6.93041 18.732 4.46691L15.2679 2.5001C13.8038 4.99405 10.1978 4.99395 8.73363 2.5L5.26953 4.46681C6.71586 6.93035 4.85673 10.0332 2 10.0332V13.9669C4.85668 13.9669 6.71425 17.0697 5.26795 19.5332L8.73205 21.5C10.1969 19.0048 13.8046 19.0047 15.2695 21.4999L18.7336 19.5331C17.2874 17.0696 19.1434 13.9669 22 13.9669Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const helpActiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16V11.5"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 8.01195V8.00195"
      stroke="#4285F4"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const helpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16V11.5"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 8.01195V8.00195"
      stroke="#5C5B62"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Onboarding = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_754_270"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={2}
      width={16}
      height={16}
    >
      <path d="M2 2H18V18H2V2Z" fill="white" />
    </mask>
    <g mask="url(#mask0_754_270)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8261 7.59625C16.164 7.59625 17.2486 6.51166 17.2486 5.17372C17.2486 3.83578 16.164 2.75119 14.8261 2.75119C13.4881 2.75119 12.4035 3.83578 12.4035 5.17372C12.4035 6.51166 13.4881 7.59625 14.8261 7.59625ZM14.8261 8.34744C16.5788 8.34744 17.9998 6.9265 17.9998 5.17372C17.9998 3.42091 16.5788 2 14.8261 2C13.0733 2 11.6523 3.42094 11.6523 5.17372C11.6523 6.9265 13.0733 8.34744 14.8261 8.34744Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36804 6.89573C8.32941 5.99585 9.72901 5.73201 10.9557 6.22766L13.4743 7.24538C13.7358 7.35103 13.9738 7.5073 14.1747 7.70521C14.3756 7.90312 14.5354 8.13877 14.645 8.39863L16.1817 12.0438C16.4396 12.6554 16.1859 13.3626 15.598 13.6708L15.2024 13.8783C15.3708 14.3878 15.2225 14.9782 14.7664 15.3406C14.3988 15.6325 13.9186 15.7017 13.4985 15.5549C13.4438 15.7919 13.3206 16.0162 13.129 16.1962C12.7228 16.5777 12.1293 16.6434 11.6586 16.3941C11.5892 16.619 11.4559 16.8278 11.2596 16.9911C10.8965 17.2933 10.4099 17.3594 9.99354 17.1979C9.92807 17.3985 9.80738 17.5843 9.63247 17.7309C9.21488 18.0809 8.61116 18.0968 8.17576 17.7692L4.95938 15.3496C4.59611 15.0763 4.25308 14.7771 3.93297 14.4543L2.62047 13.1308C2.37243 12.8807 2.19247 12.5713 2.09768 12.232C2.00289 11.8928 1.99643 11.5349 2.07891 11.1924L2.87788 7.87576C3.04797 7.1696 3.69891 6.68626 4.42407 6.72766L7.36804 6.89573ZM7.77801 7.54523L7.77572 7.54751L6.21144 9.10316C5.87685 9.43591 5.92957 9.99135 6.32076 10.2552C6.44156 10.3367 6.58351 10.3812 6.72922 10.3832C6.87492 10.3852 7.01805 10.3447 7.14107 10.2666L9.63847 8.68107L14.7708 13.2564L15.2492 13.0055C15.4913 12.8786 15.5957 12.5874 15.4895 12.3356L13.9528 8.69044C13.8817 8.52176 13.7779 8.36879 13.6475 8.24033C13.5171 8.11186 13.3626 8.01042 13.1929 7.94185L10.6743 6.92413C9.69441 6.52823 8.57285 6.75476 7.82351 7.49998L7.77801 7.54523ZM6.65047 7.60716L4.38122 7.4776C4.01866 7.45691 3.69319 7.69857 3.60813 8.05166L2.80922 11.3684C2.75673 11.5863 2.76083 11.814 2.82114 12.0299C2.88146 12.2458 2.99598 12.4427 3.15382 12.6018L4.46632 13.9253C4.76092 14.2224 5.07663 14.4978 5.41097 14.7493L8.62735 17.1689C8.70321 17.226 8.79615 17.2557 8.89105 17.2532C8.98596 17.2507 9.07722 17.2162 9.14997 17.1552C9.33941 16.9964 9.3516 16.7094 9.17647 16.5351L9.17604 16.5347L7.42322 14.7959L7.95226 14.2626L9.70504 16.0014L9.70613 16.0024L10.0904 16.3836C10.2779 16.5696 10.5761 16.5827 10.7791 16.4137C11.015 16.2174 11.0267 15.8591 10.8039 15.6479L9.0476 13.9823L9.56451 13.4372L11.8945 15.6469C12.0962 15.8382 12.4121 15.8389 12.6148 15.6486C12.8357 15.4411 12.8353 15.0902 12.614 14.8831L12.6137 14.8828L10.4368 12.8496L10.9495 12.3006L13.1264 14.3338C13.1266 14.334 13.1268 14.3342 13.127 14.3343L13.5421 14.7221C13.7521 14.9182 14.0741 14.9311 14.2992 14.7524C14.5811 14.5284 14.5932 14.1044 14.3244 13.8648L9.5621 9.61932L7.54369 10.9008C7.2973 11.0572 7.01062 11.1384 6.71879 11.1343C6.42696 11.1303 6.14265 11.0412 5.90069 10.878C5.11719 10.3495 5.01163 9.23694 5.68176 8.57054L6.65047 7.60716ZM16.045 4.28513C16.1931 4.43035 16.1955 4.66813 16.0503 4.81626L14.7983 6.09326C14.7633 6.12893 14.7216 6.15727 14.6755 6.17662C14.6295 6.19597 14.58 6.20593 14.5301 6.20593C14.4801 6.20593 14.4307 6.19597 14.3847 6.17662C14.3386 6.15727 14.2969 6.12893 14.2619 6.09326L13.6359 5.45476C13.4907 5.30663 13.4931 5.06882 13.6412 4.92363C13.7893 4.77844 14.0271 4.78076 14.1723 4.92888L14.5301 5.29382L15.5138 4.29038C15.6591 4.14226 15.8969 4.13991 16.045 4.28513Z"
        fill="black"
      />
    </g>
  </svg>
);
export const activeOnboarding = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_434_4081"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={2}
      width={16}
      height={16}
    >
      <path d="M2 2H18V18H2V2Z" fill="#4285F4" />
    </mask>
    <g mask="url(#mask0_434_4081)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.83 7.59625C16.1679 7.59625 17.2525 6.51166 17.2525 5.17372C17.2525 3.83578 16.1679 2.75119 14.83 2.75119C13.492 2.75119 12.4074 3.83578 12.4074 5.17372C12.4074 6.51166 13.492 7.59625 14.83 7.59625ZM14.83 8.34744C16.5827 8.34744 18.0037 6.9265 18.0037 5.17372C18.0037 3.42091 16.5827 2 14.83 2C13.0772 2 11.6562 3.42094 11.6562 5.17372C11.6562 6.9265 13.0772 8.34744 14.83 8.34744Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36999 6.89573C8.33137 5.99585 9.73096 5.73201 10.9576 6.22766L13.4763 7.24538C13.7377 7.35103 13.9758 7.5073 14.1767 7.70521C14.3776 7.90312 14.5374 8.13877 14.6469 8.39863L16.1837 12.0438C16.4415 12.6554 16.1878 13.3626 15.6 13.6708L15.2043 13.8783C15.3727 14.3878 15.2245 14.9782 14.7683 15.3406C14.4008 15.6325 13.9206 15.7017 13.5005 15.5549C13.4457 15.7919 13.3226 16.0162 13.131 16.1962C12.7247 16.5777 12.1312 16.6434 11.6606 16.3941C11.5911 16.619 11.4578 16.8278 11.2616 16.9911C10.8985 17.2933 10.4119 17.3594 9.99549 17.1979C9.93002 17.3985 9.80933 17.5843 9.63443 17.7309C9.21683 18.0809 8.61311 18.0968 8.17771 17.7692L4.96133 15.3496C4.59807 15.0763 4.25504 14.7771 3.93493 14.4543L2.62243 13.1308C2.37439 12.8807 2.19442 12.5713 2.09963 12.232C2.00485 11.8928 1.99839 11.5349 2.08087 11.1924L2.87983 7.87576C3.04993 7.1696 3.70087 6.68626 4.42602 6.72766L7.36999 6.89573ZM7.77996 7.54523L7.77768 7.54751L6.2134 9.10316C5.8788 9.43591 5.93152 9.99135 6.32271 10.2552C6.44351 10.3367 6.58546 10.3812 6.73117 10.3832C6.87688 10.3852 7.02001 10.3447 7.14302 10.2666L9.64043 8.68107L14.7727 13.2564L15.2511 13.0055C15.4932 12.8786 15.5977 12.5874 15.4915 12.3356L13.9547 8.69044C13.8836 8.52176 13.7799 8.36879 13.6495 8.24033C13.5191 8.11186 13.3646 8.01042 13.1948 7.94185L10.6762 6.92413C9.69637 6.52823 8.5748 6.75476 7.82546 7.49998L7.77996 7.54523ZM6.65243 7.60716L4.38318 7.4776C4.02062 7.45691 3.69515 7.69857 3.61008 8.05166L2.81118 11.3684C2.75868 11.5863 2.76278 11.814 2.8231 12.0299C2.88341 12.2458 2.99793 12.4427 3.15577 12.6018L4.46827 13.9253C4.76288 14.2224 5.07858 14.4978 5.41293 14.7493L8.6293 17.1689C8.70516 17.226 8.79811 17.2557 8.89301 17.2532C8.98791 17.2507 9.07917 17.2162 9.15193 17.1552C9.34136 16.9964 9.35355 16.7094 9.17843 16.5351L9.17799 16.5347L7.42518 14.7959L7.95421 14.2626L9.70699 16.0014L9.70808 16.0024L10.0923 16.3836C10.2799 16.5696 10.5781 16.5827 10.7811 16.4137C11.017 16.2174 11.0286 15.8591 10.8059 15.6479L9.04955 13.9823L9.56646 13.4372L11.8965 15.6469C12.0982 15.8382 12.4141 15.8389 12.6167 15.6486C12.8376 15.4411 12.8373 15.0902 12.616 14.8831L12.6156 14.8828L10.4388 12.8496L10.9515 12.3006L13.1284 14.3338C13.1285 14.334 13.1287 14.3342 13.1289 14.3343L13.5441 14.7221C13.7541 14.9182 14.0761 14.9311 14.3011 14.7524C14.5831 14.5284 14.5951 14.1044 14.3263 13.8648L9.56405 9.61932L7.54565 10.9008C7.29925 11.0572 7.01258 11.1384 6.72075 11.1343C6.42892 11.1303 6.1446 11.0412 5.90265 10.878C5.11915 10.3495 5.01358 9.23694 5.68371 8.57054L6.65243 7.60716ZM16.047 4.28513C16.1951 4.43035 16.1974 4.66813 16.0522 4.81626L14.8002 6.09326C14.7653 6.12893 14.7236 6.15727 14.6775 6.17662C14.6315 6.19597 14.582 6.20593 14.5321 6.20593C14.4821 6.20593 14.4327 6.19597 14.3866 6.17662C14.3406 6.15727 14.2988 6.12893 14.2639 6.09326L13.6379 5.45476C13.4927 5.30663 13.495 5.06882 13.6431 4.92363C13.7913 4.77844 14.0291 4.78076 14.1743 4.92888L14.5321 5.29382L15.5158 4.29038C15.661 4.14226 15.8988 4.13991 16.047 4.28513Z"
        fill="#4285F4"
      />
    </g>
  </svg>
);
export const Compliance = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51992 2.15791C9.65789 2.05537 9.82522 2 9.99712 2C10.169 2 10.3363 2.05537 10.4743 2.15791L16.7135 5.66749C16.9919 5.78989 17.1767 6.06348 17.1911 6.36668L17.1927 6.40908L17.1959 6.52748C17.2072 7.14547 17.1864 7.76364 17.1335 8.37947C17.0359 9.49626 16.7975 10.9691 16.1919 12.1626C15.2079 14.101 13.7439 15.5362 12.5479 16.4786C12.058 16.8653 11.545 17.222 11.0119 17.5466C10.8132 17.667 10.611 17.7815 10.4055 17.8898L10.3503 17.9178C10.2404 17.9719 10.1196 18 9.99712 18C9.87464 18 9.75381 17.9719 9.64392 17.9178L9.58792 17.8898C9.38266 17.7815 9.18071 17.667 8.98232 17.5466C8.44921 17.222 7.93627 16.8653 7.44633 16.4786C6.25034 15.5362 4.78635 14.101 3.80236 12.1626C3.22636 11.0275 2.98876 9.55146 2.88396 8.42827C2.82317 7.76233 2.79567 7.09377 2.80156 6.42508L2.80236 6.37788C2.80658 6.22631 2.85379 6.07905 2.93849 5.95327C3.02319 5.8275 3.14189 5.72839 3.28076 5.66749L3.28556 5.66589L3.30236 5.65789L3.36876 5.62829L3.62076 5.51549C3.83676 5.41789 4.14155 5.27789 4.49515 5.11069C5.20475 4.77469 6.09834 4.33469 6.86394 3.9027C7.48081 3.54859 8.08241 3.16852 8.66712 2.7635C8.93426 2.58001 9.19881 2.39279 9.46072 2.20191L9.50552 2.16831L9.51672 2.16031L9.51992 2.15791ZM15.5999 6.92108C15.3895 6.82508 15.1199 6.70108 14.8151 6.55708C13.978 6.16491 13.1543 5.74467 12.3455 5.29709C11.6872 4.91979 11.0453 4.51463 10.4215 4.0827C10.2803 3.98554 10.1398 3.88741 9.99992 3.7883V16.2866C10.5427 15.9676 11.0632 15.6118 11.5575 15.2218C12.6455 14.3642 13.9215 13.0994 14.7655 11.4378C15.2295 10.5227 15.4471 9.29546 15.5391 8.24027C15.5847 7.72267 15.5975 7.26748 15.5999 6.94268V6.92108Z"
      fill="black"
    />
  </svg>
);
export const activeCompliance = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51992 2.15791C9.65789 2.05537 9.82522 2 9.99712 2C10.169 2 10.3363 2.05537 10.4743 2.15791L16.7135 5.66749C16.9919 5.78989 17.1767 6.06348 17.1911 6.36668L17.1927 6.40908L17.1959 6.52748C17.2072 7.14547 17.1864 7.76364 17.1335 8.37947C17.0359 9.49626 16.7975 10.9691 16.1919 12.1626C15.2079 14.101 13.7439 15.5362 12.5479 16.4786C12.058 16.8653 11.545 17.222 11.0119 17.5466C10.8132 17.667 10.611 17.7815 10.4055 17.8898L10.3503 17.9178C10.2404 17.9719 10.1196 18 9.99712 18C9.87464 18 9.75381 17.9719 9.64392 17.9178L9.58792 17.8898C9.38266 17.7815 9.18071 17.667 8.98232 17.5466C8.44921 17.222 7.93627 16.8653 7.44633 16.4786C6.25034 15.5362 4.78635 14.101 3.80236 12.1626C3.22636 11.0275 2.98876 9.55146 2.88396 8.42827C2.82317 7.76233 2.79567 7.09377 2.80156 6.42508L2.80236 6.37788C2.80658 6.22631 2.85379 6.07905 2.93849 5.95327C3.02319 5.8275 3.14189 5.72839 3.28076 5.66749L3.28556 5.66589L3.30236 5.65789L3.36876 5.62829L3.62076 5.51549C3.83676 5.41789 4.14155 5.27789 4.49515 5.11069C5.20475 4.77469 6.09834 4.33469 6.86394 3.9027C7.48081 3.54859 8.08241 3.16852 8.66712 2.7635C8.93426 2.58001 9.19881 2.39279 9.46072 2.20191L9.50552 2.16831L9.51672 2.16031L9.51992 2.15791ZM15.5999 6.92108C15.3895 6.82508 15.1199 6.70108 14.8151 6.55708C13.978 6.16491 13.1543 5.74467 12.3455 5.29709C11.6872 4.91979 11.0453 4.51463 10.4215 4.0827C10.2803 3.98554 10.1398 3.88741 9.99992 3.7883V16.2866C10.5427 15.9676 11.0632 15.6118 11.5575 15.2218C12.6455 14.3642 13.9215 13.0994 14.7655 11.4378C15.2295 10.5227 15.4471 9.29546 15.5391 8.24027C15.5847 7.72267 15.5975 7.26748 15.5999 6.94268V6.92108Z"
      fill="#4285F4"
    />
  </svg>
);
export const LeaveTracker = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_754_285)">
      <path
        d="M2.87961 12.4004H1.75961C1.67124 12.4004 1.59961 12.472 1.59961 12.5604V13.6804C1.59961 13.7688 1.67124 13.8404 1.75961 13.8404H2.87961C2.96797 13.8404 3.03961 13.7688 3.03961 13.6804V12.5604C3.03961 12.472 2.96797 12.4004 2.87961 12.4004Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 12.4004H4.16C4.07163 12.4004 4 12.472 4 12.5604V13.6804C4 13.7688 4.07163 13.8404 4.16 13.8404H5.28C5.36837 13.8404 5.44 13.7688 5.44 13.6804V12.5604C5.44 12.472 5.36837 12.4004 5.28 12.4004Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M7.68039 12.4004H6.56039C6.47202 12.4004 6.40039 12.472 6.40039 12.5604V13.6804C6.40039 13.7688 6.47202 13.8404 6.56039 13.8404H7.68039C7.76876 13.8404 7.84039 13.7688 7.84039 13.6804V12.5604C7.84039 12.472 7.76876 12.4004 7.68039 12.4004Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M14.0332 12.4336V15.1579H16.7575"
        stroke="black"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8977 0C11.0007 9.48968e-05 11.0998 0.0411599 11.1726 0.114062C11.2455 0.187009 11.2867 0.285943 11.2867 0.389062V1.55703H13.6218C14.1378 1.5571 14.6328 1.76172 14.9977 2.12656C15.3625 2.49142 15.5671 2.98638 15.5672 3.50234V9.99064C15.3138 9.94984 15.0539 9.92816 14.789 9.92816V7.00547H0.778125V13.6218C0.778192 13.9314 0.901528 14.228 1.12031 14.4469C1.33927 14.6658 1.63643 14.789 1.9461 14.789H9.92816C9.92816 15.054 9.95064 15.3138 9.99144 15.5672H1.9461L1.7539 15.5578C1.30855 15.5132 0.889568 15.3162 0.570313 14.9969C0.205689 14.6322 0.000684676 14.1376 0 13.6218V3.50234C0.000712638 2.98663 0.205681 2.49205 0.570313 2.12734C0.935112 1.76254 1.43018 1.55765 1.9461 1.55703H4.28125V0.389062C4.28128 0.285889 4.32235 0.18702 4.39531 0.114062C4.46829 0.0411282 4.56714 0 4.67031 0C4.7735 1.11595e-05 4.87234 0.0411118 4.94531 0.114062C5.01827 0.18702 5.05934 0.285889 5.05938 0.389062V1.55703H10.5078V0.389062C10.5078 0.285958 10.549 0.187006 10.6218 0.114062C10.6949 0.0410754 10.7944 0 10.8977 0ZM1.9461 2.33516C1.30016 2.33516 0.778318 2.85801 0.778125 3.50234V6.22734H14.789V3.50234C14.789 3.2315 14.6952 2.97018 14.525 2.7625L14.4469 2.67734C14.228 2.45847 13.9314 2.33522 13.6218 2.33516H11.2867V3.50234L11.2789 3.5789C11.264 3.65374 11.2274 3.72337 11.1726 3.77813L11.1133 3.82656C11.0499 3.86882 10.975 3.89212 10.8977 3.89218L10.8211 3.88438C10.7712 3.87441 10.7236 3.85482 10.6813 3.82656L10.6218 3.77813C10.5489 3.70514 10.5078 3.60556 10.5078 3.50234V2.33516H5.05938V3.50234C5.05938 3.60556 5.0183 3.70514 4.94531 3.77813L4.88594 3.82656C4.82252 3.86879 4.74763 3.89218 4.67031 3.89218L4.59375 3.88438C4.54406 3.87442 4.49687 3.85464 4.45469 3.82656L4.39531 3.77813C4.34054 3.72335 4.30322 3.65377 4.28828 3.5789L4.28125 3.50234V2.33516H1.9461Z"
        fill="black"
      />
      <path
        d="M14.6596 19.2003C17.1674 19.2003 19.2002 17.1675 19.2002 14.6597C19.2002 12.1519 17.1674 10.1191 14.6596 10.1191C12.1519 10.1191 10.1191 12.1519 10.1191 14.6597C10.1191 17.1675 12.1519 19.2003 14.6596 19.2003Z"
        stroke="black"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.87961 7.59961H1.75961C1.67124 7.59961 1.59961 7.67124 1.59961 7.75961V8.87961C1.59961 8.96798 1.67124 9.03961 1.75961 9.03961H2.87961C2.96797 9.03961 3.03961 8.96798 3.03961 8.87961V7.75961C3.03961 7.67124 2.96797 7.59961 2.87961 7.59961Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 7.59961H4.16C4.07163 7.59961 4 7.67124 4 7.75961V8.87961C4 8.96798 4.07163 9.03961 4.16 9.03961H5.28C5.36837 9.03961 5.44 8.96798 5.44 8.87961V7.75961C5.44 7.67124 5.36837 7.59961 5.28 7.59961Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M7.68039 7.59961H6.56039C6.47202 7.59961 6.40039 7.67124 6.40039 7.75961V8.87961C6.40039 8.96798 6.47202 9.03961 6.56039 9.03961H7.68039C7.76876 9.03961 7.84039 8.96798 7.84039 8.87961V7.75961C7.84039 7.67124 7.76876 7.59961 7.68039 7.59961Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M10.0808 7.59961H8.96078C8.87242 7.59961 8.80078 7.67124 8.80078 7.75961V8.87961C8.80078 8.96798 8.87242 9.03961 8.96078 9.03961H10.0808C10.1691 9.03961 10.2408 8.96798 10.2408 8.87961V7.75961C10.2408 7.67124 10.1691 7.59961 10.0808 7.59961Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M12.4792 7.59961H11.3592C11.2709 7.59961 11.1992 7.67124 11.1992 7.75961V8.87961C11.1992 8.96798 11.2709 9.03961 11.3592 9.03961H12.4792C12.5676 9.03961 12.6392 8.96798 12.6392 8.87961V7.75961C12.6392 7.67124 12.5676 7.59961 12.4792 7.59961Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M2.87961 10H1.75961C1.67124 10 1.59961 10.0716 1.59961 10.16V11.28C1.59961 11.3684 1.67124 11.44 1.75961 11.44H2.87961C2.96797 11.44 3.03961 11.3684 3.03961 11.28V10.16C3.03961 10.0716 2.96797 10 2.87961 10Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 10H4.16C4.07163 10 4 10.0716 4 10.16V11.28C4 11.3684 4.07163 11.44 4.16 11.44H5.28C5.36837 11.44 5.44 11.3684 5.44 11.28V10.16C5.44 10.0716 5.36837 10 5.28 10Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M7.68039 10H6.56039C6.47202 10 6.40039 10.0716 6.40039 10.16V11.28C6.40039 11.3684 6.47202 11.44 6.56039 11.44H7.68039C7.76876 11.44 7.84039 11.3684 7.84039 11.28V10.16C7.84039 10.0716 7.76876 10 7.68039 10Z"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M10.0808 10H8.96078C8.87242 10 8.80078 10.0716 8.80078 10.16V11.28C8.80078 11.3684 8.87242 11.44 8.96078 11.44H10.0808C10.1691 11.44 10.2408 11.3684 10.2408 11.28V10.16C10.2408 10.0716 10.1691 10 10.0808 10Z"
        stroke="black"
        strokeWidth={0.5}
      />
    </g>
    <defs>
      <clipPath id="clip0_754_285">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const activeLeaveTracker = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_447_4624)">
      <path
        d="M2.88156 12.4004H1.76156C1.6732 12.4004 1.60156 12.472 1.60156 12.5604V13.6804C1.60156 13.7688 1.6732 13.8404 1.76156 13.8404H2.88156C2.96993 13.8404 3.04156 13.7688 3.04156 13.6804V12.5604C3.04156 12.472 2.96993 12.4004 2.88156 12.4004Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 12.4004H4.16C4.07163 12.4004 4 12.472 4 12.5604V13.6804C4 13.7688 4.07163 13.8404 4.16 13.8404H5.28C5.36837 13.8404 5.44 13.7688 5.44 13.6804V12.5604C5.44 12.472 5.36837 12.4004 5.28 12.4004Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M7.67844 12.4004H6.55844C6.47007 12.4004 6.39844 12.472 6.39844 12.5604V13.6804C6.39844 13.7688 6.47007 13.8404 6.55844 13.8404H7.67844C7.7668 13.8404 7.83844 13.7688 7.83844 13.6804V12.5604C7.83844 12.472 7.7668 12.4004 7.67844 12.4004Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M14.0312 12.4336V15.1579H16.7556"
        stroke="white"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8977 0C11.0007 9.48968e-05 11.0998 0.0411599 11.1726 0.114062C11.2455 0.187009 11.2867 0.285943 11.2867 0.389062V1.55703H13.6218C14.1378 1.5571 14.6328 1.76172 14.9977 2.12656C15.3625 2.49142 15.5671 2.98638 15.5672 3.50234V9.99064C15.3138 9.94984 15.0539 9.92816 14.789 9.92816V7.00547H0.778125V13.6218C0.778192 13.9314 0.901528 14.228 1.12031 14.4469C1.33927 14.6658 1.63643 14.789 1.9461 14.789H9.92816C9.92816 15.054 9.95064 15.3138 9.99144 15.5672H1.9461L1.7539 15.5578C1.30855 15.5132 0.889568 15.3162 0.570313 14.9969C0.205689 14.6322 0.000684676 14.1376 0 13.6218V3.50234C0.000712638 2.98663 0.205681 2.49205 0.570313 2.12734C0.935112 1.76254 1.43018 1.55765 1.9461 1.55703H4.28125V0.389062C4.28128 0.285889 4.32235 0.18702 4.39531 0.114062C4.46829 0.0411282 4.56714 0 4.67031 0C4.7735 1.11595e-05 4.87234 0.0411118 4.94531 0.114062C5.01827 0.18702 5.05934 0.285889 5.05938 0.389062V1.55703H10.5078V0.389062C10.5078 0.285958 10.549 0.187006 10.6218 0.114062C10.6949 0.0410754 10.7944 0 10.8977 0ZM1.9461 2.33516C1.30016 2.33516 0.778318 2.85801 0.778125 3.50234V6.22734H14.789V3.50234C14.789 3.2315 14.6952 2.97018 14.525 2.7625L14.4469 2.67734C14.228 2.45847 13.9314 2.33522 13.6218 2.33516H11.2867V3.50234L11.2789 3.5789C11.264 3.65374 11.2274 3.72337 11.1726 3.77813L11.1133 3.82656C11.0499 3.86882 10.975 3.89212 10.8977 3.89218L10.8211 3.88438C10.7712 3.87441 10.7236 3.85482 10.6813 3.82656L10.6218 3.77813C10.5489 3.70514 10.5078 3.60556 10.5078 3.50234V2.33516H5.05938V3.50234C5.05938 3.60556 5.0183 3.70514 4.94531 3.77813L4.88594 3.82656C4.82252 3.86879 4.74763 3.89218 4.67031 3.89218L4.59375 3.88438C4.54406 3.87442 4.49687 3.85464 4.45469 3.82656L4.39531 3.77813C4.34054 3.72335 4.30322 3.65377 4.28828 3.5789L4.28125 3.50234V2.33516H1.9461Z"
        fill="white"
      />
      <path
        d="M14.6577 19.2003C17.1654 19.2003 19.1982 17.1675 19.1982 14.6597C19.1982 12.1519 17.1654 10.1191 14.6577 10.1191C12.15 10.1191 10.1172 12.1519 10.1172 14.6597C10.1172 17.1675 12.15 19.2003 14.6577 19.2003Z"
        stroke="white"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.88156 7.59961H1.76156C1.6732 7.59961 1.60156 7.67124 1.60156 7.75961V8.87961C1.60156 8.96798 1.6732 9.03961 1.76156 9.03961H2.88156C2.96993 9.03961 3.04156 8.96798 3.04156 8.87961V7.75961C3.04156 7.67124 2.96993 7.59961 2.88156 7.59961Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 7.59961H4.16C4.07163 7.59961 4 7.67124 4 7.75961V8.87961C4 8.96798 4.07163 9.03961 4.16 9.03961H5.28C5.36837 9.03961 5.44 8.96798 5.44 8.87961V7.75961C5.44 7.67124 5.36837 7.59961 5.28 7.59961Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M7.67844 7.59961H6.55844C6.47007 7.59961 6.39844 7.67124 6.39844 7.75961V8.87961C6.39844 8.96798 6.47007 9.03961 6.55844 9.03961H7.67844C7.7668 9.03961 7.83844 8.96798 7.83844 8.87961V7.75961C7.83844 7.67124 7.7668 7.59961 7.67844 7.59961Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M10.0808 7.59961H8.96078C8.87242 7.59961 8.80078 7.67124 8.80078 7.75961V8.87961C8.80078 8.96798 8.87242 9.03961 8.96078 9.03961H10.0808C10.1691 9.03961 10.2408 8.96798 10.2408 8.87961V7.75961C10.2408 7.67124 10.1691 7.59961 10.0808 7.59961Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M12.4792 7.59961H11.3592C11.2709 7.59961 11.1992 7.67124 11.1992 7.75961V8.87961C11.1992 8.96798 11.2709 9.03961 11.3592 9.03961H12.4792C12.5676 9.03961 12.6392 8.96798 12.6392 8.87961V7.75961C12.6392 7.67124 12.5676 7.59961 12.4792 7.59961Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M2.88156 10H1.76156C1.6732 10 1.60156 10.0716 1.60156 10.16V11.28C1.60156 11.3684 1.6732 11.44 1.76156 11.44H2.88156C2.96993 11.44 3.04156 11.3684 3.04156 11.28V10.16C3.04156 10.0716 2.96993 10 2.88156 10Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M5.28 10H4.16C4.07163 10 4 10.0716 4 10.16V11.28C4 11.3684 4.07163 11.44 4.16 11.44H5.28C5.36837 11.44 5.44 11.3684 5.44 11.28V10.16C5.44 10.0716 5.36837 10 5.28 10Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M7.67844 10H6.55844C6.47007 10 6.39844 10.0716 6.39844 10.16V11.28C6.39844 11.3684 6.47007 11.44 6.55844 11.44H7.67844C7.7668 11.44 7.83844 11.3684 7.83844 11.28V10.16C7.83844 10.0716 7.7668 10 7.67844 10Z"
        stroke="white"
        strokeWidth={0.5}
      />
      <path
        d="M10.0808 10H8.96078C8.87242 10 8.80078 10.0716 8.80078 10.16V11.28C8.80078 11.3684 8.87242 11.44 8.96078 11.44H10.0808C10.1691 11.44 10.2408 11.3684 10.2408 11.28V10.16C10.2408 10.0716 10.1691 10 10.0808 10Z"
        stroke="white"
        strokeWidth={0.5}
      />
    </g>
    <defs>
      <clipPath id="clip0_447_4624">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const Documents = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9223 12.0769V9.65385C16.9223 7.93327 15.5275 6.53846 13.8069 6.53846H12.4223C11.8488 6.53846 11.3839 6.07353 11.3839 5.5V4.11538C11.3839 2.39481 9.98906 1 8.26848 1H6.53771M7.23002 14.1538V14.8462M9.99925 12.0769V14.8462M12.7685 10V14.8462M8.61463 1H4.11463C3.54111 1 3.07617 1.46493 3.07617 2.03846V17.9615C3.07617 18.5351 3.54111 19 4.11463 19H15.8839C16.4574 19 16.9223 18.5351 16.9223 17.9615V9.30769C16.9223 4.71948 13.2028 1 8.61463 1Z"
      stroke="#5C5B62"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const activeDocuments = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 11.875V9.6875C16.25 8.1342 14.9908 6.875 13.4375 6.875H12.1875C11.6697 6.875 11.25 6.45527 11.25 5.9375V4.6875C11.25 3.1342 9.9908 1.875 8.4375 1.875H6.875M6.875 12.5H13.125M6.875 15H10M8.75 1.875H4.6875C4.16973 1.875 3.75 2.29473 3.75 2.8125V17.1875C3.75 17.7053 4.16973 18.125 4.6875 18.125H15.3125C15.8303 18.125 16.25 17.7053 16.25 17.1875V9.375C16.25 5.23286 12.8921 1.875 8.75 1.875Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const OrganisationalStructure = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_754_337)">
      <path
        d="M8.5 13C8.18174 13 7.87652 13.1264 7.65147 13.3515C7.42643 13.5765 7.3 13.8817 7.3 14.2V17.8C7.3 18.1183 7.42643 18.4235 7.65147 18.6485C7.87652 18.8736 8.18174 19 8.5 19H11.5C11.8183 19 12.1235 18.8736 12.3485 18.6485C12.5736 18.4235 12.7 18.1183 12.7 17.8V14.2C12.7 13.8817 12.5736 13.5765 12.3485 13.3515C12.1235 13.1264 11.8183 13 11.5 13H8.5ZM12.1 14.2V17.8C12.1 17.9591 12.0368 18.1117 11.9243 18.2243C11.8117 18.3368 11.6591 18.4 11.5 18.4H8.5C8.34087 18.4 8.18826 18.3368 8.07574 18.2243C7.96321 18.1117 7.9 17.9591 7.9 17.8V14.2C7.9 14.0409 7.96321 13.8883 8.07574 13.7757C8.18826 13.6632 8.34087 13.6 8.5 13.6H11.5C11.6591 13.6 11.8117 13.6632 11.9243 13.7757C12.0368 13.8883 12.1 14.0409 12.1 14.2ZM8.5 7H11.5C11.8183 7 12.1235 6.87357 12.3485 6.64853C12.5736 6.42348 12.7 6.11826 12.7 5.8V2.2C12.7 1.88174 12.5736 1.57652 12.3485 1.35147C12.1235 1.12643 11.8183 1 11.5 1H8.5C8.18174 1 7.87652 1.12643 7.65147 1.35147C7.42643 1.57652 7.3 1.88174 7.3 2.2V5.8C7.3 6.11826 7.42643 6.42348 7.65147 6.64853C7.87652 6.87357 8.18174 7 8.5 7ZM7.9 2.2C7.9 2.04087 7.96321 1.88826 8.07574 1.77574C8.18826 1.66321 8.34087 1.6 8.5 1.6H11.5C11.6591 1.6 11.8117 1.66321 11.9243 1.77574C12.0368 1.88826 12.1 2.04087 12.1 2.2V5.8C12.1 5.95913 12.0368 6.11174 11.9243 6.22426C11.8117 6.33679 11.6591 6.4 11.5 6.4H8.5C8.34087 6.4 8.18826 6.33679 8.07574 6.22426C7.96321 6.11174 7.9 5.95913 7.9 5.8V2.2ZM2.2 19H5.2C5.51826 19 5.82348 18.8736 6.04853 18.6485C6.27357 18.4235 6.4 18.1183 6.4 17.8V14.2C6.4 13.8817 6.27357 13.5765 6.04853 13.3515C5.82348 13.1264 5.51826 13 5.2 13H2.2C1.88174 13 1.57652 13.1264 1.35147 13.3515C1.12643 13.5765 1 13.8817 1 14.2L1 17.8C1 18.1183 1.12643 18.4235 1.35147 18.6485C1.57652 18.8736 1.88174 19 2.2 19ZM1.6 14.2C1.6 14.0409 1.66321 13.8883 1.77574 13.7757C1.88826 13.6632 2.04087 13.6 2.2 13.6H5.2C5.35913 13.6 5.51174 13.6632 5.62426 13.7757C5.73679 13.8883 5.8 14.0409 5.8 14.2V17.8C5.8 17.9591 5.73679 18.1117 5.62426 18.2243C5.51174 18.3368 5.35913 18.4 5.2 18.4H2.2C2.04087 18.4 1.88826 18.3368 1.77574 18.2243C1.66321 18.1117 1.6 17.9591 1.6 17.8V14.2ZM13.6 14.2V17.8C13.6 18.1183 13.7264 18.4235 13.9515 18.6485C14.1765 18.8736 14.4817 19 14.8 19H17.8C18.1183 19 18.4235 18.8736 18.6485 18.6485C18.8736 18.4235 19 18.1183 19 17.8V14.2C19 13.8817 18.8736 13.5765 18.6485 13.3515C18.4235 13.1264 18.1183 13 17.8 13H14.8C14.4817 13 14.1765 13.1264 13.9515 13.3515C13.7264 13.5765 13.6 13.8817 13.6 14.2ZM18.4 14.2V17.8C18.4 17.9591 18.3368 18.1117 18.2243 18.2243C18.1117 18.3368 17.9591 18.4 17.8 18.4H14.8C14.6409 18.4 14.4883 18.3368 14.3757 18.2243C14.2632 18.1117 14.2 17.9591 14.2 17.8V14.2C14.2 14.0409 14.2632 13.8883 14.3757 13.7757C14.4883 13.6632 14.6409 13.6 14.8 13.6H17.8C17.9591 13.6 18.1117 13.6632 18.2243 13.7757C18.3368 13.8883 18.4 14.0409 18.4 14.2ZM3.7 12.4C3.77957 12.4 3.85587 12.3684 3.91213 12.3121C3.96839 12.2559 4 12.1796 4 12.1V11.5C4 11.1817 4.12643 10.8765 4.35147 10.6515C4.57652 10.4264 4.88174 10.3 5.2 10.3H9.7V12.1C9.7 12.1796 9.73161 12.2559 9.78787 12.3121C9.84413 12.3684 9.92043 12.4 10 12.4C10.0796 12.4 10.1559 12.3684 10.2121 12.3121C10.2684 12.2559 10.3 12.1796 10.3 12.1V10.3H14.8C15.1183 10.3 15.4235 10.4264 15.6485 10.6515C15.8736 10.8765 16 11.1817 16 11.5V12.1C16 12.1796 16.0316 12.2559 16.0879 12.3121C16.1441 12.3684 16.2204 12.4 16.3 12.4C16.3796 12.4 16.4559 12.3684 16.5121 12.3121C16.5684 12.2559 16.6 12.1796 16.6 12.1V11.5C16.5995 11.0228 16.4097 10.5652 16.0723 10.2277C15.7348 9.89027 15.2772 9.70048 14.8 9.7H10.3V7.9C10.3 7.82044 10.2684 7.74413 10.2121 7.68787C10.1559 7.63161 10.0796 7.6 10 7.6C9.92043 7.6 9.84413 7.63161 9.78787 7.68787C9.73161 7.74413 9.7 7.82044 9.7 7.9V9.7H5.2C4.72276 9.70048 4.2652 9.89027 3.92773 10.2277C3.59027 10.5652 3.40048 11.0228 3.4 11.5V12.1C3.4 12.1796 3.43161 12.2559 3.48787 12.3121C3.54413 12.3684 3.62044 12.4 3.7 12.4Z"
        fill="black"
        stroke="black"
        strokeWidth={0.2}
      />
    </g>
    <defs>
      <clipPath id="clip0_754_337">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const activeOrganisationalStructure = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_754_337)">
      <path
        d="M8.5 13C8.18174 13 7.87652 13.1264 7.65147 13.3515C7.42643 13.5765 7.3 13.8817 7.3 14.2V17.8C7.3 18.1183 7.42643 18.4235 7.65147 18.6485C7.87652 18.8736 8.18174 19 8.5 19H11.5C11.8183 19 12.1235 18.8736 12.3485 18.6485C12.5736 18.4235 12.7 18.1183 12.7 17.8V14.2C12.7 13.8817 12.5736 13.5765 12.3485 13.3515C12.1235 13.1264 11.8183 13 11.5 13H8.5ZM12.1 14.2V17.8C12.1 17.9591 12.0368 18.1117 11.9243 18.2243C11.8117 18.3368 11.6591 18.4 11.5 18.4H8.5C8.34087 18.4 8.18826 18.3368 8.07574 18.2243C7.96321 18.1117 7.9 17.9591 7.9 17.8V14.2C7.9 14.0409 7.96321 13.8883 8.07574 13.7757C8.18826 13.6632 8.34087 13.6 8.5 13.6H11.5C11.6591 13.6 11.8117 13.6632 11.9243 13.7757C12.0368 13.8883 12.1 14.0409 12.1 14.2ZM8.5 7H11.5C11.8183 7 12.1235 6.87357 12.3485 6.64853C12.5736 6.42348 12.7 6.11826 12.7 5.8V2.2C12.7 1.88174 12.5736 1.57652 12.3485 1.35147C12.1235 1.12643 11.8183 1 11.5 1H8.5C8.18174 1 7.87652 1.12643 7.65147 1.35147C7.42643 1.57652 7.3 1.88174 7.3 2.2V5.8C7.3 6.11826 7.42643 6.42348 7.65147 6.64853C7.87652 6.87357 8.18174 7 8.5 7ZM7.9 2.2C7.9 2.04087 7.96321 1.88826 8.07574 1.77574C8.18826 1.66321 8.34087 1.6 8.5 1.6H11.5C11.6591 1.6 11.8117 1.66321 11.9243 1.77574C12.0368 1.88826 12.1 2.04087 12.1 2.2V5.8C12.1 5.95913 12.0368 6.11174 11.9243 6.22426C11.8117 6.33679 11.6591 6.4 11.5 6.4H8.5C8.34087 6.4 8.18826 6.33679 8.07574 6.22426C7.96321 6.11174 7.9 5.95913 7.9 5.8V2.2ZM2.2 19H5.2C5.51826 19 5.82348 18.8736 6.04853 18.6485C6.27357 18.4235 6.4 18.1183 6.4 17.8V14.2C6.4 13.8817 6.27357 13.5765 6.04853 13.3515C5.82348 13.1264 5.51826 13 5.2 13H2.2C1.88174 13 1.57652 13.1264 1.35147 13.3515C1.12643 13.5765 1 13.8817 1 14.2L1 17.8C1 18.1183 1.12643 18.4235 1.35147 18.6485C1.57652 18.8736 1.88174 19 2.2 19ZM1.6 14.2C1.6 14.0409 1.66321 13.8883 1.77574 13.7757C1.88826 13.6632 2.04087 13.6 2.2 13.6H5.2C5.35913 13.6 5.51174 13.6632 5.62426 13.7757C5.73679 13.8883 5.8 14.0409 5.8 14.2V17.8C5.8 17.9591 5.73679 18.1117 5.62426 18.2243C5.51174 18.3368 5.35913 18.4 5.2 18.4H2.2C2.04087 18.4 1.88826 18.3368 1.77574 18.2243C1.66321 18.1117 1.6 17.9591 1.6 17.8V14.2ZM13.6 14.2V17.8C13.6 18.1183 13.7264 18.4235 13.9515 18.6485C14.1765 18.8736 14.4817 19 14.8 19H17.8C18.1183 19 18.4235 18.8736 18.6485 18.6485C18.8736 18.4235 19 18.1183 19 17.8V14.2C19 13.8817 18.8736 13.5765 18.6485 13.3515C18.4235 13.1264 18.1183 13 17.8 13H14.8C14.4817 13 14.1765 13.1264 13.9515 13.3515C13.7264 13.5765 13.6 13.8817 13.6 14.2ZM18.4 14.2V17.8C18.4 17.9591 18.3368 18.1117 18.2243 18.2243C18.1117 18.3368 17.9591 18.4 17.8 18.4H14.8C14.6409 18.4 14.4883 18.3368 14.3757 18.2243C14.2632 18.1117 14.2 17.9591 14.2 17.8V14.2C14.2 14.0409 14.2632 13.8883 14.3757 13.7757C14.4883 13.6632 14.6409 13.6 14.8 13.6H17.8C17.9591 13.6 18.1117 13.6632 18.2243 13.7757C18.3368 13.8883 18.4 14.0409 18.4 14.2ZM3.7 12.4C3.77957 12.4 3.85587 12.3684 3.91213 12.3121C3.96839 12.2559 4 12.1796 4 12.1V11.5C4 11.1817 4.12643 10.8765 4.35147 10.6515C4.57652 10.4264 4.88174 10.3 5.2 10.3H9.7V12.1C9.7 12.1796 9.73161 12.2559 9.78787 12.3121C9.84413 12.3684 9.92043 12.4 10 12.4C10.0796 12.4 10.1559 12.3684 10.2121 12.3121C10.2684 12.2559 10.3 12.1796 10.3 12.1V10.3H14.8C15.1183 10.3 15.4235 10.4264 15.6485 10.6515C15.8736 10.8765 16 11.1817 16 11.5V12.1C16 12.1796 16.0316 12.2559 16.0879 12.3121C16.1441 12.3684 16.2204 12.4 16.3 12.4C16.3796 12.4 16.4559 12.3684 16.5121 12.3121C16.5684 12.2559 16.6 12.1796 16.6 12.1V11.5C16.5995 11.0228 16.4097 10.5652 16.0723 10.2277C15.7348 9.89027 15.2772 9.70048 14.8 9.7H10.3V7.9C10.3 7.82044 10.2684 7.74413 10.2121 7.68787C10.1559 7.63161 10.0796 7.6 10 7.6C9.92043 7.6 9.84413 7.63161 9.78787 7.68787C9.73161 7.74413 9.7 7.82044 9.7 7.9V9.7H5.2C4.72276 9.70048 4.2652 9.89027 3.92773 10.2277C3.59027 10.5652 3.40048 11.0228 3.4 11.5V12.1C3.4 12.1796 3.43161 12.2559 3.48787 12.3121C3.54413 12.3684 3.62044 12.4 3.7 12.4Z"
        fill="white"
        stroke="white"
        strokeWidth={0.2}
      />
    </g>
    <defs>
      <clipPath id="clip0_754_337">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const settingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.5 16.5C9.19863 15.2923 10.5045 14.4797 12 14.4797C13.4956 14.4797 14.8014 15.2923 15.5 16.5M14.0001 10C14.0001 11.1046 13.1046 12 12.0001 12C10.8955 12 10 11.1046 10 10C10 8.89543 10.8955 8 12.0001 8C13.1046 8 14.0001 8.89543 14.0001 10Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M22 13.9669V10.0332C19.1433 10.0332 17.2857 6.93041 18.732 4.46691L15.2679 2.5001C13.8038 4.99405 10.1978 4.99395 8.73363 2.5L5.26953 4.46681C6.71586 6.93035 4.85673 10.0332 2 10.0332V13.9669C4.85668 13.9669 6.71425 17.0697 5.26795 19.5332L8.73205 21.5C10.1969 19.0048 13.8046 19.0047 15.2695 21.4999L18.7336 19.5331C17.2874 17.0696 19.1434 13.9669 22 13.9669Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DiscountManagementIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 10C2 7.17157 2 5.75736 2.87868 4.87868C3.75736 4 5.17157 4 8 4H16C18.8284 4 20.2426 4 21.1213 4.87868C22 5.75736 22 7.17157 22 10V14C22 16.8284 22 18.2426 21.1213 19.1213C20.2426 20 18.8284 20 16 20H8C5.17157 20 3.75736 20 2.87868 19.1213C2 18.2426 2 16.8284 2 14V10Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 9.90429C6 5.35988 12 9.99015 12 13H8.5C6.7632 13 6 11.4699 6 9.90429Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 9.90429C18 5.35988 12 9.99015 12 13H15.5C17.2368 13 18 11.4699 18 9.90429Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 4V20"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 13H22"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 16L12 13L9 16"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const LaptopIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 14.5V6.5C20 4.61438 20 3.67157 19.4142 3.08579C18.8284 2.5 17.8856 2.5 16 2.5H8C6.11438 2.5 5.17157 2.5 4.58579 3.08579C4 3.67157 4 4.61438 4 6.5V14.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.49762 15.5154L4.01953 14.5H19.9518L20.5023 15.5154C21.9452 18.177 22.3046 19.5077 21.7561 20.5039C21.2077 21.5 19.7536 21.5 16.8454 21.5H7.15462C4.24642 21.5 2.79231 21.5 2.24387 20.5039C1.69543 19.5077 2.05474 18.177 3.49762 15.5154Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 7L16.4199 7.79289C16.8066 8.12623 17 8.29289 17 8.5C17 8.70711 16.8066 8.87377 16.4199 9.20711L15.5 10"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 7L7.58009 7.79289C7.19337 8.12623 7 8.29289 7 8.5C7 8.70711 7.19336 8.87377 7.58009 9.20711L8.5 10"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 6L11 11"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const IntelligenceIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.3702 16.2713L20.465 15.2776C21.5834 14.9184 21.8652 13.4928 20.9647 12.749L18.5414 10.7472M17.3702 16.2713L15.6246 16.8319C14.8533 17.0796 14.1247 17.441 13.464 17.9038L12.1229 18.8432M17.3702 16.2713L17.4325 14.7768C17.4671 13.9453 17.636 13.1245 17.9329 12.345L18.5414 10.7472M17.3702 16.2713L17.2401 19.3942C17.193 20.5254 15.9184 21.1841 14.942 20.5819L12.1229 18.8432M18.5414 10.7472L19.657 7.81789C20.0649 6.74666 19.1288 5.64722 17.9828 5.85166L14.7505 6.42828M18.5414 10.7472L17.3209 9.73905C16.6858 9.21445 16.1377 8.59606 15.6961 7.90606L14.7505 6.42828M12.1229 18.8432L9.43738 20.7242C8.50033 21.3805 7.19058 20.7997 7.07263 19.6754L6.74168 16.5208M12.1229 18.8432L10.5594 17.8788C9.87224 17.455 9.12342 17.1362 8.33865 16.9335L6.74168 16.5208M6.74168 16.5208L3.61989 15.7141C2.48271 15.4203 2.11569 14.0149 2.96854 13.22L5.2878 11.0584M6.74168 16.5208L6.43349 13.5832L5.2878 11.0584M5.2878 11.0584L4.00706 8.23589C3.53226 7.18955 4.40146 6.03466 5.55954 6.17312L8.85203 6.56678M5.2878 11.0584L6.58864 9.84595C7.1925 9.28313 7.70325 8.63126 8.10245 7.91385L8.85203 6.56678M8.85203 6.56678L10.4099 3.76716C10.9595 2.7795 12.3882 2.73674 12.998 3.68971L14.7505 6.42828M8.85203 6.56678L10.7141 6.78942C11.5126 6.88489 12.3213 6.86164 13.1127 6.72045L14.7505 6.42828"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const AnalyticsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M4.5 9V20"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 4V20"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 11V20"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 7V20"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5 14V20"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ActiveDiscountManagementIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 10C2 7.17157 2 5.75736 2.87868 4.87868C3.75736 4 5.17157 4 8 4H16C18.8284 4 20.2426 4 21.1213 4.87868C22 5.75736 22 7.17157 22 10V14C22 16.8284 22 18.2426 21.1213 19.1213C20.2426 20 18.8284 20 16 20H8C5.17157 20 3.75736 20 2.87868 19.1213C2 18.2426 2 16.8284 2 14V10Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 9.90429C6 5.35988 12 9.99015 12 13H8.5C6.7632 13 6 11.4699 6 9.90429Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 9.90429C18 5.35988 12 9.99015 12 13H15.5C17.2368 13 18 11.4699 18 9.90429Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 4V20"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 13H22"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 16L12 13L9 16"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DownArrow = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52722 5.52918C3.40224 5.65419 3.33203 5.82373 3.33203 6.00051C3.33203 6.17728 3.40224 6.34682 3.52722 6.47184L7.52722 10.4718C7.65224 10.5968 7.82178 10.667 7.99856 10.667C8.17533 10.667 8.34487 10.5968 8.46989 10.4718L12.4699 6.47184C12.5913 6.34611 12.6585 6.17771 12.657 6.00291C12.6555 5.82811 12.5854 5.6609 12.4618 5.5373C12.3382 5.41369 12.171 5.34358 11.9962 5.34206C11.8214 5.34054 11.653 5.40774 11.5272 5.52918L7.99856 9.05784L4.46989 5.52918C4.34487 5.40419 4.17533 5.33398 3.99856 5.33398C3.82178 5.33398 3.65224 5.40419 3.52722 5.52918Z"
      fill="#5C5B62"
    />
  </svg>
);
export const UpArrow = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: "rotate(180deg)",
    }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52722 5.52918C3.40224 5.65419 3.33203 5.82373 3.33203 6.00051C3.33203 6.17728 3.40224 6.34682 3.52722 6.47184L7.52722 10.4718C7.65224 10.5968 7.82178 10.667 7.99856 10.667C8.17533 10.667 8.34487 10.5968 8.46989 10.4718L12.4699 6.47184C12.5913 6.34611 12.6585 6.17771 12.657 6.00291C12.6555 5.82811 12.5854 5.6609 12.4618 5.5373C12.3382 5.41369 12.171 5.34358 11.9962 5.34206C11.8214 5.34054 11.653 5.40774 11.5272 5.52918L7.99856 9.05784L4.46989 5.52918C4.34487 5.40419 4.17533 5.33398 3.99856 5.33398C3.82178 5.33398 3.65224 5.40419 3.52722 5.52918Z"
      fill="#5C5B62"
    />
  </svg>
);
export const menubar = (
  <svg
    width={20}
    height={14}
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 1C15 0.447734 14.5523 0 14 0H1C0.447735 0 0 0.447734 0 1C0 1.55227 0.447735 2 1 2H14C14.5523 2 15 1.55223 15 1ZM1 6H19C19.5523 6 20 6.44777 20 7C20 7.55227 19.5523 8 19 8H1C0.447735 8 0 7.55227 0 7C0 6.44777 0.447735 6 1 6ZM1 12H10C10.5522 12 11 12.4477 11 13C11 13.5522 10.5522 14 10 14H1C0.447735 14 0 13.5522 0 13C0 12.4477 0.447735 12 1 12Z"
      fill="white"
    />
  </svg>
);
export const collapseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 6.56V17.44C20 18.8538 18.8539 20 17.44 20H6.56C5.14615 20 4 18.8538 4 17.44L4 6.56C4 5.14611 5.14615 4 6.56 4L17.44 4C18.8539 4 20 5.14611 20 6.56Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 16L8 8"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 15L12 12L15 9"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const close = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1244 7.7875L10.8806 10L13.1244 12.2125C13.1868 12.271 13.2366 12.3416 13.2706 12.4201C13.3047 12.4986 13.3222 12.5832 13.3222 12.6688C13.3222 12.7543 13.3047 12.8389 13.2706 12.9174C13.2366 12.9959 13.1868 13.0665 13.1244 13.125C13.066 13.1829 12.9967 13.2288 12.9206 13.2599C12.8444 13.291 12.7629 13.3067 12.6806 13.3063C12.5167 13.3056 12.3595 13.2405 12.2431 13.125L9.99937 10.8813L7.78687 13.125C7.67046 13.2405 7.51333 13.3056 7.34937 13.3063C7.26711 13.3067 7.18558 13.291 7.10943 13.2599C7.03328 13.2288 6.96402 13.1829 6.90562 13.125C6.78921 13.0079 6.72387 12.8495 6.72387 12.6844C6.72387 12.5193 6.78921 12.3609 6.90562 12.2438L9.11812 10L6.90562 7.7875C6.80323 7.66794 6.74972 7.51414 6.7558 7.35685C6.76187 7.19955 6.82708 7.05034 6.93839 6.93903C7.0497 6.82772 7.19891 6.76251 7.35621 6.75643C7.51351 6.75036 7.66731 6.80386 7.78687 6.90625L9.99937 9.11875L12.2119 6.90625C12.2697 6.84634 12.3388 6.79841 12.4152 6.7652C12.4916 6.73198 12.5738 6.71414 12.6571 6.71269C12.7404 6.71124 12.8231 6.72621 12.9006 6.75674C12.9781 6.78727 13.0488 6.83277 13.1087 6.89063C13.1687 6.94849 13.2166 7.01759 13.2498 7.09398C13.283 7.17037 13.3009 7.25255 13.3023 7.33583C13.3038 7.41911 13.2888 7.50187 13.2583 7.57936C13.2277 7.65686 13.1822 7.72759 13.1244 7.7875ZM16.1869 16.1875C14.9631 17.4111 13.404 18.2444 11.7067 18.5819C10.0094 18.9195 8.25012 18.7462 6.65131 18.0839C5.05251 17.4216 3.686 16.3001 2.72458 14.8611C1.76316 13.4222 1.25 11.7306 1.25 10C1.25 8.26946 1.76316 6.57777 2.72458 5.13886C3.686 3.69995 5.05251 2.57844 6.65131 1.91614C8.25012 1.25385 10.0094 1.08052 11.7067 1.41807C13.404 1.75562 14.9631 2.58888 16.1869 3.8125C16.9995 4.62503 17.6441 5.58966 18.0839 6.65132C18.5236 7.71298 18.75 8.85086 18.75 10C18.75 11.1491 18.5236 12.287 18.0839 13.3487C17.6441 14.4103 16.9995 15.375 16.1869 16.1875ZM15.3056 4.69375C14.2557 3.64747 12.9193 2.93575 11.4651 2.64847C10.011 2.36119 8.50432 2.51123 7.13539 3.07965C5.76647 3.64807 4.59666 4.60938 3.7737 5.84218C2.95074 7.07499 2.51153 8.524 2.51153 10.0063C2.51153 11.4885 2.95074 12.9375 3.7737 14.1703C4.59666 15.4031 5.76647 16.3644 7.13539 16.9329C8.50432 17.5013 10.011 17.6513 11.4651 17.364C12.9193 17.0768 14.2557 16.365 15.3056 15.3188C16.0048 14.622 16.5596 13.794 16.9381 12.8824C17.3167 11.9708 17.5115 10.9934 17.5115 10.0063C17.5115 9.01915 17.3167 8.04175 16.9381 7.13011C16.5596 6.21848 16.0048 5.39053 15.3056 4.69375Z"
      fill="#1B3C52"
    />
  </svg>
);
export const PlusIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99916 18.5706C9.77716 18.5706 9.56425 18.4824 9.40728 18.3254C9.2503 18.1684 9.16211 17.9555 9.16211 17.7335V2.26479C9.16211 2.04279 9.2503 1.82988 9.40728 1.6729C9.56425 1.51592 9.77716 1.42773 9.99916 1.42773C10.2212 1.42773 10.4341 1.51592 10.591 1.6729C10.748 1.82988 10.8362 2.04279 10.8362 2.26479V17.7335C10.8362 17.9555 10.748 18.1684 10.591 18.3254C10.4341 18.4824 10.2212 18.5706 9.99916 18.5706Z"
      fill="#000"
    />
    <path
      d="M17.7335 10.8362H2.26479C2.04279 10.8362 1.82988 10.748 1.6729 10.591C1.51592 10.4341 1.42773 10.2212 1.42773 9.99916C1.42773 9.77716 1.51592 9.56425 1.6729 9.40728C1.82988 9.2503 2.04279 9.16211 2.26479 9.16211H17.7335C17.9555 9.16211 18.1684 9.2503 18.3254 9.40728C18.4824 9.56425 18.5706 9.77716 18.5706 9.99916C18.5706 10.2212 18.4824 10.4341 18.3254 10.591C18.1684 10.748 17.9555 10.8362 17.7335 10.8362Z"
      fill="#000"
    />
  </svg>
);
export const DropDownArrowDown = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41 6.91196C4.25378 7.06823 4.16602 7.28015 4.16602 7.50112C4.16602 7.72209 4.25378 7.93402 4.41 8.09029L9.41 13.0903C9.56628 13.2465 9.7782 13.3343 9.99917 13.3343C10.2201 13.3343 10.4321 13.2465 10.5883 13.0903L15.5883 8.09029C15.7401 7.93312 15.8241 7.72262 15.8222 7.50412C15.8203 7.28563 15.7327 7.07662 15.5782 6.92211C15.4237 6.7676 15.2147 6.67996 14.9962 6.67806C14.7777 6.67616 14.5672 6.76016 14.41 6.91196L9.99917 11.3228L5.58834 6.91196C5.43206 6.75573 5.22014 6.66797 4.99917 6.66797C4.7782 6.66797 4.56628 6.75573 4.41 6.91196Z"
      fill="#030303"
    />
  </svg>
);
export const DropDownArrowUp = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: "rotate(180deg)",
    }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41 6.91196C4.25378 7.06823 4.16602 7.28015 4.16602 7.50112C4.16602 7.72209 4.25378 7.93402 4.41 8.09029L9.41 13.0903C9.56628 13.2465 9.7782 13.3343 9.99917 13.3343C10.2201 13.3343 10.4321 13.2465 10.5883 13.0903L15.5883 8.09029C15.7401 7.93312 15.8241 7.72262 15.8222 7.50412C15.8203 7.28563 15.7327 7.07662 15.5782 6.92211C15.4237 6.7676 15.2147 6.67996 14.9962 6.67806C14.7777 6.67616 14.5672 6.76016 14.41 6.91196L9.99917 11.3228L5.58834 6.91196C5.43206 6.75573 5.22014 6.66797 4.99917 6.66797C4.7782 6.66797 4.56628 6.75573 4.41 6.91196Z"
      fill="#030303"
    />
  </svg>
);
export const ExportIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9598 12.0625C17.794 12.0625 17.635 12.1283 17.5178 12.2456C17.4006 12.3628 17.3348 12.5217 17.3348 12.6875V14.8219C17.3348 15.325 17.1349 15.8074 16.7792 16.1632C16.4235 16.5189 15.941 16.7188 15.4379 16.7188H4.56289C4.05981 16.7188 3.57733 16.5189 3.2216 16.1632C2.86586 15.8074 2.66602 15.325 2.66602 14.8219V12.6875C2.66602 12.5217 2.60017 12.3628 2.48296 12.2456C2.36575 12.1283 2.20678 12.0625 2.04102 12.0625C1.87526 12.0625 1.71628 12.1283 1.59907 12.2456C1.48186 12.3628 1.41602 12.5217 1.41602 12.6875V14.8219C1.41684 15.6562 1.74865 16.4562 2.33863 17.0461C2.9286 17.6361 3.72854 17.9679 4.56289 17.9688H15.4379C16.2722 17.9679 17.0722 17.6361 17.6622 17.0461C18.2521 16.4562 18.5839 15.6562 18.5848 14.8219V12.6875C18.5848 12.5217 18.5189 12.3628 18.4017 12.2456C18.2845 12.1283 18.1255 12.0625 17.9598 12.0625Z"
      fill="white"
    />
    <path
      d="M9.55738 13.8875C9.61548 13.9461 9.68461 13.9926 9.76077 14.0243C9.83693 14.056 9.91862 14.0724 10.0011 14.0724C10.0836 14.0724 10.1653 14.056 10.2415 14.0243C10.3177 13.9926 10.3868 13.9461 10.4449 13.8875L14.0011 10.3313C14.1004 10.2119 14.1516 10.0598 14.1449 9.9047C14.1381 9.7496 14.0739 9.60256 13.9647 9.4922C13.8556 9.38184 13.7092 9.31607 13.5542 9.30769C13.3992 9.29931 13.2466 9.34893 13.1261 9.44687L10.6261 11.9469V2.65625C10.6261 2.49049 10.5603 2.33152 10.4431 2.21431C10.3259 2.0971 10.1669 2.03125 10.0011 2.03125C9.83537 2.03125 9.6764 2.0971 9.55919 2.21431C9.44198 2.33152 9.37613 2.49049 9.37613 2.65625V11.9375L6.87613 9.4375C6.75885 9.32022 6.59979 9.25434 6.43394 9.25434C6.26809 9.25434 6.10903 9.32022 5.99175 9.4375C5.87448 9.55478 5.80859 9.71383 5.80859 9.87969C5.80859 10.0455 5.87448 10.2046 5.99175 10.3219L9.55738 13.8875Z"
      fill="white"
    />
  </svg>
);
export const ImportIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.1413 7.3277C6.4863 7.3277 6.7663 7.6077 6.7663 7.9527C6.7663 8.2977 6.4863 8.5777 6.1413 8.5777H5.3638C4.01464 8.5777 2.91797 9.67437 2.91797 11.0227V15.0852C2.91797 16.4344 4.01464 17.531 5.3638 17.531H14.6388C15.9871 17.531 17.0846 16.4344 17.0846 15.0852V11.0152C17.0846 9.67104 15.9913 8.5777 14.648 8.5777H13.8621C13.5171 8.5777 13.2371 8.2977 13.2371 7.9527C13.2371 7.6077 13.5171 7.3277 13.8621 7.3277H14.648C16.6805 7.3277 18.3346 8.98187 18.3346 11.0152V15.0852C18.3346 17.1235 16.6763 18.781 14.6388 18.781H5.3638C3.3263 18.781 1.66797 17.1235 1.66797 15.0852V11.0227C1.66797 8.9852 3.3263 7.3277 5.3638 7.3277H6.1413ZM10.4435 1.8507L12.8735 4.2907C13.1168 4.5357 13.116 4.9307 12.8718 5.17404C12.6268 5.41737 12.2318 5.41737 11.9885 5.17237L10.6255 3.80466L10.626 12.9501H9.37597L9.37547 3.80466L8.0143 5.17237C7.89264 5.2957 7.7318 5.35654 7.5718 5.35654C7.41264 5.35654 7.25264 5.2957 7.13097 5.17404C6.8868 4.9307 6.88514 4.5357 7.1293 4.2907L9.55847 1.8507C9.79264 1.61487 10.2093 1.61487 10.4435 1.8507Z"
      fill="white"
    />
  </svg>
);
export const EditIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_421_3696)">
      <path
        d="M12.3759 8.0002C12.0302 8.0002 11.7509 8.28026 11.7509 8.62518V13.6254C11.7509 13.9697 11.4708 14.2504 11.1259 14.2504H2.37514C2.03009 14.2504 1.75013 13.9697 1.75013 13.6254V4.87506C1.75013 4.53069 2.03009 4.25008 2.37514 4.25008H7.37557C7.72121 4.25008 8.00058 3.97005 8.00058 3.6251C8.00058 3.28006 7.72121 3 7.37557 3H2.37514C1.34132 3 0.5 3.84129 0.5 4.87506V13.6254C0.5 14.6592 1.34132 15.5004 2.37514 15.5004H11.1259C12.1597 15.5004 13.001 14.6592 13.001 13.6254V8.62518C13.001 8.27958 12.7215 8.0002 12.3759 8.0002Z"
        fill="#1B3C52"
      />
      <path
        d="M6.35976 7.43036C6.31631 7.474 6.28656 7.52937 6.27414 7.58968L5.83225 9.79985C5.81166 9.90228 5.84415 10.0079 5.91787 10.0823C5.94696 10.1113 5.98148 10.1343 6.01945 10.1499C6.05743 10.1656 6.09812 10.1736 6.13919 10.1735C6.15912 10.1735 6.17983 10.1717 6.20043 10.1673L8.40999 9.72547C8.47123 9.71287 8.52684 9.68357 8.56999 9.63974L13.5154 4.69456L11.3058 2.48521L6.35976 7.43036ZM15.0429 0.957068C14.4336 0.347644 13.4422 0.347644 12.8334 0.957068L11.9683 1.82203L14.1779 4.03149L15.0429 3.16642C15.338 2.87206 15.5005 2.4795 15.5005 2.06201C15.5005 1.64451 15.338 1.25198 15.0429 0.957068Z"
        fill="#1B3C52"
      />
    </g>
    <defs>
      <clipPath id="clip0_421_3696">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const DeleteIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 4.66602C12.4899 4.66602 12.3203 4.73625 12.1953 4.86128C12.0702 4.9863 12 5.15587 12 5.33268V12.7933C11.9809 13.1305 11.8293 13.4464 11.5783 13.6723C11.3273 13.8982 10.9973 14.0157 10.66 13.9993H5.34C5.00273 14.0157 4.67266 13.8982 4.42167 13.6723C4.17069 13.4464 4.01912 13.1305 4 12.7933V5.33268C4 5.15587 3.92976 4.9863 3.80474 4.86128C3.67971 4.73625 3.51014 4.66602 3.33333 4.66602C3.15652 4.66602 2.98695 4.73625 2.86193 4.86128C2.7369 4.9863 2.66667 5.15587 2.66667 5.33268V12.7933C2.6857 13.4842 2.97772 14.1393 3.47879 14.6152C3.97985 15.0912 4.64912 15.3492 5.34 15.3327H10.66C11.3509 15.3492 12.0201 15.0912 12.5212 14.6152C13.0223 14.1393 13.3143 13.4842 13.3333 12.7933V5.33268C13.3333 5.15587 13.2631 4.9863 13.1381 4.86128C13.013 4.73625 12.8435 4.66602 12.6667 4.66602ZM13.3333 2.66602H10.6667V1.33268C10.6667 1.15587 10.5964 0.986302 10.4714 0.861278C10.3464 0.736253 10.1768 0.666016 10 0.666016H6C5.82319 0.666016 5.65362 0.736253 5.5286 0.861278C5.40357 0.986302 5.33333 1.15587 5.33333 1.33268V2.66602H2.66667C2.48986 2.66602 2.32029 2.73625 2.19526 2.86128C2.07024 2.9863 2 3.15587 2 3.33268C2 3.50949 2.07024 3.67906 2.19526 3.80409C2.32029 3.92911 2.48986 3.99935 2.66667 3.99935H13.3333C13.5101 3.99935 13.6797 3.92911 13.8047 3.80409C13.9298 3.67906 14 3.50949 14 3.33268C14 3.15587 13.9298 2.9863 13.8047 2.86128C13.6797 2.73625 13.5101 2.66602 13.3333 2.66602ZM6.66667 2.66602V1.99935H9.33333V2.66602H6.66667Z"
      fill="#1B3C52"
    />
    <path
      d="M7.33333 11.3333V6.66667C7.33333 6.48986 7.2631 6.32029 7.13807 6.19526C7.01305 6.07024 6.84348 6 6.66667 6C6.48986 6 6.32029 6.07024 6.19526 6.19526C6.07024 6.32029 6 6.48986 6 6.66667V11.3333C6 11.5101 6.07024 11.6797 6.19526 11.8047C6.32029 11.9298 6.48986 12 6.66667 12C6.84348 12 7.01305 11.9298 7.13807 11.8047C7.2631 11.6797 7.33333 11.5101 7.33333 11.3333ZM10 11.3333V6.66667C10 6.48986 9.92976 6.32029 9.80474 6.19526C9.67971 6.07024 9.51014 6 9.33333 6C9.15652 6 8.98695 6.07024 8.86193 6.19526C8.7369 6.32029 8.66667 6.48986 8.66667 6.66667V11.3333C8.66667 11.5101 8.7369 11.6797 8.86193 11.8047C8.98695 11.9298 9.15652 12 9.33333 12C9.51014 12 9.67971 11.9298 9.80474 11.8047C9.92976 11.6797 10 11.5101 10 11.3333Z"
      fill="#1B3C52"
    />
  </svg>
);
export const RestoreIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_421_3734)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.48184 2.00101V1.50001C3.48184 1.23479 3.37648 0.980437 3.18895 0.7929C3.00141 0.605364 2.74706 0.500007 2.48184 0.500007C2.21662 0.500007 1.96227 0.605364 1.77473 0.7929C1.5872 0.980437 1.48184 1.23479 1.48184 1.50001V4.50001C1.48184 4.76522 1.5872 5.01958 1.77473 5.20711C1.96227 5.39465 2.21662 5.50001 2.48184 5.50001H5.48184C5.74706 5.50001 6.00141 5.39465 6.18895 5.20711C6.37648 5.01958 6.48184 4.76522 6.48184 4.50001C6.48184 4.23479 6.37648 3.98044 6.18895 3.7929C6.00141 3.60536 5.74706 3.50001 5.48184 3.50001H4.82084C5.71534 2.87001 6.80584 2.50001 7.98184 2.50001C11.0173 2.50001 13.4818 4.96451 13.4818 8.00001C13.4818 11.0355 11.0173 13.5 7.98184 13.5C5.08884 13.5 2.71434 11.262 2.49784 8.42401C2.47404 8.16241 2.34826 7.92069 2.14769 7.75107C1.94712 7.58145 1.68786 7.49755 1.42595 7.51752C1.16403 7.53749 0.920485 7.65971 0.747943 7.85777C0.575401 8.05583 0.487717 8.31383 0.50384 8.57601C0.79884 12.4465 4.03634 15.5 7.98184 15.5C12.1213 15.5 15.4818 12.1395 15.4818 8.00001C15.4818 3.86051 12.1213 0.500007 7.98184 0.500007C6.35854 0.497758 4.77874 1.02471 3.48184 2.00101Z"
        fill="#1B3C52"
      />
    </g>
    <defs>
      <clipPath id="clip0_421_3734">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LeftArrow = (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6161 3.32293C11.8519 3.5251 11.8793 3.88021 11.6771 4.11608L7.49086 9.00001L11.6771 13.8839C11.8793 14.1198 11.8519 14.4749 11.6161 14.6771C11.3802 14.8793 11.0251 14.8519 10.8229 14.6161L6.32292 9.36608C6.14236 9.15543 6.14236 8.84459 6.32292 8.63394L10.8229 3.38394C11.0251 3.14807 11.3802 3.12075 11.6161 3.32293Z"
      fill="#4E5D78"
    />
  </svg>
);
export const RightArrow = (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.38394 3.32293C6.61981 3.12075 6.97492 3.14807 7.17709 3.38394L11.6771 8.63394C11.8576 8.84459 11.8576 9.15543 11.6771 9.36608L7.17709 14.6161C6.97492 14.8519 6.61981 14.8793 6.38394 14.6771C6.14807 14.4749 6.12075 14.1198 6.32293 13.8839L10.5092 9.00001L6.32293 4.11608C6.12075 3.88021 6.14807 3.5251 6.38394 3.32293Z"
      fill="#4E5D78"
    />
  </svg>
);
export const CloseIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9962 2.00525L2.00626 13.9927M14 14L2 2"
      stroke="#1B3C52"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const calendarIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_695_5586)">
      <path
        d="M17.4219 1.5625H15.625V0.625C15.625 0.279844 15.3452 0 15 0C14.6548 0 14.375 0.279844 14.375 0.625V1.5625H5.625V0.625C5.625 0.279844 5.3452 0 5 0C4.6548 0 4.375 0.279844 4.375 0.625V1.5625H2.57812C1.15652 1.5625 0 2.71902 0 4.14062V17.4219C0 18.8435 1.15652 20 2.57812 20H17.4219C18.8435 20 20 18.8435 20 17.4219V4.14062C20 2.71902 18.8435 1.5625 17.4219 1.5625ZM2.57812 2.8125H4.375V3.4375C4.375 3.78266 4.6548 4.0625 5 4.0625C5.3452 4.0625 5.625 3.78266 5.625 3.4375V2.8125H14.375V3.4375C14.375 3.78266 14.6548 4.0625 15 4.0625C15.3452 4.0625 15.625 3.78266 15.625 3.4375V2.8125H17.4219C18.1542 2.8125 18.75 3.40828 18.75 4.14062V5.625H1.25V4.14062C1.25 3.40828 1.84578 2.8125 2.57812 2.8125ZM17.4219 18.75H2.57812C1.84578 18.75 1.25 18.1542 1.25 17.4219V6.875H18.75V17.4219C18.75 18.1542 18.1542 18.75 17.4219 18.75Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_695_5586">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadImageIcon = (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.659 18.3786C39.3481 9.17282 30.0122 3.58339 20.8063 5.89427C13.6122 7.70023 8.38845 13.918 7.85023 21.3157C2.7421 22.1581 -0.716022 26.9819 0.126366 32.09C0.87521 36.6312 4.81013 39.957 9.41256 39.9387H17.2242V36.814H9.41256C5.96118 36.814 3.16324 34.0161 3.16324 30.5647C3.16324 27.1133 5.96118 24.3154 9.41256 24.3154C10.2755 24.3154 10.9749 23.616 10.9749 22.7531C10.9671 14.9874 17.2561 8.68576 25.0218 8.67805C31.7441 8.67131 37.5309 13.4237 38.8312 20.019C38.8938 20.3401 39.0557 20.6335 39.2939 20.8578C39.5322 21.082 39.8348 21.2258 40.1592 21.2689C44.4304 21.8771 47.3997 25.8326 46.7916 30.1037C46.2454 33.9391 42.9708 36.7947 39.0968 36.814H32.8475V39.9387H39.0968C45.1368 39.9204 50.0183 35.0093 49.9999 28.9693C49.9847 23.9415 46.5433 19.5718 41.659 18.3786Z"
      fill="black"
    />
    <path
      d="M23.9271 24.7688L17.6777 31.0181L19.8806 33.221L23.474 29.6433V44.626H26.5986V29.6433L30.1764 33.221L32.3793 31.0181L26.1299 24.7688C25.5205 24.163 24.5365 24.163 23.9271 24.7688Z"
      fill="black"
    />
  </svg>
);
export const ThreeDots = (
  <svg
    width={18}
    height={19}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4746 9.5L11.455 9.75325L11.4157 9.98701L11.3568 10.2208L11.2782 10.4545L11.18 10.6688L11.0425 10.8636L10.905 11.0584L10.7478 11.2338L10.571 11.3896L10.3746 11.526L10.1782 11.6623L9.96211 11.7597L9.7264 11.8377L9.49068 11.8961L9.25497 11.9351L8.99961 11.9545L8.74425 11.9351L8.50854 11.8961L8.27282 11.8377L8.03711 11.7597L7.82104 11.6623L7.62461 11.526L7.42818 11.3896L7.25139 11.2338L7.09425 11.0584L6.95675 10.8636L6.81925 10.6688L6.72104 10.4545L6.64247 10.2208L6.58354 9.98701L6.54425 9.75325L6.52461 9.5L6.54425 9.24675L6.58354 9.01299L6.64247 8.77922L6.72104 8.54545L6.81925 8.33117L6.95675 8.13636L7.09425 7.94156L7.25139 7.76623L7.42818 7.61039L7.62461 7.47403L7.82104 7.33766L8.03711 7.24026L8.27282 7.16234L8.50854 7.1039L8.74425 7.06494L8.99961 7.04546L9.25497 7.06494L9.49068 7.1039L9.72639 7.16234L9.96211 7.24026L10.1782 7.33766L10.3746 7.47403L10.571 7.61039L10.7478 7.76623L10.905 7.94156L11.0425 8.13636L11.18 8.33117L11.2782 8.54545L11.3568 8.77922L11.4157 9.01299L11.455 9.24675L11.4746 9.5ZM11.4746 2.95455L11.455 3.20779L11.4157 3.44156L11.3568 3.67532L11.2782 3.90909L11.18 4.12338L11.0425 4.31818L10.905 4.51299L10.7478 4.68831L10.571 4.84416L10.3746 4.98052L10.1782 5.11688L9.96211 5.21429L9.72639 5.29221L9.49068 5.35065L9.25497 5.38961L8.99961 5.40909L8.74425 5.38961L8.50854 5.35065L8.27282 5.29221L8.03711 5.21429L7.82104 5.11688L7.62461 4.98052L7.42818 4.84416L7.25139 4.68831L7.09425 4.51299L6.95675 4.31818L6.81925 4.12338L6.72104 3.90909L6.64247 3.67532L6.58354 3.44156L6.54425 3.20779L6.52461 2.95455L6.54425 2.7013L6.58354 2.46753L6.64247 2.23377L6.72104 2L6.81925 1.78571L6.95675 1.59091L7.09425 1.3961L7.25139 1.22078L7.42818 1.06494L7.62461 0.928571L7.82104 0.792208L8.03711 0.694805L8.27282 0.616883L8.50854 0.558442L8.74425 0.519481L8.99961 0.5L9.25497 0.519481L9.49068 0.558442L9.72639 0.616883L9.96211 0.694805L10.1782 0.792208L10.3746 0.928571L10.571 1.06494L10.7478 1.22078L10.905 1.3961L11.0425 1.59091L11.18 1.78571L11.2782 2L11.3568 2.23377L11.4157 2.46753L11.455 2.7013L11.4746 2.95455ZM11.4746 16.0455L11.455 16.2987L11.4157 16.5325L11.3568 16.7662L11.2782 17L11.18 17.2143L11.0425 17.4091L10.905 17.6039L10.7478 17.7792L10.571 17.9351L10.3746 18.0714L10.1782 18.2078L9.96211 18.3052L9.7264 18.3831L9.49068 18.4416L9.25497 18.4805L8.99961 18.5L8.74425 18.4805L8.50854 18.4416L8.27282 18.3831L8.03711 18.3052L7.82104 18.2078L7.62461 18.0714L7.42818 17.9351L7.25139 17.7792L7.09425 17.6039L6.95675 17.4091L6.81925 17.2143L6.72104 17L6.64247 16.7662L6.58354 16.5325L6.54425 16.2987L6.52461 16.0455L6.54425 15.7922L6.58354 15.5584L6.64247 15.3247L6.72104 15.0909L6.81925 14.8766L6.95675 14.6818L7.09425 14.487L7.25139 14.3117L7.42818 14.1558L7.62461 14.0195L7.82104 13.8831L8.03711 13.7857L8.27282 13.7078L8.50854 13.6494L8.74425 13.6104L8.99961 13.5909L9.25497 13.6104L9.49068 13.6494L9.7264 13.7078L9.96211 13.7857L10.1782 13.8831L10.3746 14.0195L10.571 14.1558L10.7478 14.3117L10.905 14.487L11.0425 14.6818L11.18 14.8766L11.2782 15.0909L11.3568 15.3247L11.4157 15.5584L11.455 15.7922L11.4746 16.0455Z"
      fill="#49454E"
    />
  </svg>
);
export const DarkDocumentIcon = (
  <svg
    width={11}
    height={14}
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1155 8.38462V6.76923C10.1155 5.62218 9.18566 4.69231 8.03861 4.69231H7.11553C6.73318 4.69231 6.42323 4.38235 6.42323 4V3.07692C6.42323 1.92987 5.49336 1 4.3463 1H3.19246M3.654 9.76923V10.2308M5.50015 8.38462V10.2308M7.3463 7V10.2308M4.57707 1H1.57707C1.19472 1 0.884766 1.30996 0.884766 1.69231V12.3077C0.884766 12.69 1.19472 13 1.57707 13H9.42323C9.80558 13 10.1155 12.69 10.1155 12.3077V6.53846C10.1155 3.47965 7.63588 1 4.57707 1Z"
      stroke="#030303"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Completed = (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_434_4870)">
      <mask
        id="mask0_434_4870"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={14}
        height={14}
      >
        <path d="M14 0H0V14H14V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_434_4870)">
        <path
          d="M9.7083 5.16517L6.03949 8.83398L4.29297 7.08749"
          stroke="#00B051"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask
          id="mask1_434_4870"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={14}
          height={14}
        >
          <path d="M0 4.19617e-05H14V14H0V4.19617e-05Z" fill="white" />
        </mask>
        <g mask="url(#mask1_434_4870)">
          <path
            d="M13.4531 7.00002C13.4531 10.564 10.5639 13.4531 6.99998 13.4531C3.43603 13.4531 0.546875 10.564 0.546875 7.00002C0.546875 3.43607 3.43603 0.546911 6.99998 0.546911C10.5639 0.546911 13.4531 3.43607 13.4531 7.00002Z"
            stroke="#00B051"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_434_4870">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const EyesIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8983 7.68808C15.7553 7.49255 12.3496 2.90039 7.9999 2.90039C3.65018 2.90039 0.244309 7.49255 0.101528 7.68789C0.0355528 7.77828 0 7.88728 0 7.99919C0 8.11109 0.0355528 8.2201 0.101528 8.31048C0.244309 8.50602 3.65018 13.0982 7.9999 13.0982C12.3496 13.0982 15.7553 8.50599 15.8983 8.31064C15.9643 8.2203 16 8.11128 16 7.99936C16 7.88744 15.9643 7.77842 15.8983 7.68808ZM7.9999 12.0432C4.79587 12.0432 2.02084 8.99533 1.19937 7.99892C2.01978 7.00164 4.789 3.95533 7.9999 3.95533C11.2038 3.95533 13.9786 7.0027 14.8004 7.99964C13.98 8.99689 11.2108 12.0432 7.9999 12.0432Z"
      fill="black"
    />
    <path
      d="M8.00078 4.83398C6.25572 4.83398 4.83594 6.25377 4.83594 7.99883C4.83594 9.74389 6.25572 11.1637 8.00078 11.1637C9.74584 11.1637 11.1656 9.74389 11.1656 7.99883C11.1656 6.25377 9.74584 4.83398 8.00078 4.83398ZM8.00078 10.1087C6.83734 10.1087 5.89091 9.16223 5.89091 7.99883C5.89091 6.83542 6.83737 5.88895 8.00078 5.88895C9.16419 5.88895 10.1107 6.83542 10.1107 7.99883C10.1107 9.16223 9.16422 10.1087 8.00078 10.1087Z"
      fill="black"
    />
  </svg>
);
export const CheckTrueIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.13737 6.48098C1.89575 6.48166 1.65926 6.55073 1.45525 6.6802C1.25125 6.80968 1.08807 6.99427 0.984601 7.21261C0.881129 7.43096 0.84159 7.67414 0.870559 7.91402C0.899528 8.1539 0.99582 8.38067 1.1483 8.56811L4.39872 12.5499C4.51461 12.6938 4.66317 12.808 4.83205 12.8829C5.00093 12.9579 5.18526 12.9915 5.36973 12.9809C5.76426 12.9597 6.12045 12.7486 6.34755 12.4016L13.0995 1.52762C13.1006 1.5258 13.1018 1.524 13.1029 1.52223C13.1663 1.42496 13.1458 1.23219 13.015 1.11109C12.9791 1.07783 12.9367 1.05228 12.8905 1.03601C12.8444 1.01974 12.7954 1.0131 12.7465 1.01648C12.6977 1.01987 12.6501 1.03322 12.6066 1.05571C12.5631 1.0782 12.5247 1.10935 12.4937 1.14725C12.4913 1.15023 12.4888 1.15316 12.4862 1.15605L5.67678 8.8497C5.65087 8.87897 5.6194 8.90281 5.5842 8.91982C5.549 8.93684 5.51077 8.94668 5.47173 8.9488C5.43269 8.95091 5.39362 8.94524 5.35679 8.93212C5.31996 8.91901 5.28611 8.89871 5.25719 8.87239L2.99726 6.81585C2.76255 6.60069 2.45578 6.48122 2.13737 6.48098Z"
      fill="#00D261"
    />
  </svg>
);
export const ActionThreeDots = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6.5C7.173 6.5 6.5 7.173 6.5 8C6.5 8.827 7.173 9.5 8 9.5C8.827 9.5 9.5 8.827 9.5 8C9.5 7.173 8.827 6.5 8 6.5ZM3 6.5C2.173 6.5 1.5 7.173 1.5 8C1.5 8.827 2.173 9.5 3 9.5C3.827 9.5 4.5 8.827 4.5 8C4.5 7.173 3.827 6.5 3 6.5ZM13 6.5C12.173 6.5 11.5 7.173 11.5 8C11.5 8.827 12.173 9.5 13 9.5C13.827 9.5 14.5 8.827 14.5 8C14.5 7.173 13.827 6.5 13 6.5Z"
      fill="black"
    />
  </svg>
);
export const LiTrueIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 48 48"
  >
    <rect x={0} y={0} width={48} height={48} rx={8} ry={8} fill="#4CAF50" />
    <path fill="#fff" d="M20.5 31.5l-7-7 2.1-2.1 4.9 4.9 13-13 2.1 2.1z" />
  </svg>
);
export const InputCheckTrueIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={0.4}>
      <path
        d="M15.5827 6C15.2494 5.66667 14.7493 5.66667 14.416 6L8.16602 12.25L5.58268 9.66667C5.24935 9.33333 4.74935 9.33333 4.41602 9.66667C4.08268 10 4.08268 10.5 4.41602 10.8333L7.58268 14C7.74935 14.1667 7.91602 14.25 8.16602 14.25C8.41602 14.25 8.58268 14.1667 8.74935 14L15.5827 7.16667C15.916 6.83333 15.916 6.33333 15.5827 6Z"
        fill="#081536"
      />
    </g>
  </svg>
);

export const DownloadIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3678 9.65039C14.2352 9.65039 14.108 9.70307 14.0143 9.79684C13.9205 9.89061 13.8678 10.0178 13.8678 10.1504V11.8579C13.8678 12.2604 13.7079 12.6463 13.4233 12.9309C13.1388 13.2155 12.7528 13.3754 12.3503 13.3754H3.65031C3.24785 13.3754 2.86186 13.2155 2.57728 12.9309C2.29269 12.6463 2.13281 12.2604 2.13281 11.8579V10.1504C2.13281 10.0178 2.08013 9.89061 1.98637 9.79684C1.8926 9.70307 1.76542 9.65039 1.63281 9.65039C1.5002 9.65039 1.37303 9.70307 1.27926 9.79684C1.18549 9.89061 1.13281 10.0178 1.13281 10.1504V11.8579C1.13347 12.5254 1.39892 13.1653 1.8709 13.6373C2.34288 14.1093 2.98283 14.3747 3.65031 14.3754H12.3503C13.0178 14.3747 13.6577 14.1093 14.1297 13.6373C14.6017 13.1653 14.8672 12.5254 14.8678 11.8579V10.1504C14.8678 10.0178 14.8151 9.89061 14.7214 9.79684C14.6276 9.70307 14.5004 9.65039 14.3678 9.65039Z"
      fill="#1B3C52"
    />
    <path
      d="M7.64551 11.11C7.69199 11.1569 7.74729 11.1941 7.80822 11.2194C7.86915 11.2448 7.93451 11.2579 8.00051 11.2579C8.06652 11.2579 8.13187 11.2448 8.1928 11.2194C8.25373 11.1941 8.30903 11.1569 8.35551 11.11L11.2005 8.265C11.2799 8.16948 11.3209 8.04784 11.3155 7.92376C11.3101 7.79968 11.2588 7.68205 11.1714 7.59376C11.0841 7.50547 10.967 7.45286 10.843 7.44615C10.7189 7.43945 10.5969 7.47914 10.5005 7.5575L8.50051 9.5575V2.125C8.50051 1.99239 8.44783 1.86521 8.35407 1.77145C8.2603 1.67768 8.13312 1.625 8.00051 1.625C7.8679 1.625 7.74073 1.67768 7.64696 1.77145C7.55319 1.86521 7.50051 1.99239 7.50051 2.125V9.55L5.50051 7.55C5.40669 7.45618 5.27944 7.40347 5.14676 7.40347C5.01408 7.40347 4.88683 7.45618 4.79301 7.55C4.69919 7.64382 4.64648 7.77107 4.64648 7.90375C4.64648 8.03643 4.69919 8.16368 4.79301 8.2575L7.64551 11.11Z"
      fill="#1B3C52"
    />
  </svg>
);
export const LeftArrowIcon = (
  <svg
    width={14}
    height={15}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91602 7.49935H11.0827M11.0827 7.49935L8.74935 9.83268M11.0827 7.49935L8.74935 5.16602"
      stroke="#1B3C52"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SignatureIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_759_6197)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2493 5.9756V2.49935C16.2493 2.22576 16.1955 1.95485 16.0908 1.70209C15.9861 1.44933 15.8326 1.21967 15.6392 1.02621C15.4457 0.832754 15.216 0.679297 14.9633 0.5746C14.7105 0.469903 14.4396 0.416016 14.166 0.416016H2.49935C2.22576 0.416016 1.95485 0.469903 1.70209 0.5746C1.44933 0.679297 1.21967 0.832754 1.02621 1.02621C0.635509 1.41691 0.416016 1.94681 0.416016 2.49935V17.4993C0.416016 18.0519 0.635509 18.5818 1.02621 18.9725C1.21967 19.1659 1.44933 19.3194 1.70209 19.4241C1.95485 19.5288 2.22576 19.5827 2.49935 19.5827H14.166C14.7186 19.5827 15.2485 19.3632 15.6392 18.9725C16.0299 18.5818 16.2493 18.0519 16.2493 17.4993V14.0231C16.2493 13.9126 16.2055 13.8066 16.1273 13.7285C16.0492 13.6503 15.9432 13.6064 15.8327 13.6064C15.7222 13.6064 15.6162 13.6503 15.5381 13.7285C15.4599 13.8066 15.416 13.9126 15.416 14.0231V17.4993C15.416 17.8309 15.2843 18.1488 15.0499 18.3832C14.8155 18.6177 14.4975 18.7493 14.166 18.7493H2.49935C2.16783 18.7493 1.84989 18.6177 1.61547 18.3832C1.38105 18.1488 1.24935 17.8309 1.24935 17.4993V2.49935C1.24935 2.16783 1.38105 1.84989 1.61547 1.61547C1.84989 1.38105 2.16783 1.24935 2.49935 1.24935H14.166C14.4975 1.24935 14.8155 1.38105 15.0499 1.61547C15.2843 1.84989 15.416 2.16783 15.416 2.49935V5.9756C15.416 6.08611 15.4599 6.19209 15.5381 6.27023C15.6162 6.34837 15.7222 6.39227 15.8327 6.39227C15.9432 6.39227 16.0492 6.34837 16.1273 6.27023C16.2055 6.19209 16.2493 6.08611 16.2493 5.9756Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.7706 16.535C8.74628 16.6084 8.74285 16.6871 8.76069 16.7624C8.77852 16.8376 8.81692 16.9064 8.8716 16.9611C8.92628 17.0158 8.99508 17.0542 9.07032 17.072C9.14556 17.0898 9.22428 17.0864 9.29768 17.0621L11.611 16.2908C11.7953 16.2296 11.9626 16.1262 12.0998 15.9888L19.2881 8.80042C19.4043 8.68446 19.4965 8.54671 19.5595 8.39507C19.6224 8.24342 19.6548 8.08085 19.6548 7.91667C19.6548 7.75248 19.6224 7.58991 19.5595 7.43827C19.4965 7.28662 19.4043 7.14887 19.2881 7.03292L18.7998 6.54458C18.5654 6.31024 18.2475 6.1786 17.916 6.1786C17.5846 6.1786 17.2667 6.31024 17.0323 6.54458L9.84393 13.7329C9.70643 13.87 9.6031 14.0375 9.54185 14.2217L8.7706 16.535ZM9.82477 16.0079L10.8948 15.6513L10.1814 14.9379L9.82477 16.0079ZM10.5885 14.1667L11.666 15.2442L17.3268 9.58333L16.2493 8.50583L10.5885 14.1667ZM17.916 8.99417L16.8385 7.91667L17.6214 7.13375C17.6997 7.05584 17.8056 7.0121 17.916 7.0121C18.0264 7.0121 18.1324 7.05584 18.2106 7.13375L18.6989 7.62208C18.7768 7.70033 18.8206 7.80625 18.8206 7.91667C18.8206 8.02708 18.7768 8.13301 18.6989 8.21125L17.916 8.99417ZM3.33268 17.0833H4.16602C4.24339 17.0834 4.31925 17.0619 4.38506 17.0211C4.45087 16.9804 4.50401 16.9222 4.53852 16.8529L4.99935 15.9317L5.46018 16.8529C5.49468 16.9222 5.54783 16.9804 5.61364 17.0211C5.67944 17.0619 5.7553 17.0834 5.83268 17.0833H7.49935C7.60986 17.0833 7.71584 17.0394 7.79398 16.9613C7.87212 16.8832 7.91602 16.7772 7.91602 16.6667C7.91602 16.5562 7.87212 16.4502 7.79398 16.372C7.71584 16.2939 7.60986 16.25 7.49935 16.25H6.09018L5.37185 14.8138C5.33743 14.7444 5.28432 14.686 5.21851 14.6452C5.15269 14.6044 5.07679 14.5827 4.99935 14.5827C4.92191 14.5827 4.846 14.6044 4.78019 14.6452C4.71438 14.686 4.66127 14.7444 4.62685 14.8138L3.90852 16.25H3.33268C3.22218 16.25 3.11619 16.2939 3.03805 16.372C2.95991 16.4502 2.91602 16.5562 2.91602 16.6667C2.91602 16.7772 2.95991 16.8832 3.03805 16.9613C3.11619 17.0394 3.22218 17.0833 3.33268 17.0833ZM4.16602 4.58333H12.4993C12.6099 4.58333 12.7158 4.53943 12.794 4.46129C12.8721 4.38315 12.916 4.27717 12.916 4.16667C12.916 4.05616 12.8721 3.95018 12.794 3.87204C12.7158 3.7939 12.6099 3.75 12.4993 3.75H4.16602C4.05551 3.75 3.94953 3.7939 3.87139 3.87204C3.79325 3.95018 3.74935 4.05616 3.74935 4.16667C3.74935 4.27717 3.79325 4.38315 3.87139 4.46129C3.94953 4.53943 4.05551 4.58333 4.16602 4.58333ZM4.16602 7.08333H12.4993C12.6099 7.08333 12.7158 7.03944 12.794 6.96129C12.8721 6.88315 12.916 6.77717 12.916 6.66667C12.916 6.55616 12.8721 6.45018 12.794 6.37204C12.7158 6.2939 12.6099 6.25 12.4993 6.25H4.16602C4.05551 6.25 3.94953 6.2939 3.87139 6.37204C3.79325 6.45018 3.74935 6.55616 3.74935 6.66667C3.74935 6.77717 3.79325 6.88315 3.87139 6.96129C3.94953 7.03944 4.05551 7.08333 4.16602 7.08333ZM4.16602 9.58333H12.4993C12.6099 9.58333 12.7158 9.53944 12.794 9.4613C12.8721 9.38315 12.916 9.27717 12.916 9.16667C12.916 9.05616 12.8721 8.95018 12.794 8.87204C12.7158 8.7939 12.6099 8.75 12.4993 8.75H4.16602C4.05551 8.75 3.94953 8.7939 3.87139 8.87204C3.79325 8.95018 3.74935 9.05616 3.74935 9.16667C3.74935 9.27717 3.79325 9.38315 3.87139 9.4613C3.94953 9.53944 4.05551 9.58333 4.16602 9.58333ZM4.16602 12.0833H9.99935C10.1099 12.0833 10.2158 12.0394 10.294 11.9613C10.3721 11.8832 10.416 11.7772 10.416 11.6667C10.416 11.5562 10.3721 11.4502 10.294 11.372C10.2158 11.2939 10.1099 11.25 9.99935 11.25H4.16602C4.05551 11.25 3.94953 11.2939 3.87139 11.372C3.79325 11.4502 3.74935 11.5562 3.74935 11.6667C3.74935 11.7772 3.79325 11.8832 3.87139 11.9613C3.94953 12.0394 4.05551 12.0833 4.16602 12.0833Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_759_6197">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const OnboardingDashIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0894 15.6113H12.6597C12.5769 15.6113 12.4974 15.5784 12.4388 15.5198C12.3802 15.4612 12.3472 15.3817 12.3472 15.2988C12.3472 15.2159 12.3802 15.1365 12.4388 15.0779C12.4974 15.0193 12.5769 14.9863 12.6597 14.9863H13.0894C13.1723 14.9863 13.2518 15.0193 13.3104 15.0779C13.369 15.1365 13.4019 15.2159 13.4019 15.2988C13.4019 15.3817 13.369 15.4612 13.3104 15.5198C13.2518 15.5784 13.1723 15.6113 13.0894 15.6113ZM14.6418 15.6113H14.2144C14.1315 15.6113 14.0521 15.5784 13.9935 15.5198C13.9348 15.4612 13.9019 15.3817 13.9019 15.2988C13.9019 15.2159 13.9348 15.1365 13.9935 15.0779C14.0521 15.0193 14.1315 14.9863 14.2144 14.9863H14.6418C14.7246 14.9863 14.8041 15.0193 14.8627 15.0779C14.9213 15.1365 14.9543 15.2159 14.9543 15.2988C14.9543 15.3817 14.9213 15.4612 14.8627 15.5198C14.8041 15.5784 14.7246 15.6113 14.6418 15.6113ZM16.1945 15.6113H15.7367C15.6538 15.6113 15.5743 15.5784 15.5157 15.5198C15.4571 15.4612 15.4242 15.3817 15.4242 15.2988C15.4242 15.2159 15.4571 15.1365 15.5157 15.0779C15.5743 15.0193 15.6538 14.9863 15.7367 14.9863H16.1945C16.2774 14.9863 16.3569 15.0193 16.4155 15.0779C16.4741 15.1365 16.507 15.2159 16.507 15.2988C16.507 15.3817 16.4741 15.4612 16.4155 15.5198C16.3569 15.5784 16.2774 15.6113 16.1945 15.6113ZM8.22106 18.6711C8.17382 18.6711 8.12717 18.6605 8.08464 18.6399C8.0421 18.6193 8.00479 18.5894 7.9755 18.5523C7.94621 18.5152 7.9257 18.472 7.91553 18.4259C7.90536 18.3797 7.90578 18.3319 7.91677 18.2859L8.43278 16.132C8.44235 16.0921 8.45968 16.0545 8.4838 16.0213C8.50791 15.9881 8.53832 15.9599 8.57331 15.9385C8.60829 15.917 8.64716 15.9027 8.68769 15.8962C8.72823 15.8898 8.76963 15.8914 8.80954 15.901C8.84945 15.9105 8.88708 15.9279 8.92029 15.952C8.95351 15.9761 8.98164 16.0065 9.0031 16.0415C9.02455 16.0765 9.03891 16.1154 9.04534 16.1559C9.05177 16.1964 9.05016 16.2378 9.04059 16.2777L8.52458 18.4309C8.50834 18.4992 8.46956 18.56 8.4145 18.6036C8.35943 18.6472 8.29129 18.671 8.22106 18.6711ZM11.7781 18.6711C11.7061 18.671 11.6363 18.646 11.5805 18.6004C11.5248 18.5548 11.4866 18.4913 11.4722 18.4207L11.0343 16.2676C11.0262 16.2274 11.026 16.1859 11.0338 16.1456C11.0416 16.1054 11.0573 16.067 11.08 16.0328C11.1026 15.9986 11.1318 15.9691 11.1658 15.9462C11.1999 15.9232 11.2381 15.9072 11.2783 15.899C11.3185 15.8908 11.3599 15.8907 11.4002 15.8985C11.4405 15.9063 11.4789 15.922 11.5131 15.9447C11.5473 15.9673 11.5767 15.9965 11.5997 16.0305C11.6226 16.0645 11.6387 16.1028 11.6468 16.143L12.0847 18.2965C12.0939 18.3419 12.0929 18.3888 12.0818 18.4338C12.0706 18.4787 12.0496 18.5207 12.0203 18.5565C11.9909 18.5924 11.954 18.6213 11.9121 18.6411C11.8702 18.6609 11.8244 18.6711 11.7781 18.6711Z"
      fill="black"
    />
    <path
      d="M13.0072 18.6711H6.97247C6.88959 18.6711 6.81011 18.6382 6.7515 18.5796C6.6929 18.521 6.65997 18.4415 6.65997 18.3586C6.65997 18.2757 6.6929 18.1962 6.7515 18.1376C6.81011 18.079 6.88959 18.0461 6.97247 18.0461H13.0072C13.0901 18.0461 13.1696 18.079 13.2282 18.1376C13.2868 18.1962 13.3197 18.2757 13.3197 18.3586C13.3197 18.4415 13.2868 18.521 13.2282 18.5796C13.1696 18.6382 13.0901 18.6711 13.0072 18.6711ZM17.099 16.5176H2.90099C2.78921 16.5201 2.67807 16.5 2.57429 16.4584C2.4705 16.4168 2.37622 16.3546 2.29715 16.2756C2.21807 16.1966 2.15583 16.1023 2.11419 15.9985C2.07256 15.8948 2.05239 15.7837 2.0549 15.6719V6.98281C2.0549 6.49961 2.42638 6.12109 2.90099 6.12109H6.04396C6.12684 6.12109 6.20632 6.15402 6.26493 6.21262C6.32353 6.27123 6.35646 6.35071 6.35646 6.43359C6.35646 6.51647 6.32353 6.59596 6.26493 6.65456C6.20632 6.71317 6.12684 6.74609 6.04396 6.74609H2.90099C2.72638 6.74609 2.6799 6.89492 2.6799 6.98281V15.6719C2.6799 15.7383 2.70138 15.8926 2.90099 15.8926H17.099C17.1283 15.8936 17.1574 15.8885 17.1845 15.8778C17.2117 15.867 17.2364 15.8508 17.257 15.8301C17.2777 15.8094 17.2938 15.7846 17.3045 15.7574C17.3151 15.7302 17.32 15.7011 17.319 15.6719V6.98281C17.319 6.86836 17.2307 6.74609 17.099 6.74609H13.9549C13.872 6.74609 13.7925 6.71317 13.7339 6.65456C13.6753 6.59596 13.6424 6.51647 13.6424 6.43359C13.6424 6.35071 13.6753 6.27123 13.7339 6.21262C13.7925 6.15402 13.872 6.12109 13.9549 6.12109H17.099C17.3253 6.12357 17.5413 6.21569 17.6997 6.37723C17.8581 6.53878 17.9459 6.75657 17.944 6.98281V15.6719C17.9452 15.7832 17.9242 15.8937 17.8822 15.9968C17.8402 16.0999 17.778 16.1936 17.6993 16.2724C17.6206 16.3512 17.527 16.4134 17.4239 16.4555C17.3208 16.4976 17.2104 16.5187 17.099 16.5176Z"
      fill="black"
    />
    <path
      d="M17.6313 14.7059H2.36719C2.28431 14.7059 2.20482 14.6729 2.14622 14.6143C2.08761 14.5557 2.05469 14.4762 2.05469 14.3934C2.05469 14.3105 2.08761 14.231 2.14622 14.1724C2.20482 14.1138 2.28431 14.0809 2.36719 14.0809H17.6313C17.7141 14.0809 17.7936 14.1138 17.8522 14.1724C17.9108 14.231 17.9438 14.3105 17.9438 14.3934C17.9438 14.4762 17.9108 14.5557 17.8522 14.6143C17.7936 14.6729 17.7141 14.7059 17.6313 14.7059ZM12.8559 11.7449H7.14258C6.7684 11.7445 6.40966 11.5957 6.14508 11.3311C5.88049 11.0665 5.73166 10.7078 5.73125 10.3336V2.73945C5.73166 2.36527 5.88049 2.00654 6.14508 1.74195C6.40966 1.47736 6.7684 1.32854 7.14258 1.32812H12.8559C13.23 1.32854 13.5888 1.47736 13.8534 1.74195C14.1179 2.00654 14.2668 2.36527 14.2672 2.73945V10.3336C14.2668 10.7078 14.1179 11.0665 13.8534 11.3311C13.5888 11.5957 13.23 11.7445 12.8559 11.7449ZM7.14258 1.95312C6.93409 1.95333 6.73421 2.03624 6.58679 2.18366C6.43937 2.33108 6.35646 2.53097 6.35625 2.73945V10.3336C6.35646 10.5421 6.43937 10.742 6.58679 10.8894C6.73421 11.0368 6.93409 11.1197 7.14258 11.1199H12.8559C13.0643 11.1197 13.2642 11.0368 13.4116 10.8894C13.5591 10.742 13.642 10.5421 13.6422 10.3336V2.73945C13.642 2.53097 13.5591 2.33108 13.4116 2.18366C13.2642 2.03624 13.0643 1.95333 12.8559 1.95312H7.14258Z"
      fill="black"
    />
    <path
      d="M11.0718 6.71638H8.92568C8.71374 6.71617 8.51053 6.63191 8.36063 6.48209C8.21073 6.33226 8.12638 6.1291 8.12607 5.91716C8.13778 5.86716 7.99443 4.78434 9.01552 4.15505C9.08561 4.11133 9.17016 4.09715 9.25068 4.11559C9.3312 4.13404 9.40114 4.18362 9.44521 4.25349C9.50441 4.34716 9.58635 4.42433 9.68341 4.4778C9.78046 4.53128 9.88947 4.55932 10.0003 4.55932C10.1111 4.55932 10.2201 4.53128 10.3172 4.4778C10.4142 4.42433 10.4962 4.34716 10.5554 4.25349C10.5994 4.18355 10.6693 4.1339 10.7498 4.11537C10.8303 4.09685 10.9149 4.11098 10.9851 4.15466C11.2574 4.32198 11.4823 4.55643 11.6381 4.83556C11.7939 5.11468 11.8754 5.42913 11.8749 5.7488V5.91716C11.8747 6.0224 11.8538 6.12658 11.8134 6.22373C11.7729 6.32088 11.7137 6.40909 11.6391 6.48333C11.5645 6.55756 11.476 6.61636 11.3786 6.65635C11.2813 6.69634 11.177 6.71674 11.0718 6.71638ZM9.13388 4.84919C8.66747 5.29528 8.76357 5.84411 8.75107 5.91716C8.75117 5.9634 8.76961 6.00771 8.80235 6.04037C8.83508 6.07303 8.87943 6.09138 8.92568 6.09138H11.0718C11.118 6.09138 11.1624 6.07303 11.1951 6.04037C11.2278 6.00771 11.2463 5.9634 11.2464 5.91716V5.7488C11.2466 5.58094 11.2128 5.41478 11.147 5.26035C11.0812 5.10593 10.9848 4.96646 10.8636 4.85036C10.627 5.06579 10.3185 5.18508 9.9985 5.18487C9.67853 5.18465 9.37017 5.06493 9.13388 4.84919Z"
      fill="black"
    />
    <path
      d="M8.91582 4.58844C8.87258 4.51847 8.85866 4.43429 8.87709 4.35413C8.89551 4.27397 8.9448 4.20431 9.01425 4.16025C9.0837 4.1162 9.16772 4.1013 9.24809 4.11879C9.32845 4.13627 9.39869 4.18474 9.44355 4.25367C9.50275 4.34734 9.5847 4.42451 9.68175 4.47799C9.77881 4.53146 9.88782 4.55951 9.99863 4.55951C10.1094 4.55951 10.2185 4.53146 10.3155 4.47799C10.4126 4.42451 10.4945 4.34734 10.5537 4.25367C10.5754 4.2185 10.6039 4.18799 10.6376 4.16392C10.6712 4.13984 10.7092 4.12268 10.7495 4.11341C10.7898 4.10415 10.8315 4.10297 10.8723 4.10996C10.9131 4.11694 10.952 4.13194 10.9869 4.15408C11.0218 4.17623 11.052 4.20509 11.0757 4.23898C11.0994 4.27287 11.1161 4.31112 11.1249 4.35152C11.1337 4.39192 11.1344 4.43367 11.1269 4.47433C11.1195 4.515 11.104 4.55378 11.0814 4.58844C10.9658 4.77101 10.8059 4.92138 10.6166 5.02558C10.4273 5.12978 10.2147 5.18442 9.99863 5.18442C9.78253 5.18442 9.56995 5.12978 9.38063 5.02558C9.19132 4.92138 9.03142 4.77101 8.91582 4.58844Z"
      fill="black"
    />
    <path
      d="M10.6504 4.6832C10.5808 4.63882 10.5317 4.56874 10.5136 4.48824C10.4955 4.40775 10.51 4.32337 10.5539 4.25352C10.6167 4.1542 10.6516 4.03985 10.6552 3.92241C10.6587 3.80497 10.6306 3.68874 10.5739 3.58583C10.5173 3.48292 10.434 3.39712 10.3328 3.33735C10.2317 3.27759 10.1163 3.24607 9.99883 3.24607C9.88134 3.24607 9.76599 3.27759 9.66483 3.33735C9.56368 3.39712 9.4804 3.48292 9.42371 3.58583C9.36701 3.68874 9.33896 3.80497 9.34248 3.92241C9.34601 4.03985 9.38098 4.1542 9.44375 4.25352C9.4663 4.28817 9.48176 4.32695 9.48921 4.36762C9.49667 4.40829 9.49599 4.45003 9.48719 4.49043C9.4784 4.53083 9.46168 4.56908 9.438 4.60298C9.41432 4.63687 9.38415 4.66572 9.34923 4.68787C9.31432 4.71002 9.27536 4.72502 9.23461 4.732C9.19386 4.73898 9.15212 4.7378 9.11183 4.72854C9.07153 4.71928 9.03348 4.70211 8.99987 4.67803C8.96625 4.65396 8.93775 4.62345 8.91602 4.58828C8.79293 4.3944 8.72419 4.17101 8.71697 3.94147C8.70975 3.71193 8.76432 3.48467 8.87498 3.28343C8.98564 3.0822 9.14832 2.91438 9.34602 2.79752C9.54372 2.68067 9.76917 2.61906 9.99883 2.61914C11.0145 2.61914 11.6152 3.74531 11.0816 4.58672C11.0223 4.68047 10.7965 4.77578 10.6504 4.6832ZM12.523 8.05195H7.47461C7.39173 8.05195 7.31224 8.01903 7.25364 7.96042C7.19503 7.90182 7.16211 7.82233 7.16211 7.73945C7.16211 7.65657 7.19503 7.57709 7.25364 7.51848C7.31224 7.45988 7.39173 7.42695 7.47461 7.42695H12.523C12.6059 7.42695 12.6854 7.45988 12.744 7.51848C12.8026 7.57709 12.8355 7.65657 12.8355 7.73945C12.8355 7.82233 12.8026 7.90182 12.744 7.96042C12.6854 8.01903 12.6059 8.05195 12.523 8.05195ZM12.523 9.25234H7.47461C7.39173 9.25234 7.31224 9.21942 7.25364 9.16081C7.19503 9.10221 7.16211 9.02272 7.16211 8.93984C7.16211 8.85696 7.19503 8.77748 7.25364 8.71887C7.31224 8.66027 7.39173 8.62734 7.47461 8.62734H12.523C12.6059 8.62734 12.6854 8.66027 12.744 8.71887C12.8026 8.77748 12.8355 8.85696 12.8355 8.93984C12.8355 9.02272 12.8026 9.10221 12.744 9.16081C12.6854 9.21942 12.6059 9.25234 12.523 9.25234ZM12.523 10.4523H7.47461C7.39173 10.4523 7.31224 10.4194 7.25364 10.3608C7.19503 10.3022 7.16211 10.2227 7.16211 10.1398C7.16211 10.057 7.19503 9.97748 7.25364 9.91887C7.31224 9.86027 7.39173 9.82734 7.47461 9.82734H12.523C12.6059 9.82734 12.6854 9.86027 12.744 9.91887C12.8026 9.97748 12.8355 10.057 12.8355 10.1398C12.8355 10.2227 12.8026 10.3022 12.744 10.3608C12.6854 10.4194 12.6059 10.4523 12.523 10.4523Z"
      fill="black"
    />
  </svg>
);
export const ReviewReminders = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_759_6181)">
      <path
        d="M10.7607 12.8807L9.4007 11.5207C9.2407 11.3607 9.0007 11.3607 8.8407 11.5207C8.6807 11.6807 8.6807 11.9207 8.8407 12.0807L10.4807 13.7207C10.5607 13.8007 10.6807 13.8407 10.7607 13.8407C10.8807 13.8407 10.9607 13.8007 11.0407 13.7207L14.3607 10.4007C14.5207 10.2407 14.5207 10.0007 14.3607 9.8407C14.2007 9.6807 13.9607 9.6807 13.8007 9.8407L10.7607 12.8807Z"
        fill="black"
      />
      <path
        d="M19.0408 16.3604L16.3208 13.6404C16.5208 13.1604 16.6808 12.6404 16.7208 12.1204C16.8408 10.7604 16.4408 9.40039 15.5608 8.36039C15.0808 7.76039 14.4808 7.32039 13.8008 7.00039V4.92039C13.8008 3.96039 13.0008 3.16039 12.0008 3.16039H10.9208V2.60039C10.9208 2.00039 10.4408 1.52039 9.80083 1.52039H8.60083C8.40083 0.880391 7.80082 0.400391 7.12082 0.400391C6.40083 0.400391 5.84083 0.880391 5.64083 1.48039H4.44083C3.80083 1.52039 3.32083 2.00039 3.32083 2.60039V3.16039H2.24083C1.24083 3.16039 0.440825 3.96039 0.440825 4.92039V17.8404C0.400825 18.8004 1.24083 19.6004 2.24083 19.6004H12.0008C13.0008 19.6004 13.8008 18.8004 13.8008 17.8004V16.5204L16.3208 19.0404C17.0408 19.7604 18.2408 19.8004 19.0008 19.0404C19.7608 18.2804 19.8008 17.0804 19.0408 16.3604ZM14.9608 8.84039C15.6808 9.72039 16.0408 10.8804 15.9208 12.0004C15.7608 13.6404 14.7208 15.0004 13.2808 15.6004H13.2408C12.6008 15.8804 11.9208 15.9604 11.1608 15.9204C8.76083 15.6804 7.04083 13.5604 7.28083 11.1604C7.40083 10.0404 7.92082 9.04039 8.72082 8.32039L8.76083 8.28039C9.64083 7.52039 10.8408 7.12039 12.0408 7.24039C12.4808 7.28039 12.8808 7.40039 13.2808 7.56039C13.9208 7.88039 14.4808 8.28039 14.9608 8.84039ZM4.12083 2.60039C4.12083 2.44039 4.28083 2.32039 4.44083 2.32039H6.00083C6.24083 2.32039 6.40083 2.16039 6.40083 1.92039C6.40083 1.52039 6.72082 1.24039 7.12082 1.24039C7.52082 1.24039 7.88083 1.56039 7.88083 1.92039C7.88083 2.16039 8.04083 2.32039 8.28083 2.32039H9.84083C10.0008 2.32039 10.1608 2.44039 10.1608 2.60039V4.52039C10.1608 4.68039 10.0008 4.80039 9.84083 4.80039H4.44083C4.28083 4.80039 4.12083 4.68039 4.12083 4.52039V2.60039ZM12.0008 18.8004H2.24083C1.68083 18.8004 1.20083 18.3604 1.20083 17.8404V4.92039C1.20083 4.40039 1.64083 3.96039 2.20083 3.96039H3.28083V4.52039C3.28083 5.12039 3.76083 5.60039 4.40083 5.60039H9.80083C10.4008 5.60039 10.9208 5.12039 10.9208 4.52039V3.96039H12.0008C12.5608 3.96039 13.0008 4.40039 13.0008 4.92039V6.68039C12.7208 6.60039 12.4008 6.52039 12.0808 6.52039C10.6408 6.36039 9.32083 6.84039 8.28083 7.68039H3.48082C3.24082 7.68039 3.08083 7.84039 3.08083 8.08039C3.08083 8.32039 3.24082 8.48039 3.48082 8.48039H7.52082C7.24082 8.84039 7.04083 9.20039 6.84083 9.64039H3.52083C3.28083 9.64039 3.12083 9.80039 3.12083 10.0404C3.12083 10.2804 3.28083 10.4404 3.52083 10.4404H6.64083C6.60083 10.6804 6.52082 10.9204 6.52082 11.1604V11.6004H3.52083C3.28083 11.6004 3.12083 11.7604 3.12083 12.0004C3.12083 12.2404 3.28083 12.4004 3.52083 12.4004H6.52082C6.56082 12.8004 6.68083 13.1604 6.80083 13.5604H3.52083C3.28083 13.5604 3.12083 13.7204 3.12083 13.9604C3.12083 14.2004 3.28083 14.3604 3.52083 14.3604H7.20083C7.44082 14.8004 7.76082 15.1604 8.12082 15.4804H3.52083C3.28083 15.4804 3.12083 15.6404 3.12083 15.8804C3.12083 16.1204 3.28083 16.2804 3.52083 16.2804H9.32082C9.88083 16.5604 10.4408 16.7204 11.0808 16.8004C11.7208 16.8804 12.3608 16.8004 13.0008 16.6404V17.8804C13.0408 18.3204 12.5608 18.8004 12.0008 18.8004ZM18.4808 18.4804C18.0408 18.9204 17.3608 18.9204 16.9208 18.4804L14.3608 15.9604C15.0008 15.5604 15.5208 15.0404 15.9208 14.4004L18.4408 16.9204C18.9208 17.3604 18.9208 18.0404 18.4808 18.4804Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_759_6181">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ReviewPolicies = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 18.75H3.33333C2.781 18.7493 2.25148 18.5296 1.86092 18.1391C1.47037 17.7485 1.25066 17.219 1.25 16.6667V3.33333C1.25066 2.781 1.47037 2.25148 1.86092 1.86092C2.25148 1.47037 2.781 1.25066 3.33333 1.25H9.775C10.0525 1.25019 10.3271 1.30554 10.583 1.41283C10.8388 1.52013 11.0708 1.67723 11.2654 1.875L14.8229 5.51625C15.2045 5.9058 15.4177 6.42969 15.4167 6.975V10.0792C15.4167 10.1897 15.3728 10.2957 15.2946 10.3738C15.2165 10.4519 15.1105 10.4958 15 10.4958C14.8895 10.4958 14.7835 10.4519 14.7054 10.3738C14.6272 10.2957 14.5833 10.1897 14.5833 10.0792V6.975C14.5835 6.6479 14.4555 6.33377 14.2267 6.1L10.6687 2.45833C10.5522 2.33959 10.4131 2.24526 10.2596 2.18088C10.1062 2.11649 9.94142 2.08333 9.775 2.08333H3.33333C3.00181 2.08333 2.68387 2.21503 2.44945 2.44945C2.21503 2.68387 2.08333 3.00181 2.08333 3.33333V16.6667C2.08333 16.9982 2.21503 17.3161 2.44945 17.5506C2.68387 17.785 3.00181 17.9167 3.33333 17.9167H13.3333C13.4905 17.9173 13.6463 17.8868 13.7917 17.8271C13.8939 17.785 14.0086 17.7853 14.1106 17.8279C14.2126 17.8704 14.2936 17.9517 14.3356 18.054C14.3777 18.1562 14.3774 18.2709 14.3348 18.3729C14.2923 18.4749 14.211 18.5559 14.1088 18.5979C13.8627 18.699 13.5993 18.7506 13.3333 18.75Z"
      fill="black"
    />
    <path
      d="M14.8298 6.66641H12.084C11.5317 6.66575 11.0021 6.44604 10.6116 6.05548C10.221 5.66492 10.0013 5.1354 10.0007 4.58307V1.79557C10.0007 1.68507 10.0446 1.57909 10.1227 1.50095C10.2008 1.4228 10.3068 1.37891 10.4173 1.37891C10.5278 1.37891 10.6338 1.4228 10.7119 1.50095C10.7901 1.57909 10.834 1.68507 10.834 1.79557V4.58307C10.834 4.91459 10.9657 5.23254 11.2001 5.46696C11.4345 5.70138 11.7525 5.83307 12.084 5.83307H14.8298C14.9403 5.83307 15.0463 5.87697 15.1244 5.95511C15.2026 6.03325 15.2465 6.13923 15.2465 6.24974C15.2465 6.36025 15.2026 6.46623 15.1244 6.54437C15.0463 6.62251 14.9403 6.66641 14.8298 6.66641ZM14.1673 18.6889C14.003 18.6891 13.8423 18.6405 13.7057 18.5493L12.3673 17.6568C11.5105 17.0871 10.808 16.3143 10.3224 15.4072C9.83671 14.5001 9.58305 13.487 9.58399 12.4581V11.7447C9.5848 11.5573 9.64853 11.3755 9.76495 11.2285C9.88137 11.0816 10.0438 10.978 10.2261 10.9343C11.4635 10.5923 12.6407 10.0612 13.7161 9.35974C13.8506 9.27308 14.0073 9.22699 14.1673 9.22699C14.3274 9.22699 14.484 9.27308 14.6186 9.35974C15.6938 10.0612 16.8711 10.5924 18.1086 10.9343C18.2909 10.978 18.4533 11.0816 18.5697 11.2285C18.6861 11.3755 18.7498 11.5573 18.7507 11.7447V12.4581C18.7519 13.4873 18.4983 14.5008 18.0127 15.4081C17.527 16.3155 16.8244 17.0886 15.9673 17.6585L14.6294 18.5506C14.4925 18.6414 14.3316 18.6895 14.1673 18.6889ZM14.1673 10.0597C13.0153 10.8113 11.7536 11.3794 10.4273 11.7439L10.4173 12.4581C10.4163 13.35 10.636 14.2284 11.0569 15.0148C11.4778 15.8012 12.0867 16.4712 12.8294 16.9652L14.1673 17.8556L15.5052 16.9635C16.2477 16.4697 16.8565 15.7999 17.2773 15.0138C17.6982 14.2277 17.9181 13.3497 17.9173 12.4581V11.7447C16.5877 11.3805 15.3227 10.8122 14.1673 10.0602V10.0597Z"
      fill="black"
    />
    <path
      d="M13.75 15.0007C13.6395 15.0006 13.5335 14.9567 13.4554 14.8786L12.6221 14.0452C12.5462 13.9667 12.5042 13.8614 12.5051 13.7522C12.5061 13.6429 12.5499 13.5384 12.6272 13.4611C12.7044 13.3839 12.8089 13.3401 12.9182 13.3391C13.0274 13.3382 13.1327 13.3802 13.2113 13.4561L13.75 13.9948L15.1221 12.6227C15.2007 12.5468 15.3059 12.5048 15.4152 12.5058C15.5244 12.5067 15.6289 12.5506 15.7062 12.6278C15.7834 12.7051 15.8272 12.8096 15.8282 12.9188C15.8291 13.0281 15.7871 13.1333 15.7113 13.2119L14.0446 14.8786C13.9665 14.9567 13.8605 15.0006 13.75 15.0007ZM7.5 5.41732H4.16667C4.05616 5.41732 3.95018 5.37342 3.87204 5.29528C3.7939 5.21714 3.75 5.11116 3.75 5.00065C3.75 4.89014 3.7939 4.78416 3.87204 4.70602C3.95018 4.62788 4.05616 4.58398 4.16667 4.58398H7.5C7.61051 4.58398 7.71649 4.62788 7.79463 4.70602C7.87277 4.78416 7.91667 4.89014 7.91667 5.00065C7.91667 5.11116 7.87277 5.21714 7.79463 5.29528C7.71649 5.37342 7.61051 5.41732 7.5 5.41732ZM10 7.91732H4.16667C4.05616 7.91732 3.95018 7.87342 3.87204 7.79528C3.7939 7.71714 3.75 7.61116 3.75 7.50065C3.75 7.39014 3.7939 7.28416 3.87204 7.20602C3.95018 7.12788 4.05616 7.08398 4.16667 7.08398H10C10.1105 7.08398 10.2165 7.12788 10.2946 7.20602C10.3728 7.28416 10.4167 7.39014 10.4167 7.50065C10.4167 7.61116 10.3728 7.71714 10.2946 7.79528C10.2165 7.87342 10.1105 7.91732 10 7.91732ZM10.8333 10.4173H4.16667C4.05616 10.4173 3.95018 10.3734 3.87204 10.2953C3.7939 10.2171 3.75 10.1112 3.75 10.0007C3.75 9.89014 3.7939 9.78416 3.87204 9.70602C3.95018 9.62788 4.05616 9.58398 4.16667 9.58398H10.8333C10.9438 9.58398 11.0498 9.62788 11.128 9.70602C11.2061 9.78416 11.25 9.89014 11.25 10.0007C11.25 10.1112 11.2061 10.2171 11.128 10.2953C11.0498 10.3734 10.9438 10.4173 10.8333 10.4173ZM8.33333 12.9173H4.16667C4.05616 12.9173 3.95018 12.8734 3.87204 12.7953C3.7939 12.7171 3.75 12.6112 3.75 12.5007C3.75 12.3901 3.7939 12.2842 3.87204 12.206C3.95018 12.1279 4.05616 12.084 4.16667 12.084H8.33333C8.44384 12.084 8.54982 12.1279 8.62796 12.206C8.7061 12.2842 8.75 12.3901 8.75 12.5007C8.75 12.6112 8.7061 12.7171 8.62796 12.7953C8.54982 12.8734 8.44384 12.9173 8.33333 12.9173ZM8.33333 15.4173H4.16667C4.05616 15.4173 3.95018 15.3734 3.87204 15.2953C3.7939 15.2171 3.75 15.1112 3.75 15.0007C3.75 14.8901 3.7939 14.7842 3.87204 14.706C3.95018 14.6279 4.05616 14.584 4.16667 14.584H8.33333C8.44384 14.584 8.54982 14.6279 8.62796 14.706C8.7061 14.7842 8.75 14.8901 8.75 15.0007C8.75 15.1112 8.7061 15.2171 8.62796 15.2953C8.54982 15.3734 8.44384 15.4173 8.33333 15.4173Z"
      fill="black"
    />
  </svg>
);
export const EmployeeFiles = (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.1232 34.4192H4.87695C4.56758 34.4192 4.31445 34.1661 4.31445 33.8567V21.088C4.31445 20.7786 4.56758 20.5255 4.87695 20.5255H15.2326L16.3913 17.0661C16.4291 16.9544 16.501 16.8573 16.5968 16.7887C16.6927 16.7201 16.8078 16.6833 16.9257 16.6836H31.1176C31.427 16.6836 31.6801 16.9367 31.6801 17.2461V33.8567C31.6857 34.1661 31.4326 34.4192 31.1232 34.4192ZM5.43945 33.2942H30.5551V17.8086H17.3307L16.172 21.268C16.1342 21.3797 16.0623 21.4767 15.9664 21.5454C15.8705 21.614 15.7555 21.6508 15.6376 21.6505H5.43945V33.2942Z"
      fill="#1B3C52"
    />
    <path
      d="M7.85352 21.6501C7.54414 21.6501 7.29102 21.397 7.29102 21.0876V2.14258C7.29102 1.8332 7.54414 1.58008 7.85352 1.58008H26.9504C27.2598 1.58008 27.5129 1.8332 27.5129 2.14258V5.28695C27.5129 5.59633 27.2598 5.84945 26.9504 5.84945C26.641 5.84945 26.3879 5.59633 26.3879 5.28695V2.70508H8.41602V21.0876C8.41602 21.397 8.16289 21.6501 7.85352 21.6501Z"
      fill="#1B3C52"
    />
    <path
      d="M5.45117 21.6502C5.1418 21.6502 4.88867 21.3971 4.88867 21.0877V5.69773C4.88867 5.38836 5.1418 5.13523 5.45117 5.13523H7.84742C8.1568 5.13523 8.40992 5.38836 8.40992 5.69773C8.40992 6.00711 8.1568 6.26023 7.84742 6.26023H6.01367V21.0877C6.01367 21.3971 5.76055 21.6502 5.45117 21.6502ZM10.1424 21.6502C9.83305 21.6502 9.57992 21.3971 9.57992 21.0877V5.28711C9.57992 4.97773 9.83305 4.72461 10.1424 4.72461H29.2393C29.5487 4.72461 29.8018 4.97773 29.8018 5.28711V17.2459C29.8018 17.5552 29.5487 17.8084 29.2393 17.8084C28.9299 17.8084 28.6768 17.5552 28.6768 17.2459V5.84961H10.7049V21.0877C10.7049 21.3971 10.4518 21.6502 10.1424 21.6502Z"
      fill="#1B3C52"
    />
    <path
      d="M19.3507 15.0173C19.0919 15.0173 18.8613 14.8429 18.805 14.5842C18.7262 14.2524 18.5911 13.9366 18.4057 13.6504C18.2932 13.4704 18.1525 13.3017 17.995 13.1385C17.7117 12.8525 17.3744 12.6256 17.0026 12.4711C16.6308 12.3166 16.232 12.2375 15.8294 12.2385C14.7832 12.2385 13.8213 12.7617 13.2588 13.6448C13.0675 13.9429 12.9325 14.2579 12.8594 14.5842C12.7919 14.8879 12.4882 15.0792 12.1844 15.006C12.1124 14.9895 12.0443 14.9588 11.9841 14.9159C11.9239 14.873 11.8727 14.8187 11.8335 14.756C11.7944 14.6933 11.7679 14.6235 11.7557 14.5506C11.7436 14.4777 11.7459 14.4031 11.7625 14.331C11.8694 13.8754 12.055 13.4423 12.3138 13.0373C12.6906 12.4472 13.2105 11.9619 13.8252 11.6266C14.4398 11.2912 15.1292 11.1167 15.8294 11.1192C16.9488 11.1192 18.0007 11.5579 18.7938 12.3454C19.0132 12.5648 19.2044 12.801 19.3563 13.0429C19.615 13.4367 19.8007 13.8698 19.9019 14.331C19.9186 14.4031 19.9209 14.4777 19.9087 14.5506C19.8965 14.6235 19.8701 14.6933 19.8309 14.756C19.7917 14.8187 19.7406 14.873 19.6804 14.9159C19.6201 14.9588 19.5521 14.9895 19.48 15.006C19.435 15.0117 19.3957 15.0173 19.3507 15.0173Z"
      fill="#1B3C52"
    />
    <path
      d="M15.8284 12.2402C14.4334 12.2402 13.2972 11.104 13.2972 9.70898C13.2972 8.31398 14.4334 7.17773 15.8284 7.17773C17.2234 7.17773 18.3597 8.31398 18.3597 9.70898C18.3597 11.104 17.2234 12.2402 15.8284 12.2402ZM15.8284 8.29711C15.4555 8.29711 15.0978 8.44527 14.8341 8.70899C14.5703 8.97271 14.4222 9.3304 14.4222 9.70336C14.4222 10.0763 14.5703 10.434 14.8341 10.6977C15.0978 10.9615 15.4555 11.1096 15.8284 11.1096C16.2014 11.1096 16.5591 10.9615 16.8228 10.6977C17.0865 10.434 17.2347 10.0763 17.2347 9.70336C17.2347 8.93273 16.6047 8.29711 15.8284 8.29711ZM26.9491 9.86086H22.0328C21.7234 9.86086 21.4703 9.60773 21.4703 9.29836C21.4703 8.98898 21.7234 8.73586 22.0328 8.73586H26.9491C27.2584 8.73586 27.5116 8.98898 27.5116 9.29836C27.5116 9.60773 27.2584 9.86086 26.9491 9.86086ZM26.9491 12.2402H22.0328C21.7234 12.2402 21.4703 11.9871 21.4703 11.6777C21.4703 11.3684 21.7234 11.1152 22.0328 11.1152H26.9491C27.2584 11.1152 27.5116 11.3684 27.5116 11.6777C27.5116 11.9871 27.2584 12.2402 26.9491 12.2402ZM26.9491 32.3721H6.64844C6.33906 32.3721 6.08594 32.119 6.08594 31.8096C6.08594 31.5002 6.33906 31.2471 6.64844 31.2471H26.9434C27.2528 31.2471 27.5059 31.5002 27.5059 31.8096C27.5059 32.119 27.2584 32.3721 26.9491 32.3721Z"
      fill="#1B3C52"
    />
  </svg>
);
export const RostersSchedules = (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_771_6129)">
      <mask
        id="mask0_771_6129"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={36}
        height={36}
      >
        <path d="M0 0.000106812H35.9999V36H0V0.000106812Z" fill="white" />
      </mask>
      <g mask="url(#mask0_771_6129)">
        <path
          d="M27.7734 3.16408H3.86718C2.31391 3.16408 1.05469 4.42331 1.05469 5.97658V10.1953H30.5858V5.97658C30.5858 4.42331 29.3267 3.16408 27.7734 3.16408Z"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.96094 5.27344V1.0547"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.6797 5.27344V1.0547"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7734 5.27344V1.0547"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8672 5.27344V1.0547"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.0703 14.9414H19.8281"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8125 14.9414H13.5703"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3281 14.9414H26.0859"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.55469 19.6875H7.31249"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8125 19.6875H13.5703"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.0703 19.6875H19.8281"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.55469 24.4336H7.31249"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8125 24.4336H13.5703"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.9453 27.211C34.9453 31.4825 31.4825 34.9453 27.2109 34.9453C22.9394 34.9453 19.4766 31.4825 19.4766 27.211C19.4766 22.9394 22.9394 19.4766 27.2109 19.4766C31.4825 19.4766 34.9453 22.9394 34.9453 27.211Z"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.2109 23.6953V27.2109H30.7266"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.5858 20.2501V10.1954H1.05469V27.0703C1.05469 28.2353 1.99912 29.1797 3.16406 29.1797H19.7297"
          stroke="#1B3C52"
          strokeWidth={1.3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_771_6129">
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CreateJobAd = (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_771_6156)">
      <path
        d="M35.8523 21.9806C35.6414 21.3337 35.0438 20.8978 34.3617 20.8978H25.5023V18.6759C25.5938 18.5774 26.0367 18.2118 26.0789 18.0853L28.9477 10.9837C29.2781 11.0048 29.6086 10.7938 29.7281 10.4845L32.3789 3.92432C32.5125 3.60088 32.4141 3.24228 32.168 3.02432C33.5531 0.359472 29.7141 -1.1874 28.8633 1.68838C28.5328 1.66728 28.2023 1.87822 28.0828 2.1876L27.8367 2.79228L25.6641 8.14307L25.4953 8.56494V6.11103C25.4883 6.06885 25.4883 6.02666 25.4672 5.98447C25.4531 5.92119 25.4109 5.87197 25.3758 5.82275L19.9055 0.352441C19.8281 0.282128 19.7297 0.239941 19.6242 0.232909H1.56094C0.738281 0.232909 0.0703125 0.900878 0.0703125 1.72353V30.7415C0.0703125 31.5642 0.738281 32.2321 1.56094 32.2321H14.2594V34.2782C14.2523 35.129 14.9766 35.8603 15.8344 35.8532H34.3547C35.0297 35.8532 35.6273 35.4243 35.8453 34.7774C35.9016 34.6157 35.9297 34.454 35.9297 34.2782V22.4728C35.9297 22.304 35.9016 22.1423 35.8523 21.9806ZM34.3547 21.6993C34.5867 21.6993 34.8047 21.8048 34.9453 21.9735C33.4477 22.986 26.7258 27.5493 25.0945 28.6532C24.0469 27.9431 16.4812 22.8173 15.2508 21.9806C15.3914 21.8048 15.6094 21.7063 15.8344 21.6993H34.3547ZM29.7703 1.56182C30.2695 0.373535 32.0555 1.09072 31.5914 2.29307L31.4367 2.67275C31.3594 2.64463 29.7492 1.99072 29.6156 1.93447L29.7703 1.56182ZM28.4203 3.46728L28.9758 3.69228L27.1195 8.29775L26.5641 8.07275L28.4203 3.46728ZM26.2617 8.81807L26.9156 9.08525C27.2602 9.23291 27.6891 9.0501 27.8227 8.69853L29.7633 3.88916C29.9109 3.54463 29.7281 3.11572 29.3766 2.98213L28.7227 2.71494L28.8141 2.48291L31.6266 3.62197L28.9688 10.1821L26.1633 9.04307L26.2617 8.81807ZM25.4953 9.49307C25.5305 9.54932 25.5797 9.60557 25.6359 9.64775L25.4953 9.99228V9.49307ZM26.3602 9.99932C26.4797 10.0485 28.0125 10.6673 28.1812 10.7376L25.4812 17.4173L23.6602 16.679L26.3602 9.99932ZM24.968 18.0712L23.6672 19.2876L23.5758 17.5087L24.968 18.0712ZM20.018 1.604L24.1242 5.71025H20.707C20.3273 5.71025 20.018 5.40088 20.018 5.02119V1.604ZM14.2594 22.4728V31.4306H1.56094C1.18125 31.4306 0.871875 31.1212 0.871875 30.7415V1.72353C0.871875 1.34385 1.18125 1.03447 1.56094 1.03447H19.2164V5.02119C19.2164 5.84385 19.8844 6.51182 20.707 6.51182H24.6867V11.9751L22.7602 16.7493C22.7461 16.8056 22.732 16.8618 22.732 16.9181L22.9008 20.1876C22.9078 20.5251 23.3367 20.6868 23.5758 20.4618C23.6742 20.3704 24.6234 19.4845 24.6867 19.4212V20.8978H15.8273C14.9625 20.8907 14.2523 21.629 14.2594 22.4728ZM15.0609 31.8524C15.075 31.8454 15.0609 22.8384 15.068 22.8243C16.3055 23.661 22.1625 27.6267 23.2594 28.379L15.0609 33.9337V31.8524ZM34.3547 35.0517H15.8344C15.6023 35.0517 15.3844 34.9462 15.2438 34.7774L23.9766 28.8642C25.3195 29.7571 24.8766 29.7501 26.2195 28.8642L34.9453 34.7774C34.7977 34.9462 34.5867 35.0517 34.3547 35.0517ZM35.1281 33.9337L26.9297 28.379C28.2727 27.4649 33.8977 23.654 35.1281 22.8243V33.9337ZM3.78984 7.15166H12.7828C13.0078 7.15166 13.1836 6.96885 13.1836 6.75088V4.49385C13.1836 4.26885 13.0008 4.09307 12.7828 4.09307H3.78984C3.56484 4.09307 3.38906 4.27588 3.38906 4.49385V6.75088C3.38906 6.97588 3.57188 7.15166 3.78984 7.15166ZM4.19062 4.89463H12.382V6.3501H4.19062V4.89463ZM3.78984 10.4704C3.2625 10.4704 3.26953 9.66885 3.78984 9.66885H12.7828C13.3102 9.66885 13.3031 10.4704 12.7828 10.4704H3.78984ZM3.78984 12.9806H21.7969C22.3312 12.9876 22.3172 13.7751 21.7969 13.7821H3.78984C3.25547 13.7751 3.26953 12.9876 3.78984 12.9806ZM21.7969 17.1009H3.78984C3.25547 17.0938 3.26953 16.3063 3.78984 16.2993H21.7969C22.3312 16.3063 22.3172 17.0938 21.7969 17.1009ZM11.7773 20.4126H3.78984C3.2625 20.4126 3.26953 19.611 3.78984 19.611H11.7773C12.3047 19.611 12.2977 20.4126 11.7773 20.4126ZM11.7773 23.7313H3.78984C3.2625 23.7313 3.26953 22.9298 3.78984 22.9298H11.7773C12.3047 22.9298 12.2977 23.7243 11.7773 23.7313ZM11.7773 27.0431H3.78984C3.2625 27.0431 3.26953 26.2415 3.78984 26.2415H11.7773C12.3047 26.2415 12.2977 27.0431 11.7773 27.0431Z"
        fill="#1B3C52"
        stroke="#1B3C52"
        strokeWidth={0.2}
      />
    </g>
    <defs>
      <clipPath id="clip0_771_6156">
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const MessageHRAdvisor = (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00039 15.2781H13.8004C13.9595 15.2781 14.1121 15.2149 14.2247 15.1024C14.3372 14.9899 14.4004 14.8373 14.4004 14.6781C14.4004 14.519 14.3372 14.3664 14.2247 14.2539C14.1121 14.1413 13.9595 14.0781 13.8004 14.0781H6.00039C5.84126 14.0781 5.68865 14.1413 5.57613 14.2539C5.4636 14.3664 5.40039 14.519 5.40039 14.6781C5.40039 14.8373 5.4636 14.9899 5.57613 15.1024C5.68865 15.2149 5.84126 15.2781 6.00039 15.2781ZM21.6004 17.6781H6.00039C5.84126 17.6781 5.68865 17.7413 5.57613 17.8539C5.4636 17.9664 5.40039 18.119 5.40039 18.2781C5.40039 18.4373 5.4636 18.5899 5.57613 18.7024C5.68865 18.8149 5.84126 18.8781 6.00039 18.8781H21.6004C21.7595 18.8781 21.9121 18.8149 22.0247 18.7024C22.1372 18.5899 22.2004 18.4373 22.2004 18.2781C22.2004 18.119 22.1372 17.9664 22.0247 17.8539C21.9121 17.7413 21.7595 17.6781 21.6004 17.6781ZM21.6004 21.2781H6.00039C5.84126 21.2781 5.68865 21.3413 5.57613 21.4539C5.4636 21.5664 5.40039 21.719 5.40039 21.8781C5.40039 22.0373 5.4636 22.1899 5.57613 22.3024C5.68865 22.4149 5.84126 22.4781 6.00039 22.4781H21.6004C21.7595 22.4781 21.9121 22.4149 22.0247 22.3024C22.1372 22.1899 22.2004 22.0373 22.2004 21.8781C22.2004 21.719 22.1372 21.5664 22.0247 21.4539C21.9121 21.3413 21.7595 21.2781 21.6004 21.2781Z"
      fill="#1B3C52"
    />
    <path
      d="M32.4432 1.52052L11.958 1.47852C9.996 1.47852 8.4 3.07452 8.4 5.03652V8.11092L3.558 8.12112C1.596 8.12112 0 9.71712 0 11.6791V24.3637C0 26.3257 1.596 27.9211 3.558 27.9211H7.2V33.9211C7.19995 34.0422 7.23657 34.1605 7.30503 34.2605C7.37349 34.3604 7.47059 34.4373 7.58356 34.481C7.69653 34.5246 7.82008 34.5331 7.93796 34.5053C8.05584 34.4774 8.16253 34.4146 8.244 34.3249L14.0664 27.9199L24.042 27.8791C26.004 27.8791 27.6 26.2831 27.6 24.3217V24.2539L30.756 27.7255C30.8377 27.8145 30.9444 27.8768 31.0621 27.9043C31.1798 27.9318 31.303 27.9232 31.4157 27.8796C31.5284 27.836 31.6253 27.7594 31.6939 27.6599C31.7625 27.5604 31.7994 27.4426 31.8 27.3217V21.3217H32.442C34.404 21.3217 36 19.7257 36 17.7643V5.07852C35.9989 4.13542 35.6238 3.23126 34.9571 2.56428C34.2903 1.8973 33.3863 1.52194 32.4432 1.52052ZM26.4 24.3211C26.3992 24.9466 26.1502 25.5462 25.7076 25.9882C25.265 26.4302 24.6651 26.6785 24.0396 26.6785L13.7976 26.7205C13.7144 26.7208 13.6322 26.7384 13.5562 26.7722C13.4802 26.806 13.412 26.8552 13.356 26.9167L8.4 32.3689V27.3205C8.4 27.1614 8.33679 27.0088 8.22426 26.8963C8.11174 26.7837 7.95913 26.7205 7.8 26.7205H3.558C2.93292 26.7199 2.33361 26.4713 1.89156 26.0294C1.4495 25.5874 1.20079 24.9882 1.2 24.3631V11.6785C1.20079 11.0532 1.44965 10.4537 1.89194 10.0116C2.33424 9.56954 2.93386 9.32099 3.5592 9.32052L9 9.30912H9.0012L24.042 9.27792C24.6672 9.27855 25.2666 9.52719 25.7087 9.96926C26.1507 10.4113 26.3994 11.0107 26.4 11.6359V24.3211ZM34.8 17.7631C34.7992 18.3882 34.5505 18.9874 34.1084 19.4294C33.6664 19.8713 33.0671 20.1199 32.442 20.1205H31.2C31.0409 20.1205 30.8883 20.1837 30.7757 20.2963C30.6632 20.4088 30.6 20.5614 30.6 20.7205V25.7689L27.6 22.4689V11.6365C27.6 9.67452 26.004 8.07852 24.0408 8.07852L9.6 8.10792V5.03592C9.60064 4.41094 9.8491 3.81172 10.2909 3.36968C10.7327 2.92764 11.3318 2.67887 11.9568 2.67792L32.4414 2.71992H32.4426C33.0678 2.72055 33.6672 2.96919 34.1093 3.41126C34.5513 3.85333 34.8 4.45273 34.8006 5.07792L34.8 17.7631Z"
      fill="#1B3C52"
    />
  </svg>
);
export const AdminSettings = (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_771_6196"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={36}
      height={36}
    >
      <path d="M0 0.000106812H35.9999V36H0V0.000106812Z" fill="white" />
    </mask>
    <g mask="url(#mask0_771_6196)">
      <path
        d="M18.0005 12.4688C14.9457 12.4688 12.4693 14.9452 12.4693 18C12.4693 21.0548 14.9457 23.5312 18.0005 23.5312C21.0553 23.5312 23.5318 21.0548 23.5318 18C23.5318 14.9452 21.0553 12.4688 18.0005 12.4688ZM33.5256 14.0529L32.028 15.2858C30.3197 16.6921 30.3197 19.3079 32.028 20.7142L33.5256 21.9471C34.0563 22.384 34.1934 23.1406 33.8497 23.7359L30.8926 28.8578C30.5488 29.4531 29.8251 29.7127 29.1814 29.4716L27.3649 28.7911C25.2928 28.0148 23.0274 29.3227 22.6636 31.5053L22.3448 33.4187C22.2318 34.0967 21.6451 34.5938 20.9577 34.5938H15.0433C14.356 34.5938 13.7693 34.0967 13.6563 33.4187L13.3373 31.5053C12.9736 29.3227 10.7082 28.0148 8.63619 28.7911L6.81974 29.4716C6.17596 29.7127 5.45224 29.4531 5.10848 28.8578L2.15136 23.7359C1.80767 23.1406 1.94471 22.384 2.47543 21.9471L3.97308 20.7142C5.68132 19.3079 5.68132 16.6921 3.97308 15.2858L2.47543 14.0529C1.94471 13.616 1.80767 12.8594 2.15136 12.2641L5.10848 7.14221C5.45224 6.54688 6.17596 6.28729 6.81974 6.52846L8.63619 7.20894C10.7082 7.98519 12.9736 6.67731 13.3373 4.49474L13.6563 2.58133C13.7693 1.90331 14.356 1.40634 15.0433 1.40634H20.9577C21.6451 1.40634 22.2318 1.90331 22.3448 2.58133L22.6636 4.49474C23.0274 6.67731 25.2928 7.98519 27.3649 7.20894L29.1814 6.52846C29.8251 6.28729 30.5488 6.54688 30.8926 7.14221L33.8497 12.2641C34.1934 12.8594 34.0563 13.616 33.5256 14.0529Z"
        stroke="#1B3C52"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const NotificationUser = (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_596_3575)">
      <rect width={32} height={32} rx={16} fill="white" />
      <path
        opacity={0.2}
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#1B3C52"
      />
      <path
        d="M8.38086 23.912C8.40143 21.9049 9.21318 19.987 10.6397 18.575C12.0663 17.1629 13.9924 16.3709 15.9997 16.3709C18.0069 16.3709 19.933 17.1629 21.3596 18.575C22.7861 19.987 23.5979 21.9049 23.6185 23.912H8.38086Z"
        fill="#1B3C52"
      />
      <path
        d="M20.4449 10.5776C20.4449 8.12282 18.4549 6.13281 16.0001 6.13281C13.5453 6.13281 11.5553 8.12282 11.5553 10.5776C11.5553 13.0324 13.5453 15.0224 16.0001 15.0224C18.4549 15.0224 20.4449 13.0324 20.4449 10.5776Z"
        fill="#1B3C52"
      />
    </g>
    <defs>
      <clipPath id="clip0_596_3575">
        <rect width={32} height={32} rx={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LogOut = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1367_19353"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={1}
      y={1}
      width={18}
      height={18}
    >
      <path d="M19 1H1V19H19V1Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1367_19353)">
      <mask
        id="mask1_1367_19353"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={1}
        width={18}
        height={18}
      >
        <path d="M1 1.00005H18.9999V19H1V1.00005Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1367_19353)">
        <path
          d="M12.9882 14.7813V16.1875C12.9882 17.3525 12.0438 18.2969 10.8789 18.2969H3.81249C2.64752 18.2969 1.70312 17.3525 1.70312 16.1875V3.81254C1.70312 2.64757 2.64752 1.70317 3.81249 1.70317H10.8789C12.0438 1.70317 12.9882 2.64757 12.9882 3.81254V5.21879"
          stroke="#5C5B62"
          strokeWidth={1.2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1211 10.0352H8.59375"
          stroke="#5C5B62"
          strokeWidth={1.2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4141 12.3555L17.9886 10.7809C18.4005 10.369 18.4005 9.70129 17.9886 9.2894L16.4141 7.71486"
          stroke="#5C5B62"
          strokeWidth={1.2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
export const EyeShowIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.98676 4.375C6.94223 4.375 3.81918 6.13711 1.36058 9.66133C1.29041 9.76303 1.25195 9.88325 1.25007 10.0068C1.24819 10.1303 1.28298 10.2517 1.35004 10.3555C3.2391 13.3125 6.32035 15.625 9.98676 15.625C13.6133 15.625 16.7578 13.3055 18.6504 10.3418C18.7159 10.24 18.7507 10.1216 18.7507 10.0006C18.7507 9.87958 18.7159 9.76113 18.6504 9.65937C16.7536 6.72969 13.586 4.375 9.98676 4.375Z"
      stroke="black"
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
      stroke="black"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
  </svg>
);
export const EyeHideIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 5L15.6667 15.6667" stroke="black" strokeWidth={0.75} />
    <path
      d="M7.59961 8.66016C7.37775 9.05677 7.25 9.51325 7.25 10C7.25 11.5188 8.48122 12.75 10 12.75C10.4866 12.75 10.9423 12.6212 11.3389 12.3994L11.8857 12.9463C11.3412 13.2955 10.6949 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 9.30499 6.70341 8.65784 7.05273 8.11328L7.59961 8.66016ZM10 6.5C11.933 6.5 13.5 8.067 13.5 10C13.5 10.6949 13.2955 11.3412 12.9463 11.8857L12.3994 11.3389C12.6212 10.9423 12.75 10.4866 12.75 10C12.75 8.48122 11.5188 7.25 10 7.25C9.51325 7.25 9.05677 7.37775 8.66016 7.59961L8.11328 7.05273C8.65784 6.70341 9.30499 6.5 10 6.5Z"
      fill="black"
    />
    <path
      d="M5.22559 6.28613C3.9612 7.1289 2.75228 8.32169 1.66797 9.87598C1.64069 9.91627 1.62574 9.96401 1.625 10.0127C1.62465 10.0372 1.62809 10.0616 1.63477 10.085L1.66504 10.1523L1.66602 10.1533C3.50999 13.0398 6.48705 15.2497 9.98633 15.25C11.1994 15.25 12.3601 14.9756 13.4365 14.4971L14.0029 15.0635C12.7687 15.6551 11.4162 16 9.98633 16C6.15346 15.9997 2.96812 13.5848 1.03418 10.5576L1.03516 10.5566C0.928585 10.391 0.872007 10.198 0.875 10.001C0.878027 9.80339 0.939545 9.61091 1.05176 9.44824L1.05273 9.44629C2.14719 7.8775 3.37858 6.64079 4.68457 5.74512L5.22559 6.28613ZM9.98633 4C13.7523 4 17.0237 6.45731 18.9648 9.45508L18.9658 9.45605C19.0703 9.61833 19.126 9.808 19.126 10.001C19.1259 10.1933 19.0697 10.3811 18.9658 10.543C18.0349 12.0007 16.801 13.3157 15.3506 14.29L14.8096 13.749C16.2138 12.8351 17.4203 11.5704 18.334 10.1396L18.335 10.1387C18.3614 10.0976 18.3759 10.0498 18.376 10.001C18.376 9.95194 18.3615 9.90354 18.335 9.8623V9.86133C16.4822 7.00081 13.4179 4.75 9.98633 4.75C8.85714 4.7501 7.70851 5.00624 6.58398 5.52344L6.02051 4.95996C7.31116 4.32268 8.65119 4.0001 9.98633 4Z"
      fill="black"
    />
  </svg>
);
export const headerCloseIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6.56V17.44C20 18.8538 18.8539 20 17.44 20H6.56C5.14615 20 4 18.8538 4 17.44L4 6.56C4 5.14611 5.14615 4 6.56 4L17.44 4C18.8539 4 20 5.14611 20 6.56Z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16L8 8"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15L12 12L15 9"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const headerOpenIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: "rotate(-180deg)" }}
  >
    <path
      d="M20 6.56V17.44C20 18.8538 18.8539 20 17.44 20H6.56C5.14615 20 4 18.8538 4 17.44L4 6.56C4 5.14611 5.14615 4 6.56 4L17.44 4C18.8539 4 20 5.14611 20 6.56Z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16L8 8"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15L12 12L15 9"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const OverViewIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.44085 19.8937V17.1294C9.44474 16.424 10.0169 15.8538 10.7223 15.8529H13.3201C14.0285 15.849 14.6064 16.4211 14.6093 17.1294V19.8985C14.6103 20.4979 15.09 20.9873 15.6893 21H17.4213C19.1386 21.0097 20.5397 19.6251 20.5494 17.9078V17.9059V10.0539C20.5377 9.38156 20.2186 8.75106 19.6834 8.34435L13.7619 3.61663C12.7218 2.79446 11.2525 2.79446 10.2124 3.61663L4.31517 8.34825C3.77711 8.75495 3.457 9.38739 3.44922 10.0626V17.9049C3.45798 19.6222 4.85713 21.0087 6.57541 21H8.30927C8.92322 21.0029 9.42334 20.5076 9.42626 19.8937"
      stroke="#5C5B62"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const OverViewActiveIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.44085 19.8937V17.1294C9.44474 16.424 10.0169 15.8538 10.7223 15.8529H13.3201C14.0285 15.849 14.6064 16.4211 14.6093 17.1294V19.8985C14.6103 20.4979 15.09 20.9873 15.6893 21H17.4213C19.1386 21.0097 20.5397 19.6251 20.5494 17.9078V17.9059V10.0539C20.5377 9.38156 20.2186 8.75106 19.6834 8.34435L13.7619 3.61663C12.7218 2.79446 11.2525 2.79446 10.2124 3.61663L4.31517 8.34825C3.77711 8.75495 3.457 9.38739 3.44922 10.0626V17.9049C3.45798 19.6222 4.85713 21.0087 6.57541 21H8.30927C8.92322 21.0029 9.42334 20.5076 9.42626 19.8937"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DropDownIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6L8 10L4 6"
      stroke="#4F4B45"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotificationIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17"
      stroke="#787891"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5"
      stroke="#787891"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// new icon

export const DetailedReportIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 14H6.66667C4.46678 14 3.36683 14 2.68342 13.3166C2 12.6331 2 11.5332 2 9.33333V2"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.66699 2.66699H5.33366"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.66699 4.66699H7.33366"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M3.33301 13.3337C4.04696 12.0357 5.01487 8.67959 6.87054 8.67959C8.15307 8.67959 8.48521 10.3148 9.74207 10.3148C11.9045 10.3148 11.591 6.66699 13.9997 6.66699"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserMaltipleIcon = (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3337 9.16634C11.3337 7.32539 9.84124 5.83301 8.00033 5.83301C6.15938 5.83301 4.66699 7.32539 4.66699 9.16634C4.66699 11.0073 6.15938 12.4997 8.00033 12.4997C9.84124 12.4997 11.3337 11.0073 11.3337 9.16634Z"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.69916 6.29811C9.67791 6.14623 9.66699 5.99106 9.66699 5.83333C9.66699 3.99238 11.1594 2.5 13.0003 2.5C14.8412 2.5 16.3337 3.99238 16.3337 5.83333C16.3337 7.67428 14.8412 9.16667 13.0003 9.16667C12.3798 9.16667 11.799 8.99717 11.3015 8.70192"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 17.5C13 14.7386 10.7614 12.5 8 12.5C5.23857 12.5 3 14.7386 3 17.5"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 14.167C18 11.4056 15.7614 9.16699 13 9.16699"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RefreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M13.8391 1.33301V3.42113C13.8391 3.61704 13.5942 3.70573 13.4688 3.55523C12.2481 2.19134 10.4741 1.33301 8.49967 1.33301C4.81777 1.33301 1.83301 4.31777 1.83301 7.99967C1.83301 11.6815 4.81777 14.6663 8.49967 14.6663C12.1815 14.6663 15.1663 11.6815 15.1663 7.99967"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const RefreshWhiteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M16.6737 2.16699V4.77715C16.6737 5.02203 16.3675 5.13289 16.2108 4.94477C14.6848 3.23991 12.4674 2.16699 9.99935 2.16699C5.39697 2.16699 1.66602 5.89795 1.66602 10.5003C1.66602 15.1027 5.39697 18.8337 9.99935 18.8337C14.6017 18.8337 18.3327 15.1027 18.3327 10.5003"
      stroke="white"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DownloadExportIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M2.5 14.667C2.5 15.442 2.5 15.8295 2.58519 16.1474C2.81636 17.0101 3.49022 17.684 4.35296 17.9152C4.67087 18.0003 5.05836 18.0003 5.83333 18.0003H14.1667C14.9417 18.0003 15.3292 18.0003 15.6471 17.9152C16.5098 17.684 17.1837 17.0101 17.4148 16.1474C17.5 15.8295 17.5 15.442 17.5 14.667"
      stroke="black"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.75 10.0834C13.75 10.0834 10.9882 13.8334 9.99995 13.8334C9.01178 13.8334 6.25 10.0834 6.25 10.0834M9.99995 13V3"
      stroke="black"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const AddTeamIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 7.5C12 9.433 10.433 11 8.5 11C6.567 11 5 9.433 5 7.5C5 5.567 6.567 4 8.5 4C10.433 4 12 5.567 12 7.5Z"
      stroke="#F8FFCF"
      stroke-width="1.5"
    />
    <path
      d="M13.5 11C15.433 11 17 9.433 17 7.5C17 5.567 15.433 4 13.5 4"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.1429 20H3.85714C2.83147 20 2 19.2325 2 18.2857C2 15.9188 4.07868 14 6.64286 14H10.3571C11.4023 14 12.3669 14.3188 13.1429 14.8568"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 14V20M22 17H16"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const SearchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M11.333 11.833L13.9997 14.4997"
      stroke="#787891"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6667 7.83333C12.6667 4.88781 10.2789 2.5 7.33333 2.5C4.38781 2.5 2 4.88781 2 7.83333C2 10.7789 4.38781 13.1667 7.33333 13.1667C10.2789 13.1667 12.6667 10.7789 12.6667 7.83333Z"
      stroke="#787891"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UpWhiteTrend = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 13V8H15"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 8L15 13C14.1174 13.8826 13.6762 14.3238 13.1346 14.3726C13.045 14.3807 12.955 14.3807 12.8654 14.3726C12.3238 14.3238 11.8826 13.8826 11 13C10.1174 12.1174 9.67615 11.6762 9.13457 11.6274C9.04504 11.6193 8.95496 11.6193 8.86543 11.6274C8.32385 11.6762 7.88256 12.1174 7 13L4 16"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UpGreenTrend = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 13V8H15"
      stroke="#52C41A"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 8L15 13C14.1174 13.8826 13.6762 14.3238 13.1346 14.3726C13.045 14.3807 12.955 14.3807 12.8654 14.3726C12.3238 14.3238 11.8826 13.8826 11 13C10.1174 12.1174 9.67615 11.6762 9.13457 11.6274C9.04504 11.6193 8.95496 11.6193 8.86543 11.6274C8.32385 11.6762 7.88256 12.1174 7 13L4 16"
      stroke="#52C41A"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DownRedTrend = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 11V16H15"
      stroke="#EA4335"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 16L15 11C14.1174 10.1174 13.6762 9.6762 13.1346 9.6274C13.045 9.6193 12.955 9.6193 12.8654 9.6274C12.3238 9.6762 11.8826 10.1174 11 11C10.1174 11.8826 9.67615 12.3238 9.13457 12.3726C9.04504 12.3807 8.95496 12.3807 8.86543 12.3726C8.32385 12.3238 7.88256 11.8826 7 11L4 8"
      stroke="#EA4335"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UpBlueTrend = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 13V8H15"
      stroke="#1A8EC4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 8L15 13C14.1174 13.8826 13.6762 14.3238 13.1346 14.3726C13.045 14.3807 12.955 14.3807 12.8654 14.3726C12.3238 14.3238 11.8826 13.8826 11 13C10.1174 12.1174 9.67615 11.6762 9.13457 11.6274C9.04504 11.6193 8.95496 11.6193 8.86543 11.6274C8.32385 11.6762 7.88256 12.1174 7 13L4 16"
      stroke="#1A8EC4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RevenueFinancialIcon = (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 12.002C15 13.3827 13.8807 14.502 12.5 14.502C11.1193 14.502 10 13.3827 10 12.002C10 10.6213 11.1193 9.50195 12.5 9.50195C13.8807 9.50195 15 10.6213 15 12.002Z"
      stroke="#B4B4B4"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 11.4902V11.5002"
      stroke="#B4B4B4"
      strokeWidth={2.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12.4902V12.5002"
      stroke="#B4B4B4"
      strokeWidth={2.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 5.00195C18.9794 5.00195 20.6903 5.38615 21.6329 5.67827C22.1756 5.84646 22.5 6.36084 22.5 6.929V16.6843C22.5 17.7994 21.2719 18.6384 20.1762 18.4315C19.2361 18.254 18.0107 18.1114 16.5 18.1114C11.7491 18.1114 10.6096 19.9171 3.6448 18.3812C2.97265 18.233 2.5 17.6285 2.5 16.9402V6.92311C2.5 5.94725 3.42079 5.23561 4.37798 5.42555C10.6967 6.67941 11.9209 5.00195 16.5 5.00195Z"
      stroke="#B4B4B4"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DiscountAnalyticsIcon = (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 18V16M12.5 18V15M17.5 18V13M3 12C3 7.52166 3 5.28249 4.39124 3.89124C5.78249 2.5 8.02166 2.5 12.5 2.5C16.9783 2.5 19.2175 2.5 20.6088 3.89124C22 5.28249 22 7.52166 22 12C22 16.4783 22 18.7175 20.6088 20.1088C19.2175 21.5 16.9783 21.5 12.5 21.5C8.02166 21.5 5.78249 21.5 4.39124 20.1088C3 18.7175 3 16.4783 3 12Z"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.49219 11.4853C8.64729 11.5571 13.5341 11.2318 16.3137 6.82035M14.4923 6.28738L16.3678 5.98552C16.5964 5.95641 16.932 6.13688 17.0145 6.35201L17.5104 7.99045"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const reportsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7 18V16M12 18V15M17 18V13M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99219 11.4853C8.14729 11.5571 13.0341 11.2318 15.8137 6.82035M13.9923 6.28738L15.8678 5.98552C16.0964 5.95641 16.432 6.13688 16.5145 6.35201L17.0104 7.99045"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const reportsActiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7 18V16M12 18V15M17 18V13M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99219 11.4853C8.14729 11.5571 13.0341 11.2318 15.8137 6.82035M13.9923 6.28738L15.8678 5.98552C16.0964 5.95641 16.432 6.13688 16.5145 6.35201L17.0104 7.99045"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CopyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      y="0.232422"
      width="23.5352"
      height="23.5352"
      rx="5.47329"
      fill="#F8FFCF"
      fill-opacity="0.72"
    />
    <path
      d="M14.7576 10.6211C14.7563 9.00643 14.7319 8.17005 14.2618 7.59738C14.171 7.48678 14.0696 7.38537 13.959 7.29461C13.3548 6.79883 12.4573 6.79883 10.662 6.79883C8.86678 6.79883 7.96916 6.79883 7.36501 7.29461C7.2544 7.38537 7.15299 7.48678 7.06222 7.59738C6.56641 8.20149 6.56641 9.09905 6.56641 10.8941C6.56641 12.6893 6.56641 13.5868 7.06222 14.1909C7.15298 14.3015 7.2544 14.4029 7.36501 14.4937C7.93772 14.9637 8.77416 14.9881 10.389 14.9894"
      stroke="#4285F4"
      stroke-width="0.820994"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1514 10.6444L14.7747 10.6211M13.1438 17.747L14.7669 17.7236M17.499 13.3797L17.4837 14.9997M10.405 13.3872L10.3896 15.007M11.7607 10.6444C11.3049 10.7261 10.5733 10.81 10.405 11.7524M16.1433 17.7236C16.6003 17.649 17.3331 17.5763 17.516 16.6366M16.1433 10.6444C16.5991 10.7261 17.3307 10.81 17.499 11.7524M11.7676 17.7229C11.3118 17.6415 10.5801 17.5579 10.4113 16.6157"
      stroke="#4285F4"
      stroke-width="0.820994"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const addNewTrentIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7.5C12 9.433 10.433 11 8.5 11C6.567 11 5 9.433 5 7.5C5 5.567 6.567 4 8.5 4C10.433 4 12 5.567 12 7.5Z"
      stroke="#F8FFCF"
      strokeWidth={1.5}
    />
    <path
      d="M13.5 11C15.433 11 17 9.433 17 7.5C17 5.567 15.433 4 13.5 4"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M13.1429 20H3.85714C2.83147 20 2 19.2325 2 18.2857C2 15.9188 4.07868 14 6.64286 14H10.3571C11.4023 14 12.3669 14.3188 13.1429 14.8568"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 14V20M22 17H16"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export const ViewDetailsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M1.66699 7.16667C1.66699 7.16667 5.39795 3 10.0003 3C14.6027 3 18.3337 7.16667 18.3337 7.16667"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M17.9537 11.3715C18.207 11.7267 18.3337 11.9044 18.3337 12.1673C18.3337 12.4302 18.207 12.6079 17.9537 12.9632C16.8152 14.5595 13.908 18.0007 10.0003 18.0007C6.09264 18.0007 3.18541 14.5595 2.04703 12.9632C1.79367 12.6079 1.66699 12.4302 1.66699 12.1673C1.66699 11.9044 1.79367 11.7267 2.04703 11.3715C3.18541 9.77515 6.09264 6.33398 10.0003 6.33398C13.908 6.33398 16.8152 9.77515 17.9537 11.3715Z"
      stroke="#141B34"
      stroke-width="1.25"
    />
    <path
      d="M12.5 12.166C12.5 10.7853 11.3807 9.66602 10 9.66602C8.61925 9.66602 7.5 10.7853 7.5 12.166C7.5 13.5468 8.61925 14.666 10 14.666C11.3807 14.666 12.5 13.5468 12.5 12.166Z"
      stroke="#141B34"
      stroke-width="1.25"
    />
  </svg>
);
export const threeDotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M11.4746 9L11.455 9.25325L11.4157 9.48701L11.3568 9.72078L11.2782 9.95455L11.18 10.1688L11.0425 10.3636L10.905 10.5584L10.7478 10.7338L10.571 10.8896L10.3746 11.026L10.1782 11.1623L9.96211 11.2597L9.7264 11.3377L9.49068 11.3961L9.25497 11.4351L8.99961 11.4545L8.74425 11.4351L8.50854 11.3961L8.27282 11.3377L8.03711 11.2597L7.82104 11.1623L7.62461 11.026L7.42818 10.8896L7.25139 10.7338L7.09425 10.5584L6.95675 10.3636L6.81925 10.1688L6.72104 9.95455L6.64247 9.72078L6.58354 9.48701L6.54425 9.25325L6.52461 9L6.54425 8.74675L6.58354 8.51299L6.64247 8.27922L6.72104 8.04545L6.81925 7.83117L6.95675 7.63636L7.09425 7.44156L7.25139 7.26623L7.42818 7.11039L7.62461 6.97403L7.82104 6.83766L8.03711 6.74026L8.27282 6.66234L8.50854 6.6039L8.74425 6.56494L8.99961 6.54546L9.25497 6.56494L9.49068 6.6039L9.72639 6.66234L9.96211 6.74026L10.1782 6.83766L10.3746 6.97403L10.571 7.11039L10.7478 7.26623L10.905 7.44156L11.0425 7.63636L11.18 7.83117L11.2782 8.04545L11.3568 8.27922L11.4157 8.51299L11.455 8.74675L11.4746 9ZM11.4746 2.45455L11.455 2.70779L11.4157 2.94156L11.3568 3.17532L11.2782 3.40909L11.18 3.62338L11.0425 3.81818L10.905 4.01299L10.7478 4.18831L10.571 4.34416L10.3746 4.48052L10.1782 4.61688L9.96211 4.71429L9.72639 4.79221L9.49068 4.85065L9.25497 4.88961L8.99961 4.90909L8.74425 4.88961L8.50854 4.85065L8.27282 4.79221L8.03711 4.71429L7.82104 4.61688L7.62461 4.48052L7.42818 4.34416L7.25139 4.18831L7.09425 4.01299L6.95675 3.81818L6.81925 3.62338L6.72104 3.40909L6.64247 3.17532L6.58354 2.94156L6.54425 2.70779L6.52461 2.45455L6.54425 2.2013L6.58354 1.96753L6.64247 1.73377L6.72104 1.5L6.81925 1.28571L6.95675 1.09091L7.09425 0.896104L7.25139 0.720779L7.42818 0.564935L7.62461 0.428571L7.82104 0.292208L8.03711 0.194805L8.27282 0.116883L8.50854 0.0584416L8.74425 0.0194806L8.99961 2.95141e-08L9.25497 0.0194805L9.49068 0.0584416L9.72639 0.116883L9.96211 0.194805L10.1782 0.292208L10.3746 0.428571L10.571 0.564935L10.7478 0.720779L10.905 0.896104L11.0425 1.09091L11.18 1.28571L11.2782 1.5L11.3568 1.73377L11.4157 1.96753L11.455 2.2013L11.4746 2.45455ZM11.4746 15.5455L11.455 15.7987L11.4157 16.0325L11.3568 16.2662L11.2782 16.5L11.18 16.7143L11.0425 16.9091L10.905 17.1039L10.7478 17.2792L10.571 17.4351L10.3746 17.5714L10.1782 17.7078L9.96211 17.8052L9.7264 17.8831L9.49068 17.9416L9.25497 17.9805L8.99961 18L8.74425 17.9805L8.50854 17.9416L8.27282 17.8831L8.03711 17.8052L7.82104 17.7078L7.62461 17.5714L7.42818 17.4351L7.25139 17.2792L7.09425 17.1039L6.95675 16.9091L6.81925 16.7143L6.72104 16.5L6.64247 16.2662L6.58354 16.0325L6.54425 15.7987L6.52461 15.5455L6.54425 15.2922L6.58354 15.0584L6.64247 14.8247L6.72104 14.5909L6.81925 14.3766L6.95675 14.1818L7.09425 13.987L7.25139 13.8117L7.42818 13.6558L7.62461 13.5195L7.82104 13.3831L8.03711 13.2857L8.27282 13.2078L8.50854 13.1494L8.74425 13.1104L8.99961 13.0909L9.25497 13.1104L9.49068 13.1494L9.7264 13.2078L9.96211 13.2857L10.1782 13.3831L10.3746 13.5195L10.571 13.6558L10.7478 13.8117L10.905 13.987L11.0425 14.1818L11.18 14.3766L11.2782 14.5909L11.3568 14.8247L11.4157 15.0584L11.455 15.2922L11.4746 15.5455Z"
      fill="#49454E"
    />
  </svg>
);
export const PaginationLeftArrow = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 15C12.5 15 7.5 11.3176 7.5 10C7.5 8.68233 12.5 5 12.5 5"
      stroke="#787891"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaginationRightArrow = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50004 5C7.50004 5 12.5 8.68242 12.5 10C12.5 11.3177 7.5 15 7.5 15"
      stroke="#787891"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownArrowSelect = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 7.50004C15 7.50004 11.3176 12.5 10 12.5C8.68233 12.5 5 7.5 5 7.5"
      stroke="black"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AcmeCoOperationErrorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#4285F4" />
    <path
      d="M20.0003 28.3337C24.6027 28.3337 28.3337 24.6027 28.3337 20.0003C28.3337 15.398 24.6027 11.667 20.0003 11.667C15.398 11.667 11.667 15.398 11.667 20.0003C11.667 24.6027 15.398 28.3337 20.0003 28.3337Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 23.333V19.583"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 16.6763V16.668"
      stroke="white"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const AcmeCoOperationErrorIcon1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#F45C0C" />
    <path
      d="M20.0003 28.3337C24.6027 28.3337 28.3337 24.6027 28.3337 20.0003C28.3337 15.398 24.6027 11.667 20.0003 11.667C15.398 11.667 11.667 15.398 11.667 20.0003C11.667 24.6027 15.398 28.3337 20.0003 28.3337Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 23.333V19.583"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 16.6763V16.668"
      stroke="white"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const NotIcon = (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4993 18.8327C15.1017 18.8327 18.8327 15.1017 18.8327 10.4993C18.8327 5.89698 15.1017 2.16602 10.4993 2.16602C5.89698 2.16602 2.16602 5.89698 2.16602 10.4993C2.16602 15.1017 5.89698 18.8327 10.4993 18.8327Z"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13.834V10.084"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 7.1763V7.16797"
      stroke="white"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const GrowthIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.99967 4.43322C5.99967 4.43322 10.6252 4.0714 11.2766 4.72276C11.9279 5.37412 11.5661 9.99968 11.5661 9.99968M10.9997 4.99968L4.33301 11.6663"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const LowRiskIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12 8.33301C12 8.33301 9.05407 12.333 8 12.333C6.94587 12.333 4 8.33301 4 8.33301"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 3.66699C12 3.66699 9.05407 7.66699 8 7.66699C6.94587 7.66699 4 3.66699 4 3.66699"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const NewNotificationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M13.1663 12.0003V6.33366C13.1663 3.75633 11.077 1.66699 8.49967 1.66699C5.92235 1.66699 3.83301 3.75633 3.83301 6.33366V12.0003"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.1663 12H2.83301"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5 13.333C9.5 13.8853 9.05227 14.333 8.5 14.333M8.5 14.333C7.94773 14.333 7.5 13.8853 7.5 13.333M8.5 14.333V13.333"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const CommunicationsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0043 12H12.0133M15.9998 12H16.0088M8.00879 12H8.01776"
      stroke="#B4B4B4"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.63177 19.362 4.37462 20.2979 3.26592 20.4658C3.09774 20.4913 2.93024 20.4302 2.80997 20.31C2.62741 20.1274 2.59266 19.8451 2.6935 19.6074C3.12865 18.5818 3.5282 16.6382 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const HealthIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M19.9626 3.99317C17.2809 2.34825 14.9404 3.01113 13.5344 4.06703C12.9578 4.49998 12.6696 4.71646 12.5 4.71646C12.3304 4.71646 12.0422 4.49998 11.4656 4.06703C10.0596 3.01113 7.71909 2.34825 5.03744 3.99317C1.51807 6.15196 0.721718 13.2739 8.83953 19.2824C10.3857 20.4269 11.1588 20.9991 12.5 20.9991C13.8412 20.9991 14.6143 20.4269 16.1605 19.2824C24.2783 13.2739 23.4819 6.15196 19.9626 3.99317Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.5 9V15M9.5 12H15.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const MentoringIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.5 22L10.5 16H2.5L4.5 22H12.5ZM12.5 22H16.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 13V12.5C12.5 10.6144 12.5 9.67157 11.9142 9.08579C11.3284 8.5 10.3856 8.5 8.5 8.5C6.61438 8.5 5.67157 8.5 5.08579 9.08579C4.5 9.67157 4.5 10.6144 4.5 12.5V13"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5 13C19.5 14.1046 18.6046 15 17.5 15C16.3954 15 15.5 14.1046 15.5 13C15.5 11.8954 16.3954 11 17.5 11C18.6046 11 19.5 11.8954 19.5 13Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
    />
    <path
      d="M10.5 4C10.5 5.10457 9.60457 6 8.5 6C7.39543 6 6.5 5.10457 6.5 4C6.5 2.89543 7.39543 2 8.5 2C9.60457 2 10.5 2.89543 10.5 4Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
    />
    <path
      d="M14.5 17.5H20.5C21.6046 17.5 22.5 18.3954 22.5 19.5V20C22.5 21.1046 21.6046 22 20.5 22H19.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const HomeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M3.5 11.9896V14.5C3.5 17.7998 3.5 19.4497 4.52513 20.4749C5.55025 21.5 7.20017 21.5 10.5 21.5H14.5C17.7998 21.5 19.4497 21.5 20.4749 20.4749C21.5 19.4497 21.5 17.7998 21.5 14.5V11.9896C21.5 10.3083 21.5 9.46773 21.1441 8.74005C20.7882 8.01237 20.1247 7.49628 18.7976 6.46411L16.7976 4.90855C14.7331 3.30285 13.7009 2.5 12.5 2.5C11.2991 2.5 10.2669 3.30285 8.20242 4.90855L6.20241 6.46411C4.87533 7.49628 4.21179 8.01237 3.8559 8.74005C3.5 9.46773 3.5 10.3083 3.5 11.9896Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 17C14.7005 17.6224 13.6502 18 12.5 18C11.3497 18 10.2995 17.6224 9.5 17"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const plusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.5 4V20M20.5 12H4.5"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const PhoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M9.65826 5.71223L9.2556 4.80625C8.99232 4.21388 8.86068 3.91768 8.66381 3.69101C8.41708 3.40694 8.09547 3.19794 7.73568 3.08785C7.44859 3 7.12446 3 6.47621 3C5.52791 3 5.05376 3 4.65573 3.18229C4.18687 3.39702 3.76344 3.86328 3.59473 4.3506C3.45151 4.76429 3.49254 5.18943 3.57458 6.0397C4.44791 15.0902 9.40982 20.0521 18.4603 20.9255C19.3106 21.0075 19.7358 21.0485 20.1494 20.9053C20.6368 20.7366 21.103 20.3132 21.3178 19.8443C21.5 19.4463 21.5 18.9721 21.5 18.0238C21.5 17.3756 21.5 17.0515 21.4122 16.7644C21.3021 16.4046 21.0931 16.083 20.809 15.8362C20.5824 15.6394 20.2862 15.5077 19.6938 15.2444L18.7878 14.8418C18.1463 14.5567 17.8255 14.4141 17.4996 14.3831C17.1876 14.3534 16.8731 14.3972 16.5811 14.5109C16.276 14.6297 16.0064 14.8544 15.467 15.3039C14.9302 15.7512 14.6618 15.9749 14.3338 16.0947C14.043 16.201 13.6586 16.2403 13.3524 16.1952C13.0069 16.1443 12.7424 16.0029 12.2133 15.7202C10.5673 14.8405 9.65953 13.9328 8.77987 12.2868C8.49714 11.7577 8.35578 11.4932 8.30487 11.1477C8.25974 10.8415 8.29908 10.4571 8.4053 10.1663C8.52512 9.83828 8.74881 9.56986 9.19619 9.033C9.64562 8.49368 9.87034 8.22402 9.98915 7.91891C10.1028 7.62694 10.1466 7.3124 10.1169 7.00048C10.0859 6.67452 9.94338 6.35376 9.65826 5.71223Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const trophyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.5 12V18"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.5 18C10.8264 18 9.36971 19.012 8.61766 20.505C8.25846 21.218 8.77389 22 9.45877 22H15.5412C16.2261 22 16.7415 21.218 16.3823 20.505C15.6303 19.012 14.1736 18 12.5 18Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M5.5 5H4.48471C3.49819 5 3.00493 5 2.70017 5.37053C2.39541 5.74106 2.48478 6.15597 2.66352 6.9858C3.00494 8.57086 3.74548 9.9634 4.7489 11"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19.5 5H20.5153C21.5018 5 21.9951 5 22.2998 5.37053C22.6046 5.74106 22.5152 6.15597 22.3365 6.9858C21.9951 8.57086 21.2545 9.9634 20.2511 11"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.5 12C16.366 12 19.5 8.8831 19.5 5.03821C19.5 4.93739 19.4978 4.83707 19.4936 4.73729C19.4509 3.73806 19.4295 3.23845 18.7523 2.61922C18.0751 2 17.3247 2 15.824 2H9.17596C7.67526 2 6.92492 2 6.24772 2.61922C5.57051 3.23844 5.54915 3.73806 5.50642 4.73729C5.50215 4.83707 5.5 4.93739 5.5 5.03821C5.5 8.8831 8.63401 12 12.5 12Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const AddUserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M15.5 8C15.5 5.23858 13.2614 3 10.5 3C7.73858 3 5.5 5.23858 5.5 8C5.5 10.7614 7.73858 13 10.5 13C13.2614 13 15.5 10.7614 15.5 8Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 21V14M14.5 17.5H21.5"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.5 20C3.5 16.134 6.63401 13 10.5 13C11.9872 13 13.3662 13.4638 14.5 14.2547"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CrossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
      fill="#646363"
    />
  </svg>
);
export const YellowWarningIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#FAAC14" />
    <path
      d="M20.0003 28.3327C24.6027 28.3327 28.3337 24.6017 28.3337 19.9993C28.3337 15.397 24.6027 11.666 20.0003 11.666C15.398 11.666 11.667 15.397 11.667 19.9993C11.667 24.6017 15.398 28.3327 20.0003 28.3327Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 23.334V19.584"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 16.6763V16.668"
      stroke="white"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ViewAllIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 7.3335L4 12.0002"
      stroke="#4285F4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3603 4.05519L9.53246 4.13045C8.1912 4.25238 7.5206 4.31335 7.3628 4.74925C7.20493 5.18516 7.68113 5.66132 8.63347 6.61364L9.386 7.3662C10.3383 8.31853 10.8145 8.79473 11.2504 8.63687C11.6863 8.47907 11.7473 7.80847 11.8692 6.46719L11.9445 5.63935C12.0179 4.83177 12.0546 4.42799 11.8131 4.18653C11.5717 3.94507 11.1679 3.98177 10.3603 4.05519Z"
      stroke="#4285F4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BackArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 15C12.5 15 7.5 11.3176 7.5 10C7.5 8.68233 12.5 5 12.5 5"
      stroke="#787891"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AddLogCommunicationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0003 6.24967C10.0003 7.86051 8.69449 9.16634 7.08366 9.16634C5.47283 9.16634 4.16699 7.86051 4.16699 6.24967C4.16699 4.63884 5.47283 3.33301 7.08366 3.33301C8.69449 3.33301 10.0003 4.63884 10.0003 6.24967Z"
      stroke="#F8FFCF"
      stroke-width="1.5"
    />
    <path
      d="M11.25 9.16634C12.8608 9.16634 14.1667 7.86051 14.1667 6.24967C14.1667 4.63884 12.8608 3.33301 11.25 3.33301"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.9527 16.667H3.21461C2.35988 16.667 1.66699 16.0274 1.66699 15.2384C1.66699 13.266 3.39923 11.667 5.53604 11.667H8.63124C9.50224 11.667 10.3061 11.9327 10.9527 12.381"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.833 11.667V16.667M18.333 14.167H13.333"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const CompanyInfoIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 22H20"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M17 9H14M18 13H14M18 17H14"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M6 22V3.2C6 2.42385 6.47098 2 7.2 2C8.87221 2 9.70832 2 10.4079 2.1108C14.2589 2.72075 17.2793 5.74106 17.8892 9.59209C18 10.2917 18 11.1278 18 12.8V22"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PlansModulesIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6H21"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M11 12H21"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M11 18H21"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M3 7.39286C3 7.39286 4 8.04466 4.5 9C4.5 9 6 5.25 8 4"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 18.3929C3 18.3929 4 19.0447 4.5 20C4.5 20 6 16.25 8 15"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ConfigurationIcon = (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 19.8571V21M17 19.8571C15.9878 19.8571 15.0961 19.3521 14.573 18.5852M17 19.8571C18.0122 19.8571 18.9039 19.3521 19.427 18.5852M14.573 18.5852L13.5004 19.2857M14.573 18.5852C14.2637 18.1316 14.0833 17.5864 14.0833 17C14.0833 16.4136 14.2636 15.8685 14.5729 15.415M19.427 18.5852L20.4996 19.2857M19.427 18.5852C19.7363 18.1316 19.9167 17.5864 19.9167 17C19.9167 16.4136 19.7364 15.8685 19.4271 15.415M17 14.1429C18.0123 14.1429 18.9041 14.648 19.4271 15.415M17 14.1429C15.9877 14.1429 15.0959 14.648 14.5729 15.415M17 14.1429V13M19.4271 15.415L20.5 14.7143M14.5729 15.415L13.5 14.7143"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.5 3H20.5"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.5 9H20.5"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.5 15H9.5"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export const ReviewCreateIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
      stroke="#9BA2AB"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CheckMarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      fill="#4285F4"
      stroke="#4285F4"
      stroke-width="1.5"
    />
    <path
      d="M8 12.5L10.5 15L16 9"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const GeneralIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21.5H10C6.22876 21.5 4.34315 21.5 3.17157 20.3284C2 19.1569 2 17.2712 2 13.5V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H12C15.7712 2.5 17.6569 2.5 18.8284 3.67157C20 4.84315 20 6.72876 20 10.5V11"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4069 14.9036C17.6192 14.3655 18.3808 14.3655 18.5931 14.9036L18.6298 14.9969C19.1482 16.3113 20.1887 17.3518 21.5031 17.8702L21.5964 17.9069C22.1345 18.1192 22.1345 18.8808 21.5964 19.0931L21.5031 19.1298C20.1887 19.6482 19.1482 20.6887 18.6298 22.0031L18.5931 22.0964C18.3808 22.6345 17.6192 22.6345 17.4069 22.0964L17.3702 22.0031C16.8518 20.6887 15.8113 19.6482 14.4969 19.1298L14.4036 19.0931C13.8655 18.8808 13.8655 18.1192 14.4036 17.9069L14.4969 17.8702C15.8113 17.3518 16.8518 16.3113 17.3702 14.9969L17.4069 14.9036Z"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7.5H15M7 12H15M7 16.5H11"
      stroke="#F8FFCF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SecurityIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7088 3.99534C16.8165 3.05382 14.5009 2.5 12 2.5C9.4991 2.5 7.1835 3.05382 5.29116 3.99534C4.36318 4.45706 3.89919 4.68792 3.4496 5.41378C3 6.13965 3 6.84248 3 8.24814V11.7371C3 17.4205 7.54236 20.5804 10.173 21.9338C10.9067 22.3113 11.2735 22.5 12 22.5C12.7265 22.5 13.0933 22.3113 13.8269 21.9338C16.4576 20.5804 21 17.4205 21 11.7371V8.24814C21 6.84249 21 6.13966 20.5504 5.41378C20.1008 4.68791 19.6368 4.45706 18.7088 3.99534Z"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12C9 12 10.4079 12.2519 11 14C11 14 12.5 11 15 10"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const APIConfigurationIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14.5L17.5 19M12 14.5L6.5 19M12 14.5V7.5"
      stroke="#888076"
      strokeWidth={1.5}
    />
    <path
      d="M10.3914 4.19046C11.1054 3.06349 11.4624 2.5 12 2.5C12.5376 2.5 12.8946 3.06349 13.6086 4.19046L14.1215 4.99995C14.8259 6.1118 15.1781 6.66772 14.9104 7.08386C14.6426 7.5 13.9327 7.5 12.5129 7.5H11.4871C10.0673 7.5 9.35739 7.5 9.08963 7.08386C8.82188 6.66772 9.17409 6.1118 9.87852 4.99995L10.3914 4.19046Z"
      stroke="#888076"
      strokeWidth={1.5}
    />
    <path
      d="M21.2324 19.6408C21.8559 20.8502 22.1676 21.4548 21.9085 21.9249C21.6494 22.3949 20.9936 22.4144 19.6819 22.4536L18.7398 22.4817C17.4457 22.5203 16.7987 22.5396 16.5705 22.0895C16.3422 21.6393 16.6843 21.0186 17.3686 19.7773L17.8629 18.8805C18.5471 17.6391 18.8893 17.0184 19.3756 17.0004C19.8619 16.9824 20.1694 17.5789 20.7846 18.7721L21.2324 19.6408Z"
      stroke="#888076"
      strokeWidth={1.5}
    />
    <path
      d="M2.76761 19.6408C2.14414 20.8502 1.8324 21.4548 2.09148 21.9249C2.35055 22.3949 3.00639 22.4144 4.31805 22.4536L5.26021 22.4817C6.55427 22.5203 7.20131 22.5396 7.42955 22.0895C7.65779 21.6393 7.31567 21.0186 6.63143 19.7773L6.13711 18.8805C5.45286 17.6391 5.11074 17.0184 4.62443 17.0004C4.13811 16.9824 3.83055 17.5789 3.21545 18.7721L2.76761 19.6408Z"
      stroke="#888076"
      strokeWidth={1.5}
    />
  </svg>
);

export const EmailConfigurationIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8L9.94202 9.73943C11.6572 10.7535 12.3428 10.7535 14.058 9.73943L17 8"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 20C11 20 10.0691 19.9878 9.09883 19.9634C5.95033 19.8843 4.37608 19.8448 3.24496 18.7094C2.11383 17.5739 2.08114 16.0412 2.01577 12.9756C1.99475 11.9899 1.99474 11.0101 2.01576 10.0244C2.08114 6.95885 2.11382 5.42608 3.24495 4.29065C4.37608 3.15521 5.95033 3.11566 9.09882 3.03656C11.0393 2.98781 12.9607 2.98781 14.9012 3.03657C18.0497 3.11568 19.6239 3.15523 20.7551 4.29066C21.8862 5.42609 21.9189 6.95886 21.9842 10.0244C21.9918 10.3812 21.9967 10.9995 21.9988 11.5"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 20.7143V22M18 20.7143C16.8432 20.7143 15.8241 20.1461 15.2263 19.2833M18 20.7143C19.1568 20.7143 20.1759 20.1461 20.7737 19.2833M15.2263 19.2833L14.0004 20.0714M15.2263 19.2833C14.8728 18.773 14.6667 18.1597 14.6667 17.5C14.6667 16.8403 14.8727 16.2271 15.2262 15.7169M20.7737 19.2833L21.9996 20.0714M20.7737 19.2833C21.1272 18.773 21.3333 18.1597 21.3333 17.5C21.3333 16.8403 21.1273 16.2271 20.7738 15.7169M18 14.2857C19.1569 14.2857 20.1761 14.854 20.7738 15.7169M18 14.2857C16.8431 14.2857 15.8239 14.854 15.2262 15.7169M18 14.2857V13M20.7738 15.7169L22 14.9286M15.2262 15.7169L14 14.9286"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export const BillingOperationsIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 19.1458V8.55426C4 5.70025 4 4.27325 4.87868 3.38663C5.75736 2.5 7.17157 2.5 10 2.5H14C16.8284 2.5 18.2426 2.5 19.1213 3.38663C20 4.27325 20 5.70025 20 8.55426V19.1458C20 20.6575 20 21.4133 19.538 21.7108C18.7831 22.1971 17.6161 21.1774 17.0291 20.8073C16.5441 20.5014 16.3017 20.3485 16.0325 20.3397C15.7417 20.3301 15.4949 20.4768 14.9709 20.8073L13.06 22.0124C12.5445 22.3374 12.2868 22.5 12 22.5C11.7132 22.5 11.4555 22.3374 10.94 22.0124L9.02913 20.8073C8.54415 20.5014 8.30166 20.3485 8.03253 20.3397C7.74172 20.3301 7.49493 20.4768 6.97087 20.8073C6.38395 21.1774 5.21687 22.1971 4.46195 21.7108C4 21.4133 4 20.6575 4 19.1458Z"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11.5H8"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7.5H8"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DunningManagementIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.5H10C6.22876 21.5 4.34315 21.5 3.17157 20.3284C2 19.1569 2 17.2712 2 13.5V11.5C2 7.72876 2 5.84315 3.17157 4.67157C4.34315 3.5 6.22876 3.5 10 3.5H14C17.7712 3.5 19.6569 3.5 20.8284 4.67157C22 5.84315 22 7.72876 22 11.5V13"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 9.5H22"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 15.5H12"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5803 13.7673C17.7466 13.4109 18.2534 13.4109 18.4197 13.7673L19.0465 15.1104C19.3226 15.7019 19.7981 16.1774 20.3896 16.4535L21.7327 17.0803C22.0891 17.2466 22.0891 17.7534 21.7327 17.9197L20.3896 18.5465C19.7981 18.8226 19.3226 19.2981 19.0465 19.8896L18.4197 21.2327C18.2534 21.5891 17.7466 21.5891 17.5803 21.2327L16.9535 19.8896C16.6774 19.2981 16.2019 18.8226 15.6104 18.5465L14.2673 17.9197C13.9109 17.7534 13.9109 17.2466 14.2673 17.0803L15.6104 16.4535C16.2019 16.1774 16.6774 15.7019 16.9535 15.1104L17.5803 13.7673Z"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3.5V21.5"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QuotePoliciesIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21C19.4255 20.809 19.7894 20.5612 20.1088 20.2395C21.5 18.8379 21.5 16.5821 21.5 12.0705C21.5 7.55894 21.5 5.30314 20.1088 3.90157C18.7175 2.5 16.4783 2.5 12 2.5C7.52166 2.5 5.28249 2.5 3.89124 3.90157C2.5 5.30314 2.5 7.55894 2.5 12.0705C2.5 16.5821 2.5 18.8379 3.89124 20.2395C4.21056 20.5612 4.57453 20.809 5 21"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M2.5 9H21.5"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M7 6H7.00898"
      stroke="#888076"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 6H11.009"
      stroke="#888076"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2596 16.878C9.1796 16.878 8.71714 17.6575 8.59714 18.1373C8.47714 18.617 8.47714 20.356 8.54914 21.0755C8.78914 21.975 9.38914 22.3468 9.97714 22.4667C10.5171 22.5147 12.7971 22.4967 13.4571 22.4967C14.4171 22.5147 15.1371 22.1549 15.4371 21.0755C15.4971 20.7157 15.5571 18.7369 15.4071 18.1373C15.0891 17.1778 14.36 16.878 13.76 16.878M10.2596 16.878H13.76M10.2596 16.878C10.2596 16.818 10.2582 16.0516 10.2596 15.6173C10.2609 15.2204 10.226 14.8378 10.4156 14.4876C11.126 13.0748 13.166 13.2187 13.67 14.6579C13.7573 14.8948 13.7626 15.2704 13.76 15.6173C13.7567 16.0605 13.76 16.878 13.76 16.878"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export const CancellationRulesIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 2.5C7.22876 2.5 5.34315 2.5 4.17157 3.62874C3 4.75748 3 6.57416 3 10.2075V18.4808C3 20.7867 3 21.9396 3.77285 22.3523C5.26947 23.1514 8.0768 20.4852 9.41 19.6824C10.1832 19.2168 10.5698 18.984 11 18.984C11.4302 18.984 11.8168 19.2168 12.59 19.6824C13.9232 20.4852 16.7305 23.1514 18.2272 22.3523C19 21.9396 19 20.7867 19 18.4808V12"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 7.5H11"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M21 2.5L14 9.49954M21 9.5L14 2.50046"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlatformBrandingIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.5C15.7497 21.5 17.6246 21.5 18.9389 20.5451C19.3634 20.2367 19.7367 19.8634 20.0451 19.4389C21 18.1246 21 16.2497 21 12.5C21 8.75027 21 6.8754 20.0451 5.56107C19.7367 5.1366 19.3634 4.76331 18.9389 4.45491C17.6246 3.5 15.7497 3.5 12 3.5C8.25027 3.5 6.3754 3.5 5.06107 4.45491C4.6366 4.76331 4.26331 5.1366 3.95491 5.56107C3 6.8754 3 8.75027 3 12.5C3 16.2497 3 18.1246 3.95491 19.4389C4.26331 19.8634 4.6366 20.2367 5.06107 20.5451C6.3754 21.5 8.25027 21.5 12 21.5Z"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 7.5L8 17.5"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SandboxModeIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.5C11.1818 22.5 10.4002 22.1646 8.83693 21.4939C4.94564 19.8243 3 18.9895 3 17.5853V8.2475M12 22.5C12.8182 22.5 13.5998 22.1646 15.1631 21.4939C19.0544 19.8243 21 18.9895 21 17.5853V8.2475M12 22.5V12.6707M3 8.2475C3 8.85125 3.80157 9.2325 5.40472 9.995L8.32592 11.3844C10.1288 12.2419 11.0303 12.6707 12 12.6707M3 8.2475C3 7.64376 3.80157 7.2625 5.40472 6.5M21 8.2475C21 8.85125 20.1984 9.2325 18.5953 9.995L15.6741 11.3844C13.8712 12.2419 12.9697 12.6707 12 12.6707M21 8.2475C21 7.64376 20.1984 7.2625 18.5953 6.5M6.33203 13.811L8.32591 14.7594"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.5V4.5M16 3.5L14.5 5.5M8 3.5L9.5 5.5"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

export const StaffManagementIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9Z"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 21C19 17.134 15.866 14 12 14C8.13401 14 5 17.134 5 21"
      stroke="#888076"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DatePickerIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.57715 7.83594H17.4304"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7021 11.0898H13.7099"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0039 11.0898H10.0116"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.29785 11.0898H6.30557"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7021 14.3301H13.7099"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0039 14.3301H10.0116"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.29785 14.3301H6.30557"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3701 1.66602V4.40833"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6377 1.66602V4.40833"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5319 2.98242H6.4758C4.02856 2.98242 2.5 4.3457 2.5 6.85161V14.393C2.5 16.9383 4.02856 18.3331 6.4758 18.3331H13.5242C15.9791 18.3331 17.5 16.9619 17.5 14.456V6.85161C17.5077 4.3457 15.9868 2.98242 13.5319 2.98242Z"
      stroke="black"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TooltipsIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3327 9.9987C18.3327 5.39633 14.6017 1.66536 9.99935 1.66536C5.39698 1.66536 1.66602 5.39633 1.66602 9.9987C1.66602 14.6011 5.39698 18.332 9.99935 18.332C14.6017 18.332 18.3327 14.6011 18.3327 9.9987Z"
      stroke="#787891"
      strokeWidth={1.5}
    />
    <path
      d="M10.2025 14.166V9.99935C10.2025 9.60651 10.2025 9.41009 10.0804 9.28805C9.9584 9.16602 9.76198 9.16602 9.36914 9.16602"
      stroke="#787891"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99398 6.66602H10.0015"
      stroke="#787891"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BluePlusIcon = (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50195 3.33398V12.6686"
      stroke="#4285F4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1687 8.00195H3.83398"
      stroke="#4285F4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FeedbackDashbordIcon = (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 2H10.5C7.22077 2 5.58116 2 4.41891 2.81382C3.98891 3.1149 3.6149 3.48891 3.31382 3.91891C2.5 5.08116 2.5 6.72077 2.5 10C2.5 13.2792 2.5 14.9188 3.31382 16.0811C3.6149 16.5111 3.98891 16.8851 4.41891 17.1862C5.58116 18 7.22077 18 10.5 18H14.5C17.7792 18 19.4188 18 20.5811 17.1862C21.0111 16.8851 21.3851 16.5111 21.6862 16.0811C22.5 14.9188 22.5 13.2792 22.5 10"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M19.3295 2.75418C19.6276 2.43123 19.7766 2.26976 19.935 2.17557C20.3171 1.9483 20.7876 1.94124 21.1761 2.15693C21.3372 2.24632 21.4908 2.40325 21.798 2.7171C22.1053 3.03096 22.2589 3.18789 22.3464 3.35237C22.5575 3.74925 22.5506 4.22992 22.3281 4.62028C22.2359 4.78206 22.0779 4.93431 21.7617 5.2388L18.0003 8.86172C17.4012 9.43875 17.1016 9.72727 16.7272 9.87349C16.3528 10.0197 15.9413 10.009 15.1181 9.98743L15.0062 9.9845C14.7556 9.97795 14.6303 9.97467 14.5574 9.89202C14.4846 9.80936 14.4945 9.68173 14.5144 9.42647L14.5252 9.28786C14.5812 8.56942 14.6092 8.2102 14.7495 7.88729C14.8898 7.56438 15.1318 7.30219 15.6158 6.7778L19.3295 2.75418Z"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M15.1557 22L14.7369 21.5811C13.7926 20.6369 13.5585 19.1944 14.1557 18"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M9.5 22L9.91886 21.5811C10.8631 20.6369 11.0972 19.1944 10.5 18"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M7.5 22H17.5"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M8.5 10H15.5"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FeedbackListIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 14.5V6.5C20 4.61438 20 3.67157 19.4142 3.08579C18.8284 2.5 17.8856 2.5 16 2.5H8C6.11438 2.5 5.17157 2.5 4.58579 3.08579C4 3.67157 4 4.61438 4 6.5V14.5"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.49762 15.5154L4.01953 14.5H19.9518L20.5023 15.5154C21.9452 18.177 22.3046 19.5077 21.7561 20.5039C21.2077 21.5 19.7536 21.5 16.8454 21.5H7.15462C4.24642 21.5 2.79231 21.5 2.24387 20.5039C1.69543 19.5077 2.05474 18.177 3.49762 15.5154Z"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 7L16.4199 7.79289C16.8066 8.12623 17 8.29289 17 8.5C17 8.70711 16.8066 8.87377 16.4199 9.20711L15.5 10"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 7L7.58009 7.79289C7.19337 8.12623 7 8.29289 7 8.5C7 8.70711 7.19336 8.87377 7.58009 9.20711L8.5 10"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 6L11 11"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RoadMapIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3702 16.2713L20.465 15.2776C21.5834 14.9184 21.8652 13.4928 20.9647 12.749L18.5414 10.7472M17.3702 16.2713L15.6246 16.8319C14.8533 17.0796 14.1247 17.441 13.464 17.9038L12.1229 18.8432M17.3702 16.2713L17.4325 14.7768C17.4671 13.9453 17.636 13.1245 17.9329 12.345L18.5414 10.7472M17.3702 16.2713L17.2401 19.3942C17.193 20.5254 15.9184 21.1841 14.942 20.5819L12.1229 18.8432M18.5414 10.7472L19.657 7.81789C20.0649 6.74666 19.1288 5.64722 17.9828 5.85166L14.7505 6.42828M18.5414 10.7472L17.3209 9.73905C16.6858 9.21445 16.1377 8.59606 15.6961 7.90606L14.7505 6.42828M12.1229 18.8432L9.43738 20.7242C8.50033 21.3805 7.19058 20.7997 7.07263 19.6754L6.74168 16.5208M12.1229 18.8432L10.5594 17.8788C9.87224 17.455 9.12342 17.1362 8.33865 16.9335L6.74168 16.5208M6.74168 16.5208L3.61989 15.7141C2.48271 15.4203 2.11569 14.0149 2.96854 13.22L5.2878 11.0584M6.74168 16.5208L6.43349 13.5832L5.2878 11.0584M5.2878 11.0584L4.00706 8.23589C3.53226 7.18955 4.40146 6.03466 5.55954 6.17312L8.85203 6.56678M5.2878 11.0584L6.58864 9.84595C7.1925 9.28313 7.70325 8.63126 8.10245 7.91385L8.85203 6.56678M8.85203 6.56678L10.4099 3.76716C10.9595 2.7795 12.3882 2.73674 12.998 3.68971L14.7505 6.42828M8.85203 6.56678L10.7141 6.78942C11.5126 6.88489 12.3213 6.86164 13.1127 6.72045L14.7505 6.42828"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);

export const FeedbackAnalyticsIcon = (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 9V20"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4V20"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 11V20"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 7V20"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 14V20"
      stroke="#B4B4B4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SupportIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.166 10.3377C14.166 10.0497 14.166 9.90565 14.2093 9.77732C14.3353 9.40432 14.6675 9.25965 15.0003 9.10807C15.3743 8.93765 15.5613 8.85248 15.7467 8.83748C15.9571 8.82047 16.1678 8.86582 16.3477 8.96673C16.5861 9.10048 16.7523 9.35473 16.9226 9.56148C17.7088 10.5163 18.1018 10.9938 18.2456 11.5203C18.3617 11.9452 18.3617 12.3895 18.2456 12.8143C18.0358 13.5822 17.3731 14.226 16.8825 14.8218C16.6316 15.1266 16.5061 15.279 16.3477 15.3679C16.1678 15.4688 15.9571 15.5142 15.7467 15.4972C15.5613 15.4822 15.3743 15.397 15.0003 15.2266C14.6675 15.075 14.3353 14.9303 14.2093 14.5573C14.166 14.429 14.166 14.285 14.166 13.9969V10.3377Z"
      stroke="white"
      strokeWidth={1.25}
    />
    <path
      d="M5.83268 10.3378C5.83268 9.97513 5.8225 9.64913 5.52927 9.39413C5.42262 9.30138 5.28122 9.23696 4.99844 9.10813C4.62436 8.93779 4.43732 8.85263 4.25198 8.83763C3.69594 8.79263 3.39678 9.17213 3.07612 9.56163C2.28997 10.5165 1.8969 10.9939 1.75307 11.5204C1.637 11.9453 1.637 12.3896 1.75307 12.8145C1.96285 13.5824 2.62562 14.226 3.11619 14.822C3.42542 15.1975 3.72082 15.5402 4.25198 15.4973C4.43732 15.4823 4.62436 15.397 4.99844 15.2267C5.28122 15.0979 5.42262 15.0335 5.52927 14.9407C5.8225 14.6857 5.83268 14.3598 5.83268 13.997V10.3378Z"
      stroke="white"
      strokeWidth={1.25}
    />
    <path
      d="M16.6673 9.24935V7.99935C16.6673 4.77769 13.6826 2.16602 10.0007 2.16602C6.31875 2.16602 3.33398 4.77769 3.33398 7.99935V9.24935"
      stroke="white"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6667 15.084C16.6667 18.834 13.3333 18.834 10 18.834"
      stroke="white"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ThumbUpIcon = (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.83398 8.33333C1.83398 7.59693 2.43094 7 3.16732 7C4.27188 7 5.16732 7.8954 5.16732 9V11.6667C5.16732 12.7713 4.27188 13.6667 3.16732 13.6667C2.43094 13.6667 1.83398 13.0697 1.83398 12.3333V8.33333Z"
      stroke="#141B34"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8185 5.20482L10.6409 5.77821C10.4955 6.24806 10.4227 6.48298 10.4787 6.66852C10.5239 6.81858 10.6233 6.94798 10.7587 7.03312C10.926 7.13832 11.1791 7.13832 11.6854 7.13832H11.9547C13.6681 7.13832 14.5248 7.13832 14.9295 7.64552C14.9757 7.70345 15.0168 7.76512 15.0524 7.82978C15.3637 8.39538 15.0098 9.15738 14.302 10.6814C13.6525 12.0799 13.3277 12.7792 12.7247 13.1908C12.6663 13.2306 12.6064 13.2682 12.5449 13.3034C11.91 13.6673 11.1235 13.6673 9.55028 13.6673H9.20908C7.30315 13.6673 6.3502 13.6673 5.75811 13.0937C5.16602 12.5199 5.16602 11.5966 5.16602 9.74992V9.10085C5.16602 8.13038 5.16602 7.64518 5.33824 7.20105C5.51047 6.75692 5.84025 6.39175 6.49981 5.6614L9.22742 2.64102C9.29582 2.56528 9.33002 2.5274 9.36022 2.50115C9.64168 2.25617 10.0761 2.28374 10.3223 2.56222C10.3487 2.59205 10.3775 2.63392 10.4351 2.71768C10.5252 2.84868 10.5703 2.91419 10.6096 2.97908C10.9612 3.56007 11.0676 4.25022 10.9065 4.90542C10.8885 4.9786 10.8652 5.05405 10.8185 5.20482Z"
      stroke="#141B34"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhiteBellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.6663 11.9993V6.33268C12.6663 3.75536 10.577 1.66602 7.99967 1.66602C5.42235 1.66602 3.33301 3.75536 3.33301 6.33268V11.9993"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.6663 12H2.33301"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 13.334C9 13.8863 8.55227 14.334 8 14.334M8 14.334C7.44773 14.334 7 13.8863 7 13.334M8 14.334V13.334"
      stroke="#F8FFCF"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const BlueDownloadExportIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.3337 12C10.3337 13.2887 9.28899 14.3333 8.00033 14.3333C6.71166 14.3333 5.66699 13.2887 5.66699 12"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.8207 11.9993H3.17925C2.52797 11.9993 2 11.4713 2 10.8201C2 10.5073 2.12424 10.2074 2.34539 9.98622L2.74755 9.58408C3.12262 9.20902 3.33333 8.70028 3.33333 8.16988V6.33268C3.33333 3.75536 5.42267 1.66602 8 1.66602C10.5773 1.66602 12.6667 3.75535 12.6667 6.33268V8.16988C12.6667 8.70028 12.8774 9.20902 13.2525 9.58408L13.6546 9.98622C13.8757 10.2074 14 10.5073 14 10.8201C14 11.4713 13.472 11.9993 12.8207 11.9993Z"
      stroke="#4285F4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M14.5 2H10.5C7.22077 2 5.58116 2 4.41891 2.81382C3.98891 3.1149 3.6149 3.48891 3.31382 3.91891C2.5 5.08116 2.5 6.72077 2.5 10C2.5 13.2792 2.5 14.9188 3.31382 16.0811C3.6149 16.5111 3.98891 16.8851 4.41891 17.1862C5.58116 18 7.22077 18 10.5 18H14.5C17.7792 18 19.4188 18 20.5811 17.1862C21.0111 16.8851 21.3851 16.5111 21.6862 16.0811C22.5 14.9188 22.5 13.2792 22.5 10"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19.3295 2.75418C19.6276 2.43123 19.7766 2.26976 19.935 2.17557C20.3171 1.9483 20.7876 1.94124 21.1761 2.15693C21.3372 2.24632 21.4908 2.40325 21.798 2.7171C22.1053 3.03096 22.2589 3.18789 22.3464 3.35237C22.5575 3.74925 22.5506 4.22992 22.3281 4.62028C22.2359 4.78206 22.0779 4.93431 21.7617 5.2388L18.0003 8.86172C17.4012 9.43875 17.1016 9.72727 16.7272 9.87349C16.3528 10.0197 15.9413 10.009 15.1181 9.98743L15.0062 9.9845C14.7556 9.97795 14.6303 9.97467 14.5574 9.89202C14.4846 9.80936 14.4945 9.68173 14.5144 9.42647L14.5252 9.28786C14.5812 8.56942 14.6092 8.2102 14.7495 7.88729C14.8898 7.56438 15.1318 7.30219 15.6158 6.7778L19.3295 2.75418Z"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M15.1557 22L14.7369 21.5811C13.7926 20.6369 13.5585 19.1944 14.1557 18"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M9.50098 22L9.91984 21.5811C10.8641 20.6369 11.0982 19.1944 10.501 18"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.5 22H17.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M8.5 10H15.5"
      stroke="#B4B4B4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ActiveProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M14.5 2H10.5C7.22077 2 5.58116 2 4.41891 2.81382C3.98891 3.1149 3.6149 3.48891 3.31382 3.91891C2.5 5.08116 2.5 6.72077 2.5 10C2.5 13.2792 2.5 14.9188 3.31382 16.0811C3.6149 16.5111 3.98891 16.8851 4.41891 17.1862C5.58116 18 7.22077 18 10.5 18H14.5C17.7792 18 19.4188 18 20.5811 17.1862C21.0111 16.8851 21.3851 16.5111 21.6862 16.0811C22.5 14.9188 22.5 13.2792 22.5 10"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19.3295 2.75418C19.6276 2.43123 19.7766 2.26976 19.935 2.17557C20.3171 1.9483 20.7876 1.94124 21.1761 2.15693C21.3372 2.24632 21.4908 2.40325 21.798 2.7171C22.1053 3.03096 22.2589 3.18789 22.3464 3.35237C22.5575 3.74925 22.5506 4.22992 22.3281 4.62028C22.2359 4.78206 22.0779 4.93431 21.7617 5.2388L18.0003 8.86172C17.4012 9.43875 17.1016 9.72727 16.7272 9.87349C16.3528 10.0197 15.9413 10.009 15.1181 9.98743L15.0062 9.9845C14.7556 9.97795 14.6303 9.97467 14.5574 9.89202C14.4846 9.80936 14.4945 9.68173 14.5144 9.42647L14.5252 9.28786C14.5812 8.56942 14.6092 8.2102 14.7495 7.88729C14.8898 7.56438 15.1318 7.30219 15.6158 6.7778L19.3295 2.75418Z"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M15.1557 22L14.7369 21.5811C13.7926 20.6369 13.5585 19.1944 14.1557 18"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M9.50098 22L9.91984 21.5811C10.8641 20.6369 11.0982 19.1944 10.501 18"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.5 22H17.5"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M8.5 10H15.5"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const BlackAddIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z"
      stroke="black"
      stroke-width="1.5"
    />
    <path
      d="M14 11C15.933 11 17.5 9.433 17.5 7.5C17.5 5.567 15.933 4 14 4"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.6429 20H4.35714C3.33147 20 2.5 19.2325 2.5 18.2857C2.5 15.9188 4.57868 14 7.14286 14H10.8571C11.9023 14 12.8669 14.3188 13.6429 14.8568"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5 14V20M22.5 17H16.5"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const BlackRefrechIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6737 2.16602V4.77617C16.6737 5.02106 16.3675 5.13192 16.2108 4.94379C14.6848 3.23893 12.4674 2.16602 9.99935 2.16602C5.39697 2.16602 1.66602 5.89697 1.66602 10.4993C1.66602 15.1017 5.39697 18.8327 9.99935 18.8327C14.6017 18.8327 18.3327 15.1017 18.3327 10.4993"
      stroke="black"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BlackExportIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 14.666C2.5 15.441 2.5 15.8285 2.58519 16.1464C2.81636 17.0091 3.49022 17.683 4.35296 17.9142C4.67087 17.9993 5.05836 17.9993 5.83333 17.9993H14.1667C14.9417 17.9993 15.3292 17.9993 15.6471 17.9142C16.5098 17.683 17.1837 17.0091 17.4148 16.1464C17.5 15.8285 17.5 15.441 17.5 14.666"
      stroke="black"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 10.0834C13.75 10.0834 10.9882 13.8334 9.99995 13.8334C9.01178 13.8334 6.25 10.0834 6.25 10.0834M9.99995 13V3"
      stroke="black"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlackUpArrow = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 10C12 10 9.05403 6.00001 7.99997 6C6.9459 5.99999 4 10 4 10"
      stroke="#01011D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlackDownArrow = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C12 6 9.05403 9.99999 7.99997 10C6.9459 10 4 6 4 6"
      stroke="#01011D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AssignIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6791 5.48597L13.8472 4.31784C14.4923 3.6727 15.5383 3.6727 16.1835 4.31784C16.8286 4.96298 16.8286 6.00897 16.1835 6.65411L15.0153 7.82224M12.6791 5.48597L5.81751 12.3476C4.94643 13.2186 4.51087 13.6542 4.21429 14.1849C3.91771 14.7157 3.61932 15.9689 3.33398 17.1673C4.53239 16.882 5.78564 16.5836 6.31639 16.287C6.84714 15.9904 7.28268 15.5549 8.15378 14.6838L15.0153 7.82224M12.6791 5.48597L15.0153 7.82224"
      stroke="#141B34"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16602 17.166H14.166"
      stroke="#141B34"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
  </svg>
);
export const ChangePriorityIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08398 10.5007C2.08398 6.7687 2.08398 4.90273 3.24335 3.74335C4.40273 2.58398 6.2687 2.58398 10.0007 2.58398C13.7326 2.58398 15.5986 2.58398 16.758 3.74335C17.9173 4.90273 17.9173 6.7687 17.9173 10.5007C17.9173 14.2326 17.9173 16.0986 16.758 17.258C15.5986 18.4173 13.7326 18.4173 10.0007 18.4173C6.2687 18.4173 4.40273 18.4173 3.24335 17.258C2.08398 16.0986 2.08398 14.2326 2.08398 10.5007Z"
      stroke="#141B34"
      strokeWidth={1.25}
    />
    <path
      d="M13.334 13.8327C13.8474 13.8327 14.2636 13.4063 14.2636 12.8803V11.8462C14.2636 11.5936 14.3615 11.3513 14.5358 11.1728L14.8645 10.8361C15.0461 10.6501 15.0461 10.3486 14.8645 10.1626L14.5358 9.82593C14.3615 9.64735 14.2636 9.4051 14.2636 9.15252V8.1184C14.2636 7.59241 13.8474 7.16602 13.334 7.16602"
      stroke="#141B34"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66666 13.8327C6.15326 13.8327 5.73706 13.4063 5.73706 12.8803V11.8462C5.73706 11.5936 5.63913 11.3513 5.4648 11.1728L5.13613 10.8361C4.95462 10.6501 4.95462 10.3486 5.13613 10.1626L5.4648 9.82593C5.63913 9.64735 5.73706 9.4051 5.73706 9.15252V8.1184C5.73706 7.59241 6.15326 7.16602 6.66666 7.16602"
      stroke="#141B34"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33398 10.5H8.34148M11.6598 10.5H11.6673"
      stroke="#141B34"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UpdatedStatusIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 18.8327C14.6017 18.8327 18.3327 15.1017 18.3327 10.4993C18.3327 5.89698 14.6017 2.16602 9.99935 2.16602C5.39698 2.16602 1.66602 5.89698 1.66602 10.4993C1.66602 15.1017 5.39698 18.8327 9.99935 18.8327Z"
      stroke="#141B34"
      strokeWidth={1.25}
    />
    <path
      d="M7.91602 8V13M12.0827 8V13"
      stroke="#141B34"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DeleteRedIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 5.08398L15.7336 13.4382C15.6016 15.5727 15.5357 16.6399 15.0007 17.4072C14.7361 17.7866 14.3956 18.1067 14.0006 18.3473C13.2017 18.834 12.1325 18.834 9.99392 18.834C7.8526 18.834 6.78192 18.834 5.98254 18.3464C5.58733 18.1054 5.24667 17.7847 4.98223 17.4047C4.4474 16.6362 4.38287 15.5674 4.25384 13.43L3.75 5.08398"
      stroke="#EB001B"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M2.5 5.08268H17.5M13.3797 5.08268L12.8109 3.90912C12.433 3.12957 12.244 2.73978 11.9181 2.49669C11.8458 2.44277 11.7693 2.3948 11.6892 2.35327C11.3283 2.16602 10.8951 2.16602 10.0287 2.16602C9.14067 2.16602 8.69667 2.16602 8.32973 2.36112C8.24842 2.40436 8.17082 2.45427 8.09774 2.51032C7.76803 2.76327 7.58386 3.16731 7.21551 3.9754L6.71077 5.08268"
      stroke="#EB001B"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M7.91602 14.25V9.25"
      stroke="#EB001B"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M12.084 14.25V9.25"
      stroke="#EB001B"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
  </svg>
);

export const activeFeedbackTriageIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0053 12H12.0143M16.0008 12H16.0098M8.00977 12H8.01874"
      stroke="#4285F4"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.63177 19.362 4.37462 20.2979 3.26592 20.4658C3.09774 20.4913 2.93024 20.4302 2.80997 20.31C2.62741 20.1274 2.59266 19.8451 2.6935 19.6074C3.12865 18.5818 3.5282 16.6382 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
      stroke="#4285F4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const feedbackTriageIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0053 12H12.0143M16.0008 12H16.0098M8.00977 12H8.01874"
      stroke="#5C5B62"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.63177 19.362 4.37462 20.2979 3.26592 20.4658C3.09774 20.4913 2.93024 20.4302 2.80997 20.31C2.62741 20.1274 2.59266 19.8451 2.6935 19.6074C3.12865 18.5818 3.5282 16.6382 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
      stroke="#5C5B62"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const securityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#5C5B62"
      stroke-width="1.5"
    />
    <path
      d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 13V16"
      stroke="#5C5B62"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const activeSecurityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#4285F4"
      stroke-width="1.5"
    />
    <path
      d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 13V16"
      stroke="#4285F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const RefreshAddIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M13.8391 1.33398V3.42211C13.8391 3.61802 13.5942 3.7067 13.4688 3.5562C12.2481 2.19232 10.4741 1.33398 8.49967 1.33398C4.81777 1.33398 1.83301 4.31875 1.83301 8.00065C1.83301 11.6825 4.81777 14.6673 8.49967 14.6673C12.1815 14.6673 15.1663 11.6825 15.1663 8.00065"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const TrustCenterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#52C41A" />
    <path
      d="M20.0003 28.3327C24.6027 28.3327 28.3337 24.6017 28.3337 19.9993C28.3337 15.397 24.6027 11.666 20.0003 11.666C15.398 11.666 11.667 15.397 11.667 19.9993C11.667 24.6017 15.398 28.3327 20.0003 28.3327Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 23.334V19.584"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 16.6763V16.668"
      stroke="white"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EditProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M12.6781 5.48597L13.8462 4.31784C14.4913 3.6727 15.5373 3.6727 16.1825 4.31784C16.8276 4.96298 16.8276 6.00897 16.1825 6.65411L15.0143 7.82224M12.6781 5.48597L5.81653 12.3476C4.94545 13.2186 4.50989 13.6542 4.21332 14.1849C3.91673 14.7157 3.61834 15.9689 3.33301 17.1673C4.53142 16.882 5.78467 16.5836 6.31542 16.287C6.84617 15.9904 7.28171 15.5549 8.1528 14.6838L15.0143 7.82224M12.6781 5.48597L15.0143 7.82224"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.16699 17.166H14.167"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

export const ManageCodesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M2.08301 10.5007C2.08301 6.7687 2.08301 4.90273 3.24237 3.74335C4.40175 2.58398 6.26772 2.58398 9.99967 2.58398C13.7316 2.58398 15.5976 2.58398 16.757 3.74335C17.9163 4.90273 17.9163 6.7687 17.9163 10.5007C17.9163 14.2326 17.9163 16.0986 16.757 17.258C15.5976 18.4173 13.7316 18.4173 9.99967 18.4173C6.26772 18.4173 4.40175 18.4173 3.24237 17.258C2.08301 16.0986 2.08301 14.2326 2.08301 10.5007Z"
      stroke="#141B34"
      stroke-width="1.25"
    />
    <path
      d="M13.333 13.8327C13.8464 13.8327 14.2626 13.4063 14.2626 12.8803V11.8462C14.2626 11.5936 14.3605 11.3513 14.5348 11.1728L14.8635 10.8361C15.0451 10.6501 15.0451 10.3486 14.8635 10.1626L14.5348 9.82593C14.3605 9.64735 14.2626 9.4051 14.2626 9.15252V8.1184C14.2626 7.59241 13.8464 7.16602 13.333 7.16602"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66666 13.8327C6.15326 13.8327 5.73706 13.4063 5.73706 12.8803V11.8462C5.73706 11.5936 5.63913 11.3513 5.4648 11.1728L5.13613 10.8361C4.95462 10.6501 4.95462 10.3486 5.13613 10.1626L5.4648 9.82593C5.63913 9.64735 5.73706 9.4051 5.73706 9.15252V8.1184C5.73706 7.59241 6.15326 7.16602 6.66666 7.16602"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 10.5H8.34051M11.6588 10.5H11.6663"
      stroke="#141B34"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const PauseProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M10.0003 18.8327C14.6027 18.8327 18.3337 15.1017 18.3337 10.4993C18.3337 5.89698 14.6027 2.16602 10.0003 2.16602C5.39795 2.16602 1.66699 5.89698 1.66699 10.4993C1.66699 15.1017 5.39795 18.8327 10.0003 18.8327Z"
      stroke="#141B34"
      stroke-width="1.25"
    />
    <path
      d="M7.91699 8V13M12.0837 8V13"
      stroke="#141B34"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DeleteProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M16.25 5.08398L15.7336 13.4382C15.6016 15.5727 15.5357 16.6399 15.0007 17.4072C14.7361 17.7866 14.3956 18.1067 14.0006 18.3473C13.2017 18.834 12.1325 18.834 9.99392 18.834C7.8526 18.834 6.78192 18.834 5.98254 18.3464C5.58733 18.1054 5.24667 17.7847 4.98223 17.4047C4.4474 16.6362 4.38287 15.5674 4.25384 13.43L3.75 5.08398"
      stroke="#EB001B"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M2.5 5.08268H17.5M13.3797 5.08268L12.8109 3.90912C12.433 3.12957 12.244 2.73978 11.9181 2.49669C11.8458 2.44277 11.7693 2.3948 11.6892 2.35327C11.3283 2.16602 10.8951 2.16602 10.0287 2.16602C9.14067 2.16602 8.69667 2.16602 8.32973 2.36112C8.24842 2.40436 8.17082 2.45427 8.09774 2.51032C7.76803 2.76327 7.58386 3.16731 7.21551 3.9754L6.71077 5.08268"
      stroke="#EB001B"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M7.91699 14.25V9.25"
      stroke="#EB001B"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M12.083 14.25V9.25"
      stroke="#EB001B"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

export const Support = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.332 7.86902C11.332 7.63855 11.332 7.52335 11.3667 7.42068C11.4675 7.12228 11.7332 7.00655 11.9994 6.88528C12.2987 6.74895 12.4483 6.68082 12.5966 6.66882C12.7649 6.6552 12.9335 6.69148 13.0774 6.77222C13.2681 6.87922 13.4011 7.08262 13.5373 7.24802C14.1662 8.01188 14.4806 8.39388 14.5957 8.81508C14.6886 9.15495 14.6886 9.51041 14.5957 9.85028C14.4279 10.4646 13.8977 10.9796 13.5052 11.4563C13.3045 11.7001 13.2041 11.822 13.0774 11.8931C12.9335 11.9739 12.7649 12.0101 12.5966 11.9965C12.4483 11.9845 12.2987 11.9164 11.9994 11.7801C11.7332 11.6588 11.4675 11.5431 11.3667 11.2447C11.332 11.142 11.332 11.0268 11.332 10.7963V7.86902Z"
      stroke="#F45C0C"
    />
    <path
      d="M4.66536 7.86906C4.66536 7.57893 4.65722 7.31813 4.42264 7.11413C4.33732 7.03993 4.2242 6.9884 3.99797 6.88533C3.6987 6.74906 3.54907 6.68093 3.4008 6.66893C2.95597 6.63293 2.71664 6.93653 2.46012 7.24813C1.8312 8.012 1.51674 8.39393 1.40167 8.81513C1.30882 9.15506 1.30882 9.51053 1.40167 9.8504C1.5695 10.4647 2.09971 10.9797 2.49217 11.4564C2.73956 11.7569 2.97588 12.031 3.4008 11.9967C3.54907 11.9847 3.6987 11.9165 3.99797 11.7802C4.2242 11.6771 4.33732 11.6256 4.42264 11.5514C4.65722 11.3474 4.66536 11.0867 4.66536 10.7965V7.86906Z"
      stroke="#F45C0C"
    />
    <path
      d="M13.3346 7.00065V6.00065C13.3346 3.42332 10.9468 1.33398 8.0013 1.33398C5.05578 1.33398 2.66797 3.42332 2.66797 6.00065V7.00065"
      stroke="#F45C0C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 11.666C13.3333 14.666 10.6667 14.666 8 14.666"
      stroke="#F45C0C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Meeting = (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M11.3333 10.6667V5.33333C11.3333 3.76199 11.3333 2.97631 10.8452 2.48815C10.357 2 9.57133 2 8 2H5.33333C3.76199 2 2.97631 2 2.48815 2.48815C2 2.97631 2 3.76199 2 5.33333V10.6667C2 12.238 2 13.0237 2.48815 13.5119C2.97631 14 3.76199 14 5.33333 14H8C9.57133 14 10.357 14 10.8452 13.5119C11.3333 13.0237 11.3333 12.238 11.3333 10.6667Z"
    stroke="#F45C0C"
  />
);

export const EmailIcon = (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M1.34254 8.98441C1.38613 11.0281 1.40791 12.0499 2.162 12.8069C2.91609 13.5639 3.96559 13.5902 6.06459 13.6429C7.35824 13.6755 8.63917 13.6755 9.93283 13.6429C12.0318 13.5902 13.0813 13.5639 13.8354 12.8069C14.5895 12.0499 14.6113 11.0281 14.6548 8.98441C14.6689 8.32727 14.6689 7.67401 14.6548 7.01694C14.6113 4.97322 14.5895 3.95138 13.8354 3.19443C13.0813 2.43747 12.0318 2.41111 9.93283 2.35837C8.63917 2.32586 7.35823 2.32586 6.06458 2.35836C3.96559 2.41109 2.91609 2.43746 2.162 3.19442C1.40791 3.95137 1.38612 4.97322 1.34254 7.01687C1.32853 7.674 1.32853 8.32727 1.34254 8.98441Z"
    stroke="#F45C0C"
    stroke-linejoin="round"
  />
);

export const SupportIcons = (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M3.27458 7.02753L5.03486 5.26725C5.39394 4.90818 5.51819 4.37761 5.37296 3.89101C5.2594 3.51051 5.13146 3.05309 5.04641 2.66195C4.96775 2.30018 4.6503 2 4.28008 2H3.27458C2.53414 2 1.92608 2.60256 2.0073 3.33853C2.62473 8.93307 7.06694 13.3753 12.6615 13.9927C13.3975 14.0739 14 13.4659 14 12.7254V11.7199C14 11.3497 13.6986 11.046 13.3343 10.9797C12.9325 10.9067 12.5074 10.7869 12.1517 10.6735C11.6407 10.5106 11.0727 10.6251 10.6935 11.0043L8.97247 12.7254"
    stroke="#F45C0C"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
);
